import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators, ValidatorFn } from '@angular/forms';
import { GlobalService } from '../services/global.service';
import { Router } from "@angular/router";
import Utils from '../../app/shared/utility';
import { SnackBarService } from '../../app/shared/snackbar/snackbar.service';
import { JsonPipe } from '@angular/common';
import { PIAComponent } from '../shared/modal/pia-calculator/pia-calculator.component';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../shared/loading/loading.service';
import { MessageComponent } from '../shared/modal/message/message.component';
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';
import { SubstantialEarningsComponent } from 'app/shared/modal/substantial-earning-years-calculator/substantial-earnings-calculator.component';

@Component({
  selector: 'app-new-illustration-ss-questionnaire',
  templateUrl: './new-illustration-ss-questionnaire.component.html',
  styleUrls: ['./new-illustration-ss-questionnaire.component.css']
})
export class NewIllustrationSsQuestionnaireComponent implements OnInit {
  client: any;
  clientSpouseFullName: string;

  public mmtModalData: any[];
  public mmtModalDataPass = [];

  magiBracketOneMin: number;
  magiBracketOneMax: number;
  magiBracketTwoMin: number;
  magiBracketTwoMax: number;
  magiBracketThreeMin: number;
  magiBracketThreeMax: number;
  magiBracketFourMin: number;
  magiBracketFourMax: number;
  magiBracketFiveMin: number;
  magiBracketFiveMax: number;
  magiBracketSixMin: number;
  magiBracketSixMax: string;
  isEditPercentMAGI: boolean = false;
  isMAGIUpdate: boolean = false;

  incomeForm: FormGroup;
  additinalIncomeForm: FormGroup;
  magiProjectionForm: FormGroup;
  metroAreaForm: FormGroup;
  additionalQuestionsForm: FormGroup;
  sixtyPlusForm: FormGroup;

  spouseIncomeForm: FormGroup;
  incomeEntryForm: FormGroup;
  applyQuestionnaireForm: FormGroup;
  applySpouseQuestionnaireForm: FormGroup;
  haveChildrenForm: FormGroup;
  haveSpouseChildrenForm: FormGroup;
  pensionForm: FormGroup;
  pensionSpouseForm: FormGroup;
  inRetEarningForm: FormGroup;
  inRetSpouseEarningForm: FormGroup;
  desiredClaimForm: FormGroup;
  desiredSpouseClaimForm: FormGroup;
  prevMarraigesForm: FormGroup;
  numberMarriagesForm: FormGroup;
  prevSpouseMarraigesForm: FormGroup;
  numberSpouseMarriagesForm: FormGroup;
  alreadyCollectedSSForm: FormGroup;
  alreadyCollectedSpouseSSForm: FormGroup;

  isApplyQuestionnaire: boolean;
  isApplyIncome: boolean;
  isSpouseApplyIncome: boolean;

  isIncomeEnter: boolean;
  isMAGIProjection: boolean;
  isAdditionalIncome: boolean;
  isAdditionalQuestion: boolean;

  //isDepChild: boolean = false;
  clientFirstName: string;
  spouseFirstName: string;
  isEnableUpdateButton: boolean = false;
  isChildren: boolean = false;
  isPension: boolean = false;
  isInRetEarning: boolean = false;
  isDesiredClaimAge: boolean = false;
  isPreviousMarriages: boolean = false;
  isExSpouse: boolean = false;
  isSpouse: boolean = false;
  isClient: boolean = false;
  isSpouseApplyQuestionnaire: boolean;
  isSpouseChildren: boolean = false;
  isSpousePension: boolean = false;
  isSpouseInRetEarning: boolean = false;
  isSpouseDesiredClaimAge: boolean = false;
  isAlreadyCollectSS: boolean = false;
  isSpouseAlreadyCollectSS: boolean = false;
  isSpousePreviousMarriages: boolean = false;
  isSpouseExSpouse: boolean = false;
  isOptionCurrentIncome: boolean = true;
  isEditAll: boolean = false;
  isSixtyPlus: boolean = false;
  isApplySixtyPlus: boolean = false;

  showClientKnownBenefit: boolean = false;
  showSpouseKnownBenefit: boolean = false;

  isClientAllowedRetroFiling: boolean = false;
  isSpouseAllowedRetroFiling: boolean = false;
  clientRetroClaimAge;
  clientRetroClaimYearMin;
  clientRetroClaimMonthMin;
  spouseRetroClaimAge;
  spouseRetroClaimYearMin;
  spouseRetroClaimMonthMin;

  valuePreviousMarriage: number = 0;
  valueSpousePreviousMarriage: number = 0;

  spouseProfileInfo: any;


  afterRetireWorkMinAge: number; 
  afterRetireWorkMinMaxDiff: number;
  afterRetireWorkSpouseMinAge: number;
  afterRetireWorkSpouseMinMaxDiff: number;
  clientMaxClaimAge: number = 70;
  clientMinClaimAge: number = 62;
  spouseMaxClaimAge: number = 70;
  spouseMinClaimAge: number = 62;
  clientMaxClaimMonth: number = 11;
  clientMinClaimMonth: number = 0;
  spouseMaxClaimMonth: number = 11;
  spouseMinClaimMonth: number = 0;
  params: any;
  //isIncomeSelection: boolean = false;
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1;
  yearClientTurnedSixty = 2000;
  dateOfClaimYearDiff = (this.currentYear - this.yearClientTurnedSixty) + 1;
  yearSpouseTurnedSixty = 2000;
  dateOfClaimYearSpouseDiff = (this.currentYear - this.yearSpouseTurnedSixty) + 1;
  yearMonths = Utils.months;
  isLegalMarried: boolean = false;
  couplePassesAwaySameYear: boolean = false;
  featAdditionalQuestions: boolean = false;

  maxAge = 100;
  minAge = 1;

  maxExSpouseClaimAge = 70;

  maxSpouseAge = 100;
  minSpouseAge = 1;
  defaultLifeExpectancy = 87;
  isClientSixtyPlusAtMarriage: boolean = false;
  isSpouseSixtyPlusAtMarriage: boolean = false;

  public dacAgeOptions: number[] = Array.from({ length: 100 }, (_, i) => i + 1);

  clientSEY: any[] = [];
  spouseSEY: any[] = [];
  maxMarriedDate: Date;
  minMarriedDate: Date;

  hasEarningDetailsOrDropdown = null;
  spouseHasEarningDetailsOrDropdown = null;
  isSurivivorAsSpouseDesiredAge: boolean = false;

  isMarried;//: boolean = false;
  spouseMaxIncome: string;

  isHCFilledBefore: boolean = false;
  isSSFilled: boolean = false;
  previousIncome: number;

  public inRetInflationRateMessage: string = "The annual rate at which household income is projected to grow in future retirement years.";
  public percentOfIncomeMAGIMessage: string = "The share of gross retirement income that is anticipated to fall under Modified Adjusted Gross Income (MAGI).";
  public householdIncomeYearOneMessage: string = "This amount is calculated based on the values to the left but may be overridden.";
  public currentHouseholdIncomeMessage: string = "This amount is pre-populated based on user inputs but may be overridden.";
  public currentGrossMonthlyBenefit: string = "Please enter the monthly benefit the client receives before taxes and Medicare withholdings.";
  public incomeInflationRateMessage: string = "The annual rate at which household income is projected to grow in future pre-retirement years.";
  public incomeReplacementRatioMessage: string = "The percentage of pre-retirement income that the household will require in retirement. For example, those earning $100,000 entering retirement age with an 80% IRR would need $80,000 per year to maintain their standard of living.";
  public substantialEarningMsg: string = "Social Security measures Substantial Earnings Years by the amount of money an individual earns in a calendar year on income that is taxed by Social Security. This metric is needed to calculate deductions made to the client’s Social Security benefit by the Windfall Elimination Provision. A chart with these measures for each year can be found at http://www.ssa.gov/pubs/EN-05-10045.pdf.";
  public midRetirementAdjustmentOptionalMessage: string = "Some retirees adjust their standard of living (upward or downward) during their retirement. To account for such a change to this retirement income projection, enter the information requested in the fields below.";
  public previousYearSSAMessage: string = "If taken from a previous year’s statement, add applicable recent COLAs to the amount: 2022 COLA: 8.7%; 2021 COLA: 5.9%; 2020 COLA: 1.3%; 2019 COLA: 1.6%; 2018 COLA: 2.8%."
  public expectedClaimAgeMessage: string = "Former spouse’s claim age may impact survivor benefits.";// Unsure of the anticipated claim age? The ex-spouse’s Full Retirement Age (FRA) is defaulted as the input.";

  constructor(private matDialog: MatDialog, public globalService: GlobalService, public router: Router, private snackBarService: SnackBarService,public dialog: MatDialog, private loadingService: LoadingService) {
    //console.log('this.params', this.router.getCurrentNavigation());
    this.globalService.featQuickReports = JSON.parse(localStorage.getItem('featQuickReports'));
    this.params = (this.router.getCurrentNavigation().extras.state) ? this.router.getCurrentNavigation().extras.state.params : '';
    this.featAdditionalQuestions = localStorage.getItem('featAdditionalQuestions') == 'true' ? true: false;
    console.log('this.params', this.params);
    this.isApplyIncome = this.isClient = true;
    this.resetFormBooleanValue();
    
    if (this.params == 'income') {
      this.loadingService.isLoading(true);
      this.isEnableUpdateButton = true;
      this.isApplyIncome = false;
      this.isClient = false;
      this.isIncomeEnter = true;
      //this.isIncomeSelection = true;
    } else if (this.params == 'editAll') {
      this.isEditAll = true;
    } else if (this.params =='additionalQuestions'){
      this.isEnableUpdateButton = true;
      this.isAdditionalQuestion = true;
      this.isApplyIncome = false;
      this.isClient = false;
    } else {
      if (this.params == 'editAll' || this.params == 'emptyAll' || this.params == '') {
        this.isEditAll = true;
      }
    }
    const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
    //cant be older than max
    parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
    //cant be younger than min
    || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
    ? {invalidDate: '' }  
    : null;

    this.incomeForm = new FormGroup({
      currentIncome: new FormControl('', [Validators.required, Validators.max(5000000)]),
      pia: new FormControl('', [validateBenefits(0, 4250), Validators.required]),
      yearOfStatement: new FormControl(this.currentYear, [Validators.required, Validators.min(this.currentYear - 5), Validators.max(this.currentYear)]),
      isCollectingBenefits: new FormControl(false),
      monthlyBenefits: new FormControl(''),
      //need to dynamically add/remove validation 
      knownBenefitClaiming: new FormControl('', [validateBenefits(0, 4800)]),

      dateOfClaimMonth: new FormControl('', [Validators.min(1), Validators.max(12)]),
      dateOfClaimYear: new FormControl('', [Validators.min(2000), Validators.max(this.currentYear)])

    });

    this.sixtyPlusForm = new FormGroup({
      dateOfMarriage: new FormControl('', [Validators.required])
    })

    this.additinalIncomeForm = new FormGroup(
      {
        InRetInflationRate:  new FormControl('2.4%', [Validators.required, Validators.min(-5), Validators.max(10)]),
        MAGIPerc: new FormControl('100%', [Validators.required, Validators.min(0), Validators.max(100)]),
        RetAdjYear: new FormControl(),
        RetAdjReductionDollar: new FormControl(),
        RetAdjReductionPerc: new FormControl(),
        RetAdjReductionInflation: new FormControl(),
        setYearAfterSpouseLE: new FormControl()
      }
    );

    this.magiProjectionForm = new FormGroup(
      {
        mmtModalDataItems: new FormArray([])
      }
    );

    this.additionalQuestionsForm = new FormGroup( {
      Firm: new FormControl(),
      Wholesaler: new FormControl(),
      RepName: new FormControl(),
      PlanSponsor: new FormControl(),
      SendReportTo: new FormControl(),
      MeetingReference: new FormControl(),
      ReportRequestFrom: new FormControl()
    });

    this.spouseIncomeForm = new FormGroup({
      currentIncome: new FormControl('', [Validators.required]),
      pia: new FormControl('', [validateBenefits(0, 4250), Validators.required]),
      yearOfStatement: new FormControl(this.currentYear, [Validators.required, Validators.min(this.currentYear - 5), Validators.max(this.currentYear)]),
      isCollectingBenefits: new FormControl(false),
      monthlyBenefits: new FormControl(''),
      //need to dynamically add/remove validation 
      knownBenefitClaiming: new FormControl('', [validateBenefits(0, 4800)]),

      dateOfClaimMonth: new FormControl('', [Validators.min(1), Validators.max(12)]),
      dateOfClaimYear: new FormControl('', [Validators.min(2000), Validators.max(this.currentYear)])
    });

    this.incomeEntryForm = new FormGroup({
      HouseHoldIncome: new FormControl('', [Validators.max(5000000)]),
      IncomeInflationRate: new FormControl('3.00%', [Validators.required, Validators.min(0), Validators.max(10)]),
      IncomeReplacementRatio: new FormControl("75%", [Validators.required, Validators.min(50), Validators.max(200)]),//min 50 - max 200
      YearOneRetirementIncome: new FormControl(),
    });

    this.applyQuestionnaireForm = new FormGroup({
      haveNonDisabledChild: new FormControl(false),
      haveDisabledChild: new FormControl(false),
      haveDepChild: new FormControl(false),
      havePension: new FormControl(false),
      partTimeWork: new FormControl(false),
      desiredClaimAge: new FormControl(false),
      alreadySSCollected: new FormControl(false),
      previouslyMarried: new FormControl(false),
    });
    this.applySpouseQuestionnaireForm = new FormGroup({
      haveNonDisabledChild: new FormControl(false),
      haveDisabledChild: new FormControl(false),
      haveDepChild: new FormControl(false),
      havePension: new FormControl(false),
      partTimeWork: new FormControl(false),
      desiredClaimAge: new FormControl(false),
      alreadySSCollected: new FormControl(false),
      previouslyMarried: new FormControl(false),
    });
    this.haveChildrenForm = new FormGroup({
      haveNonDisabledChild: new FormControl(false),
      numberOfChild: new FormControl(''),
      childsAges: new FormArray([]),
      haveDisabledChild: new FormControl(false),
      dacCurrentAge: new FormControl(''),
      dacAnticipateEnd: new FormControl('false'),
      dacEndAge: new FormControl('')
    });
    this.haveSpouseChildrenForm = new FormGroup({
      haveNonDisabledChild: new FormControl(false),
      numberOfChild: new FormControl(''),
      childsAges: new FormArray([]),
      haveDisabledChild: new FormControl(false),
      dacCurrentAge: new FormControl(''),
      dacAnticipateEnd: new FormControl('false'),
      dacEndAge: new FormControl('')
    });
    this.pensionForm = new FormGroup({
      annualPensionValue: new FormControl(1, [Validators.required]),
      monthlyPensionValue: new FormControl(1, [Validators.required]),
      pensionInflationRate: new FormControl('3.00%', [Validators.required, Validators.min(0), Validators.max(10)]),
      pensionStartMonth: new FormControl('', [Validators.required, Validators.min(1), Validators.max(12)]),
      pensionStartYear: new FormControl('', [Validators.required, Validators.min(1900), Validators.max(2100)]),
      substantialEarningYear: new FormControl(null)
    });
    this.pensionSpouseForm = new FormGroup({
      annualPensionValue: new FormControl(1, [Validators.required]),
      monthlyPensionValue: new FormControl(1, [Validators.required]),
      pensionInflationRate: new FormControl('3.00%', [Validators.required, Validators.min(0), Validators.max(10)]),
      pensionStartMonth: new FormControl('', [Validators.required, Validators.min(1), Validators.max(12)]),
      pensionStartYear: new FormControl('', [Validators.required, Validators.min(1900), Validators.max(2100)]),
      substantialEarningYear: new FormControl(null)
    });
    this.inRetEarningForm = new FormGroup({
      firstYearRet: new FormControl('', [Validators.required, validateBenefits(1, 1000000)]),//Validators.min(1), Validators.max(1000000)]),
      stopWorkAge: new FormControl('', [Validators.required]),
    });
    this.inRetSpouseEarningForm = new FormGroup({
      firstYearRet: new FormControl('', [Validators.required,  validateBenefits(1, 1000000)]),//Validators.min(1), Validators.max(1000000)]),
      stopWorkAge: new FormControl('', [Validators.required, Validators.min(0), Validators.max(100)]),
    });
    this.desiredClaimForm = new FormGroup({
      ageYears: new FormControl(null, [Validators.required, Validators.min(62), Validators.max(70)]),
      ageMonths: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(11)])
    });
    this.desiredSpouseClaimForm = new FormGroup({
      ageYears: new FormControl(null, [Validators.required, Validators.min(62), Validators.max(70)]),
      ageMonths: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(11)])
    });
    this.prevMarraigesForm = new FormGroup({
      marraigeTimes: new FormControl('', [Validators.required])
    });
    this.numberMarriagesForm = new FormGroup({
      numberMarriages: new FormArray([])
    });
    this.prevSpouseMarraigesForm = new FormGroup({
      marraigeTimes: new FormControl('', [Validators.required])
    });
    this.numberSpouseMarriagesForm = new FormGroup({
      numberMarriages: new FormArray([])
    });
    this.alreadyCollectedSSForm = new FormGroup({
      monthlyBenefitAmount: new FormControl('', [Validators.required, Validators.min(1900), Validators.max(2100)])
    });
    this.alreadyCollectedSpouseSSForm = new FormGroup({
      monthlyBenefitAmount: new FormControl('', [Validators.required, Validators.min(1900), Validators.max(2100)])
    });

  }

  ngOnInit() {
    //this.resetFormBooleanValue();
    //this.isApplyQuestionnaire = this.isClient = true;
    //this.isApplyIncome = this.isClient = true;
    localStorage.removeItem('clientProfile');
    localStorage.removeItem('userModel');
    this.getClient();
  }

  get numberMarraiges() {
    return this.numberMarriagesForm.controls["numberMarriages"] as FormArray;
  }

  get numberSpouseMarraiges() {
    return this.numberSpouseMarriagesForm.controls["numberMarriages"] as FormArray;
  }

  get childsAge() {
    return this.haveChildrenForm.controls["childsAges"] as FormArray;
  }

  get spouseChildsAge() {
    return this.haveSpouseChildrenForm.controls["childsAges"] as FormArray;
  }

  updateValue(i, newValue) {
    console.log('i', i);
    console.log('newValue', newValue);
    console.log('this.mmtModalData01', this.mmtModalData);
    this.isMAGIUpdate = true;
    newValue = Utils.removeCurrencyFormatting(newValue);
    newValue = newValue == 0 ? '': newValue;
    this.mmtModalData[i].percentMAGI = this.formatCurrency(newValue, '');
    //this.mmtModalData[i].updatedBracket = this.bracketAssign(newValue);
    (<FormArray>(<FormArray>this.magiProjectionForm.controls['mmtModalDataItems']).controls[i]).controls['percentMAGI'].patchValue(this.mmtModalData[i].percentMAGI);
    (<FormArray>(<FormArray>this.magiProjectionForm.controls['mmtModalDataItems']).controls[i]).controls['updatedBracket'].patchValue(this.mmtModalData[i].updatedBracket);
    console.log('this.mmtModalData02', this.mmtModalData);
  }

  reformatColumn(i, newValue){
    //console.log('newValue', newValue);
    this.mmtModalData[i].updatedBracket = this.bracketAssign(Utils.removeCurrencyFormatting(newValue));
    (<FormArray>(<FormArray>this.magiProjectionForm.controls['mmtModalDataItems']).controls[i]).controls['percentMAGI'].patchValue(this.mmtModalData[i].percentMAGI);
    (<FormArray>(<FormArray>this.magiProjectionForm.controls['mmtModalDataItems']).controls[i]).controls['updatedBracket'].patchValue(this.mmtModalData[i].updatedBracket);
  }

  populateForm() {
    const control = <FormArray>this.magiProjectionForm.controls['mmtModalDataItems'];
    var counter = Number(control.length);
    // reset the control before pushing the new value
    for (var i=0; i< counter; i++) {
      control.removeAt(0)
    }
    this.mmtModalData.forEach(item => {
      control.push(this.initItems(item))
    })
  }

  initItems(item) {
    // create a formgroup for each item
    return new FormGroup({
      year: new FormControl([item.year]), // set required or whatever else
      age: new FormControl([item.age]),
      fullMAGI: new FormControl([item.fullMAGI]),
      percentMAGI: new FormControl([item.percentMAGI]),
      updatedBracket: new FormControl([item.updatedBracket]),
    })
  }

  bracketAssign(percentMAGI) {
    let bracketValue;
    if (percentMAGI >= this.magiBracketOneMin && percentMAGI <= this.magiBracketOneMax) {
      bracketValue = 1;
    }
    if (percentMAGI >= this.magiBracketTwoMin && percentMAGI <= this.magiBracketTwoMax) {
      bracketValue = 2;
    }
    if (percentMAGI >= this.magiBracketThreeMin && percentMAGI <= this.magiBracketThreeMax) {
      bracketValue = 3;
    }
    if (percentMAGI >= this.magiBracketFourMin && percentMAGI <= this.magiBracketFourMax) {
      bracketValue = 4;
    }
    if (percentMAGI >= this.magiBracketFiveMin && percentMAGI <= this.magiBracketFiveMax) {
      bracketValue = 5;
    }
    if (percentMAGI >= this.magiBracketSixMin && percentMAGI <= this.magiBracketSixMax) {
      bracketValue = 6;
    }
    return bracketValue;


  }

  public hasSubEarningYearsDetails: boolean = false;
  public spouseHasSubEarningYearsDetails: boolean = false;
  getClient() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
        .subscribe(
            client => {
                this.client = client;
                this.previousIncome = this.client.clientProfile.CurrentIncome + (this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].currentIncome : 0);
                this.isHCFilledBefore = this.client.clientProfile.PremiumType ? true: false;
                this.isSSFilled = this.client.clientProfile.MonthlyBenefitAmount || this.client.clientProfile.PIA || this.client.clientProfile.SelfKnownBenefitClaiming ? true : false;
                console.log('this.client',this.client);
                this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
                if(this.globalService.calculateAgeV2(this.client.client.DOB) >= 60) {
                  console.log('here i am 01')
                  //when did client turn 60
                  this.yearClientTurnedSixty = this.currentYear - (this.globalService.calculateAgeV2(this.client.client.DOB) - 60);
                  //cap it at year 2000
                  this.dateOfClaimYearDiff = (this.yearClientTurnedSixty < 2000) ? 2000 : (this.currentYear - this.yearClientTurnedSixty) + 1;
                  console.log('this.params',this.params)
                  console.log('this.client.clientProfile.Spouses[0].maritalStatus', this.client.clientProfile.Spouses[0].maritalStatus )
                  if (this.params != 'empty' && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                    console.log('here i am 02');
                    this.isSixtyPlus = this.isApplySixtyPlus =  true;
                    this.isApplyIncome = false;
                  }
            
                }

                if (this.client.clientProfile.Spouses) {
                  if(this.client.clientProfile.IsLegalSpouse == 1) {
                    let clientDOB = new Date(this.client.client.DOB);
                    clientDOB.setFullYear(clientDOB.getFullYear() + 18);
                    let spouseDOB = new Date(this.client.clientProfile.Spouses[0].dob);
                    spouseDOB.setFullYear(spouseDOB.getFullYear() + 18);
                    this.minMarriedDate = spouseDOB > clientDOB ? spouseDOB : clientDOB;
                    this.maxMarriedDate = new Date();
                  }

                  if(this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) >= 60) {
                    //when did client turn 60
                    this.yearSpouseTurnedSixty = this.currentYear - (this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) - 60);
                    //cap it at year 2000
                    this.dateOfClaimYearSpouseDiff = (this.yearSpouseTurnedSixty < 2000) ? 2000 : (this.currentYear - this.yearSpouseTurnedSixty) + 1;
                    if (this.params != 'empty' && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                      console.log('here i am 01');
                      this.isSixtyPlus = this.isApplySixtyPlus =  true;
                      this.isApplyIncome = false;
                    }
                  }
                }

                const isSpouseSurvivor = ((this.client.clientProfile.LifeExpectancy - this.globalService.calculateAgeV2(this.client.client.DOB)) + this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) <= 60 || (this.client.clientProfile.LifeExpectancy - this.globalService.calculateAgeV2(this.client.client.DOB)) + this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) <= 69);

                if (!isSpouseSurvivor && this.client.clientProfile.InvertSurvivorSwitch && this.client.clientProfile.SurvivorSwitchYears && (!this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SSDesiredAgeYears == null)) {
                  this.client.clientProfile.SSDesiredAgeYears = this.client.clientProfile.SurvivorSwitchYears;
                  this.client.clientProfile.SSDesiredAgeMonths = this.client.clientProfile.SurvivorSwitchMonths;
                  this.client.clientProfile.SurvivorSwitchYears = 0;
                  this.client.clientProfile.SurvivorSwitchMonths = 0;
                  this.client.clientProfile.InvertSurvivorSwitch = false;
                }

                if (this.client.clientProfile.Spouses && isSpouseSurvivor) {
                  if (this.client.clientProfile.InvertSurvivorSwitch && this.client.clientProfile.SurvivorSwitchYears && (!this.client.clientProfile.Spouses[0].sSDesiredAgeYears || this.client.clientProfile.Spouses[0].sSDesiredAgeYears == null)) {
                    this.client.clientProfile.Spouses[0].sSDesiredAgeYears = this.client.clientProfile.SurvivorSwitchYears;
                    this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = this.client.clientProfile.SurvivorSwitchMonths;
                  }
                }
                
                this.isLegalMarried = (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].isLegalSpouse == 1 &&  this.client.clientProfile.Spouses[0].maritalStatus == 'Married') ? true: false;
                console.log('this.isSixtyPlus', this.isSixtyPlus);                            
                this.couplePassesAwaySameYear = (this.isLegalMarried) && (((this.client.clientProfile.Spouses[0].LifeExpectancy - this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob)) + new Date().getFullYear()) == ((this.client.clientProfile.LifeExpectancy - this.globalService.calculateAgeV2(this.client.client.DOB) + new Date().getFullYear()))) ? true : false;
                let clientAge = this.globalService.calculateAgeV2(this.client.client.DOB);
                // if (clientAge >= 62) {
                //   this.isAlreadyCollectSS = true;
                // } else {
                //   this.isAlreadyCollectSS = false;
                // }
                let spouseAge = client.clientProfile.Spouses[0] ? this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob): 0;
                // if (spouseAge >= 62) {
                //   this.isSpouseAlreadyCollectSS = true;
                // } else {
                //   this.isSpouseAlreadyCollectSS = false;
                // }
                this.clientFirstName = client.client.FirstName;


                this.clientSpouseFullName = client.clientProfile && client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ?
                (client.client.LastName == client.clientProfile.Spouses[0].lastName) ? 
                      client.client.FirstName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.client.LastName :
                      client.client.FirstName + ' ' + client.client.LastName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName
                      : client.client.FirstName + ' ' + client.client.LastName;

                this.spouseFirstName = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName ? this.client.clientProfile.Spouses[0].firstName: '';
                let clientProfileInfo = {
                  Gender: this.client.client.GenderID,
                  Age: this.globalService.calculateAgeV2(this.client.client.DOB),
                  HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
                  HCHC: this.client.clientProfile.HCHC ? 1 : 0,
                  HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
                  HCCD: this.client.clientProfile.HCCD ? 1 : 0,
                  HCC: this.client.clientProfile.HCC ? 1 : 0,
                  HCT: this.client.clientProfile.HCT ? 1 : 0,
                  HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
                  HCMS: this.client.clientProfile.HCMS ? 1 : 0,
                  HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
                  HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,

                  HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
                  HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
                  HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
                  HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
                  HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,

                  HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag ? 1 : 0,
                  HCCYrsDiag: this.client.clientProfile.HCCYrsDiag ? 1 : 0
                };

                //HACK:
                this.client.clientProfile.HCCDYrsDiag = this.client.clientProfile.HCCDYrsDiag ? 1 : 0;
                this.client.clientProfile.HCCYrsDiag = this.client.clientProfile.HCCYrsDiag ? 1 : 0;

                if (this.client.clientProfile.YearOfStatement) {
                  this.incomeForm.controls['yearOfStatement'].patchValue(this.client.clientProfile.YearOfStatement)
                  this.incomeForm.controls['yearOfStatement'].updateValueAndValidity();
                }
                //this.calculateLifeExp(clientProfileInfo, 'client');
                this.setInRetWorkEarning('client');
                this.clientMinClaimAge = client.clientProfile.Spouses[0].maritalStatus != 'Widowed' ? (clientAge > 62 ? clientAge : 62): (clientAge > 60 ? clientAge : 60);
                this.clientMaxClaimAge = this.client.clientProfile.LifeExpectancy >= 70 ? 70 : this.client.clientProfile.LifeExpectancy;
                this.desiredClaimForm.get("ageYears").setValidators([Validators.required, Validators.min(this.clientMinClaimAge),Validators.max(this.clientMaxClaimAge)]);
                this.desiredClaimForm.controls['ageYears'].updateValueAndValidity();

                let isSpouse = this.client.clientProfile.Spouses[0] ? true : false;
                if (isSpouse) {

                  this.spouseProfileInfo = {
                    Gender: 1, //this.client.clientProfile.Spouses[0].gender,
                    Age: this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob),
                    // RetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
                    HCHBP: this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0,
                    HCHC: this.client.clientProfile.Spouses[0].HCHC ? 1 : 0,
                    HCT2D: this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0,
                    HCCD: this.client.clientProfile.Spouses[0].HCCD ? 1 : 0,
                    HCC: this.client.clientProfile.Spouses[0].HCC ? 1 : 0,
                    HCT: this.client.clientProfile.Spouses[0].HCT ? 1 : 0,
                    HCT1D: this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0,
                    HCMS: this.client.clientProfile.Spouses[0].HCMS ? 1 : 0,
                    HCDCW: this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0,
                    HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0,

                    HCALZ: this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0,
                    HCPARK: this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0,
                    HCAMP: this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0,
                    HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0,
                    HCOBS: this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0,

                    HCCDYrsDiag: this.client.clientProfile.Spouses[0].HCCDYrsDiag ? 1 : 0,
                    HCCYrsDiag: this.client.clientProfile.Spouses[0].HCCYrsDiag ? 1 : 0
                  };

                  //HACK:
                  this.client.clientProfile.Spouses[0].HCCDYrsDiag = this.client.clientProfile.Spouses[0].HCCDYrsDiag ? 1 : 0;
                  this.client.clientProfile.Spouses[0].HCCYrsDiag = this.client.clientProfile.Spouses[0].HCCYrsDiag ? 1 : 0;

                  //this.calculateLifeExp(this.spouseProfileInfo, 'spouse');
                  this.setInRetWorkEarning('spouse');
                  this.spouseMaxClaimAge = this.client.clientProfile.Spouses[0].LifeExpectancy >= 70 ? 70 : this.client.clientProfile.Spouses[0].LifeExpectancy;
                  this.spouseMinClaimAge = spouseAge > 62 ? spouseAge : 62;
                  let clientRemainingYear = this.client.clientProfile.LifeExpectancy - clientAge;
                  let spouseRemainingYear = this.client.clientProfile.Spouses[0].LifeExpectancy - spouseAge;
                  this.spouseMinClaimAge = (spouseRemainingYear > clientRemainingYear && spouseAge + clientRemainingYear < 62) ? (spouseAge + clientRemainingYear > 60 ? spouseAge + clientRemainingYear: 60) : this.spouseMinClaimAge;
                  if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                    this.clientMinClaimAge = (clientRemainingYear > spouseRemainingYear && clientAge + spouseRemainingYear < 62) ? (clientAge + spouseRemainingYear > 60 ? clientAge + spouseRemainingYear: 60) : this.clientMinClaimAge;
                    this.desiredClaimForm.get("ageYears").setValidators([Validators.required, Validators.min(this.clientMinClaimAge),Validators.max(this.clientMaxClaimAge)]);
                    this.desiredClaimForm.controls['ageYears'].updateValueAndValidity();
                  }

                  // if ((this.client.clientProfile.Spouses[0].LifeExpectancy - spouseAge > clientRemainingYear) &&  (spouseAge + clientRemainingYear < 62)){
                  //   if (spouseAge + clientRemainingYear < 62) {
                  //     this.spouseMinClaimAge = spouseAge + clientRemainingYear > 60 ? spouseAge + clientRemainingYear: 60;
                  //   }
                  // }
                  this.desiredSpouseClaimForm.get("ageYears").setValidators([Validators.required, Validators.min(this.spouseMinClaimAge),Validators.max(this.spouseMaxClaimAge)]);
                  this.desiredSpouseClaimForm.controls['ageYears'].updateValueAndValidity();

                  this.spouseMinClaimMonth = spouseAge > 62 && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) == spouseAge ? ((new Date().getMonth() + 1) - this.getDOBMonth(this.client.clientProfile.Spouses[0].dob)) : 0;
                  this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.spouseMinClaimMonth),Validators.max(this.spouseMaxClaimMonth)]);
                  this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
                  //this.spouseMaxClaimMonth = spouseAge > 62 ? 0 : 0;

                  if (this.client.clientProfile.Spouses[0].yearOfStatement && this.client.clientProfile.Spouses[0].maritalStatus == 'Married')
                    this.spouseIncomeForm.controls['yearOfStatement'].patchValue(this.client.clientProfile.Spouses[0].yearOfStatement);
                    this.spouseIncomeForm.controls['yearOfStatement'].updateValueAndValidity();

                  // if(this.client.clientProfile.Spouses[0].LifeExpectancy) {
                  //   localStorage.setItem('spouseLifeExpectancy', this.client.clientProfile.Spouses[0].LifeExpectancy);
                  // }
                }

                /* if (this.params == 'socialSecurity' || this.params == 'editAll' || this.params == '') {
                  this.mappingToSS((this.params == 'editAll' || this.params == ''));
                } else if (this.params == 'income') {
                  this.mappingToIncome();                  
                } else if (this.params == 'additionalQuestions'){
                  this.mappingToAdditionalQuestions();
                } */

                this.isOptionCurrentIncome = this.client.clientProfile.HouseholdYearOneIncome ? ((this.client.clientProfile.HouseholdYearOneIncome > 0) ? false : true) : true;
                
                this.mappingToSS(true);

                let seyJson = JSON.parse(this.client.clientProfile.PIAYears)
                if (seyJson) {
                  this.piaCalcData = seyJson;
                }
                
                if (seyJson && !seyJson.staticValue) {
                  const seyTable = seyJson.seyTable || []
                  this.clientSEY = []
                  for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.client.DOB)); i >= 62; i--) {
                    this.clientSEY.push({ age: i, total: seyTable.length - (seyTable.filter(y => {
                      if (y.age >= i)
                        return y
                    }).length) })
                  }
        
                  this.clientSEY.reverse()
                  this.hasEarningDetailsOrDropdown = false;
                  this.hasSubEarningYearsDetails = true;
                  // this.pensionForm.get('substantialEarningYear').setValidators([]);
                  // this.pensionForm.controls['substantialEarningYear'].updateValueAndValidity()
                  // this.pensionForm.get('substantialEarningYear').patchValue('')
                } else {
                  this.hasEarningDetailsOrDropdown = true;

                  if (seyJson && seyJson.seyTable) {
                    if (seyJson && !seyJson.seyTable.length)
                      this.hasSubEarningYearsDetails = false;
                    else
                      this.hasSubEarningYearsDetails = true;

                    // this.pensionForm.get('substantialEarningYear').patchValue(seyJson ? seyJson.substantialEarningYears : 0)
                  }

                  // this.pensionForm.get('substantialEarningYear').setValidators([Validators.required]);
                  // this.pensionForm.controls['substantialEarningYear'].updateValueAndValidity()
                  this.toggleSEYSelection(false)
                }
                
                if (isSpouse) {
                  let seySpouse = this.client.clientProfile.Spouses[0].PIAYears
                  if (seySpouse) {
                    this.spousePIACalcData = typeof seySpouse === 'string' ? JSON.parse(seySpouse) : seySpouse;
                  }

                  if (seySpouse && !seySpouse.staticValue) {
                    const seyTable = seySpouse.seyTable || []
                    this.spouseSEY = [];
                    if (this.client.clientProfile.Spouses[0].dob) {
                      for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.clientProfile.Spouses[0].dob)); i >= 62; i--) {
                        this.spouseSEY.push({ age: i, total: seyTable.length - (seyTable.filter(y => {
                          if (y.age >= i)
                            return y
                        }).length) })
                      }
                    }
          
                    this.spouseSEY.reverse()
                    this.spouseHasEarningDetailsOrDropdown = false;
                    this.spouseHasSubEarningYearsDetails = true;
                    // this.pensionSpouseForm.get('substantialEarningYear').setValidators([]);
                    // this.pensionSpouseForm.controls['substantialEarningYear'].updateValueAndValidity()
                    // this.pensionSpouseForm.get('substantialEarningYear').patchValue('')
                  } else {
                    this.spouseHasEarningDetailsOrDropdown = true;

                    if (seySpouse && seySpouse.seyTable && !seySpouse.seyTable.length)
                      this.spouseHasSubEarningYearsDetails = false;
                    else
                      this.spouseHasSubEarningYearsDetails = true;

                    // this.pensionSpouseForm.get('substantialEarningYear').patchValue(seySpouse ? seySpouse.substantialEarningYears : 0)
                    // this.pensionSpouseForm.get('substantialEarningYear').setValidators([Validators.required]);
                    // this.pensionSpouseForm.controls['substantialEarningYear'].updateValueAndValidity();
                    this.toggleSpouseSEYSelection(false)
                  }
                }
                // localStorage.setItem('clientLifeExpectancy', this.client.clientProfile.LifeExpectancy);
                this.loadingService.isLoading(false);
            },
            error => console.log(error));
  }

  getMMTBracket() {
    let includePartner = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
    var currentYear = new Date().getFullYear();
    // let clientRetirementYear = Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
    // let spouseRetirementYear = includePartner ? Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)): null;
    // let bracketYear = includePartner ? (spouseRetirementYear < clientRetirementYear ? spouseRetirementYear: clientRetirementYear) : clientRetirementYear;
    let bracketYear = currentYear;
    console.log('bracketYear', bracketYear);
    this.globalService.getMMTBracket(includePartner, bracketYear)
            .subscribe(
                data => {
                  this.magiBracketOneMin = data.Bracket1 ? data.Bracket1: 0;
                  this.magiBracketOneMax = data.Bracket2 ? data.Bracket2 - 1 : 0;

                  this.magiBracketTwoMin = data.Bracket2 ? data.Bracket2 : 0;
                  this.magiBracketTwoMax = data.Bracket3 ? data.Bracket3 - 1 : 0;

                  this.magiBracketThreeMin = data.Bracket3 ? data.Bracket3 : 0;
                  this.magiBracketThreeMax = data.Bracket4 ? data.Bracket4 - 1 : 0;

                  this.magiBracketFourMin = data.Bracket4 ? data.Bracket4 : 0;
                  this.magiBracketFourMax = data.Bracket5 ? data.Bracket5 - 1 : 0;

                  this.magiBracketFiveMin = data.Bracket5 ? data.Bracket5 : 0;
                  this.magiBracketFiveMax = data.Bracket6 ? data.Bracket6 - 1 : 0;

                  this.magiBracketSixMin = data.Bracket6 ? data.Bracket6 : 0;
                  this.magiBracketSixMax= 'more';
                  //this.insertDataToHCQuestionnaire();
                  this.getMMTData(); 
 
                },
                error => console.log(error));
  }

  public startingIllustration: any[];
  public ssClientAge: string = '65';
  public ssSpouseAge: string = '65';
  public magi: number = 100;
  getMMTData() {
    if (this.params == 'income' || this.params == 'editAll') {
      let magiProjs =  JSON.parse(this.client.magiProjs) || [];
      var mapMMTModalData = [];
      magiProjs = magiProjs.sort((a,b)=> a.Year - b.Year);
      mapMMTModalData = magiProjs.map((entry, idx) => {
        let updatedEntry = {
            year: entry.Year,
            age: entry.Age,
            fullMAGI: entry.Income,
            percentMAGI: entry.MAGI,
            updatedBracket:  entry.Bracket
        }
  
        return updatedEntry;
     
      });
      console.log('mapMMTModalData', mapMMTModalData);
    }
        
    var tempReportVals = {
        InflationRate: (this.incomeEntryForm.value.IncomeInflationRate) ? Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate) : 0.03,
        MagiIncomePercent: (this.additinalIncomeForm.value.MAGIPerc) ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.MAGIPerc) : 100,
        IncludePartner: this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married',
        SocialSecurityRetirementAge: this.ssClientAge,
        SSMonthlyBenefit: Utils.removeCurrencyFormatting(this.incomeForm.value.pia),//this.client.clientProfile.PIA,
        PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.pia) : 0, 
        //this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? Number(this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "")) || 0 : this.client.clientProfile.Spouses[0] ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
        PartnerSocialSecurityAge: this.ssSpouseAge
    }

    var user = {
        UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
        CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
        ClientID: localStorage.getItem('selectedClient')
    }
    if (!this.client.clientProfile.IRR && this.incomeEntryForm.value.IncomeReplacementRatio) {
      this.client.clientProfile.IRR = Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio);
    }
    if (!this.client.clientProfile.CurrentIncome && this.incomeEntryForm.value.HouseHoldIncome) {
      this.client.clientProfile.CurrentIncome = Utils.removeCurrencyFormatting(this.incomeEntryForm.value.HouseHoldIncome);
    }
    let client = this.client;
    if (!this.incomeEntryForm.value.IncomeInflationRate) {
      client.clientProfile.InflationRate = null;
    }
    if (!this.incomeEntryForm.value.IncomeReplacementRatio) {
      client.clientProfile.IRR = null;
    }

    this.globalService.getMMTData(client, tempReportVals, user)
        .subscribe(
            data => {
              //console.log('here02 i am mmtData');
              console.log('data', data);
              console.log('what params:', this.params);
              
              this.startingIllustration = data.IllustrationEntries;

              this.mmtModalData = data.IllustrationEntries.map((entry, idx) => {
                if (entry.ClientAge >= data.Client.RetirementAge || (entry.PartnerAge && entry.PartnerAge >= data.Partner.RetirementAge)) {
                      // this.mmtData = data;

                      entry.ClientAge = entry.ClientAge < this.client.clientProfile.RetirementAge ? '--' : entry.ClientAge;

                      if (entry.PartnerAge)
                          entry.PartnerAge = entry.PartnerAge < this.client.clientProfile.Spouses[0].retirementAge ? '--' : entry.PartnerAge;
                      // console.log('year', entry.Year);
                      let fullMAGI;
                      let percentMAGI = entry.MagiAdjustedHouseholdIncome;
                      let updatedBracket;
                      if ((this.params == 'income' || this.params == 'editAll') && mapMMTModalData.length > 0) {
                        fullMAGI = mapMMTModalData.find(x => x.year == entry.Year) ? mapMMTModalData.find(x => x.year == entry.Year).fullMAGI : entry.HouseholdIncome;
                        percentMAGI = mapMMTModalData.find(x => x.year == entry.Year) ? mapMMTModalData.find(x => x.year == entry.Year).percentMAGI : entry.MagiAdjustedHouseholdIncome;
                        updatedBracket = mapMMTModalData.find(x => x.year == entry.Year) ? mapMMTModalData.find(x => x.year == entry.Year).updatedBracket.toLocaleString() : entry.MagiAdjustedIncomeBracket.toLocaleString();
                      } else {
                        fullMAGI = entry.HouseholdIncome;
                        percentMAGI = entry.MagiAdjustedHouseholdIncome;
                        updatedBracket = entry.MagiAdjustedIncomeBracket.toLocaleString();
                      }

                      //console.log('check fullMAGI', fullMAGI);

                      let updatedEntry = {
                          year: entry.PartnerAge ? `${entry.Year}` : `${entry.Year}`,
                          age: entry.PartnerAge ? `${entry.ClientAge}/${entry.PartnerAge}` : `${entry.ClientAge}`,
                          magi: this.magi.toLocaleString(),
                          fullMAGI: (fullMAGI) ? this.formatCurrency(fullMAGI, '') : fullMAGI,
                          percentMAGI: (percentMAGI) ? this.formatCurrency(percentMAGI, '') : percentMAGI, // this.formatCurrency(entry.MagiAdjustedHouseholdIncome, ''),
                          updatedBracket:  updatedBracket,
                          premiums: this.formatCurrency(entry.HouseholdExpenseByBracket[0], ''),
                          surcharges: this.formatCurrency((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]), ''),
                          total: entry.MagiAdjustedIncomeBracket === 1 ? entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] : entry.HouseholdExpenseByBracket[0] + entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0],
                          savings: this.formatCurrency((Math.max(0, Math.abs((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]) - (this.startingIllustration[idx].MagiAdjustedIncomeBracket === 1 ? 0 : this.startingIllustration[idx].HouseholdExpenseByBracket[this.startingIllustration[idx].MagiAdjustedIncomeBracket - 1] - this.startingIllustration[idx].HouseholdExpenseByBracket[0])))), '')
                      }
                      // console.log('updateEntry', updatedEntry);
                      updatedEntry.total = this.formatCurrency(updatedEntry.total, '');
                      return updatedEntry;
                  }
              });

              this.mmtModalData = this.mmtModalData.filter((item) => {return item != undefined});
              this.populateForm();


            },
            error => console.log(error));
  }


  enableDisablePercMAGI() {
    this.isEditPercentMAGI = !this.isEditPercentMAGI;
  }

  mappingToAdditionalQuestions() {
    //map Additional Questions too
    let firm = this.client.additionalQuestion ? this.client.additionalQuestion.Firm : '';
    let planSponsor = this.client.additionalQuestion ? this.client.additionalQuestion.PlanSponsor : '';
    let wholeSaler = this.client.additionalQuestion ? this.client.additionalQuestion.Wholesaler : '';
    let sendReportTo = this.client.additionalQuestion ? this.client.additionalQuestion.SendReportTo : '';
    let repName = this.client.additionalQuestion ? this.client.additionalQuestion.RepName : '';
    let meetingReference = this.client.additionalQuestion ? this.client.additionalQuestion.MeetingReference : '';
    let reportRequestFrom = this.client.additionalQuestion ? this.client.additionalQuestion.ReportRequestFrom : '';

    this.additionalQuestionsForm.controls['Firm'].setValue(firm);
    this.additionalQuestionsForm.controls['PlanSponsor'].setValue(planSponsor);
    this.additionalQuestionsForm.controls['Wholesaler'].setValue(wholeSaler);
    this.additionalQuestionsForm.controls['SendReportTo'].setValue(sendReportTo);
    this.additionalQuestionsForm.controls['RepName'].setValue(repName);
    this.additionalQuestionsForm.controls['MeetingReference'].setValue(meetingReference);
    this.additionalQuestionsForm.controls['ReportRequestFrom'].setValue(reportRequestFrom);
  }

  mappingToIncome(){
    //Income / MAGI
    if(this.client.clientProfile.HouseholdYearOneIncome){
      console.log('here i am 01');
      this.incomeEntryForm.controls['HouseHoldIncome'].patchValue('');
      this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(this.client.clientProfile.HouseholdYearOneIncome));
      this.incomeEntryForm.controls['YearOneRetirementIncome'].updateValueAndValidity();
    } else {
      console.log('here i am 01');
      let housholdIncome = this.client.clientProfile.CurrentIncome + ((this.client.clientProfile.Spouses) ? (this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.client.clientProfile.Spouses[0].currentIncome : 0 : 0);
      console.log('housholdIncome', housholdIncome)
      this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(housholdIncome)));
    
      this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue(Utils.formatToPercentage(this.client.clientProfile.IRR));
      this.incomeEntryForm.controls['IncomeReplacementRatio'].updateValueAndValidity();
      this.incomeEntryForm.controls['IncomeInflationRate'].patchValue(Utils.formatToPercentage(this.client.clientProfile.InflationRate));
      this.incomeEntryForm.controls['IncomeInflationRate'].updateValueAndValidity();
    }

    this.additinalIncomeForm.controls['InRetInflationRate'].patchValue(Utils.formatToPercentage(this.client.clientProfile.InRetirementInflationRate));
    this.additinalIncomeForm.controls['InRetInflationRate'].updateValueAndValidity();
    this.additinalIncomeForm.controls['MAGIPerc'].patchValue(Utils.formatToPercentage(this.client.clientProfile.MAGIPercentIncome));
    this.additinalIncomeForm.controls['MAGIPerc'].updateValueAndValidity();
    console.log('isOptionCurrentIncome 01');

    //this.isOptionCurrentIncome = this.incomeEntryForm.value.IncomeReplacementRatio ? ((Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio) > 0) ? true : false):false;
    //this.selectOptions('currentIncome');
    this.isOptionCurrentIncome = this.incomeEntryForm.value.HouseholdYearOneIncome ? ((this.incomeEntryForm.value.HouseholdYearOneIncome > 0) ? false : true) : true;

    this.getMMTBracket();
  }

  mappingToSS(isEditAll) {
    console.log('isEditAll')
    var FRA = this.getFRA(new Date(this.client.client.DOB.toString()).getFullYear());
    var birthMonths = this.getAgeMonths(this.client.client.DOB.toString())

    if(birthMonths > (FRA.age * 12) + FRA.month) {
      this.showClientKnownBenefit = true;

      //if less than 845 months
      if(birthMonths <= 845){        
        this.isClientAllowedRetroFiling = true;
        if((birthMonths - (FRA.age * 12) - FRA.month) >= 6){
          //if 6mo is/past FRA
          var fixedMonths = birthMonths - 6;;
          var years = Math.floor(fixedMonths / 12);
          var months = fixedMonths % 12;
          this.clientRetroClaimAge = years + " and " + months;
          this.clientRetroClaimYearMin = years;
          this.clientRetroClaimMonthMin = months;
          
        } else {
          //if less than 6mo past FRA
          var years = Math.floor(birthMonths / 12);
          var months = birthMonths % 12;
          this.clientRetroClaimAge = years + " and " + months;
          this.clientRetroClaimYearMin = years;
          this.clientRetroClaimMonthMin = months;
        }

        this.desiredClaimForm.get("ageYears").setValidators([Validators.required, Validators.min(this.clientRetroClaimYearMin),Validators.max(this.clientMaxClaimAge)]);
        this.desiredClaimForm.controls['ageYears'].updateValueAndValidity();
        /* this.desiredClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.clientRetroClaimMonthMin),Validators.max(11)]);
        this.desiredClaimForm.controls['ageMonths'].updateValueAndValidity(); */
      }
    } else {
      this.showClientKnownBenefit = false;
    }

    
    console.log(this.showClientKnownBenefit)
    console.log(this.client.clientProfile.MonthlyBenefitAmount);
    console.log('this.client.clientProfile.CurrentIncome',this.client.clientProfile.CurrentIncome)

    if (this.client.clientProfile.CurrentIncome >= 0 && this.client.clientProfile.CurrentIncome != null) {
      // if ((this.isHCFilledBefore && (this.client.clientProfile.Spouses[0].maritalStatus != 'Married')) || !this.isHCFilledBefore){
      //   this.incomeForm.controls['currentIncome'].patchValue(Utils.formatToCurrency(this.client.clientProfile.CurrentIncome));
      // }
      this.incomeForm.controls['currentIncome'].patchValue(Utils.formatToCurrency(this.client.clientProfile.CurrentIncome));

    }
    
    if (this.client.clientProfile.SelfKnownBenefitClaiming >= 0 && this.showClientKnownBenefit && !this.client.clientProfile.YearOfStatement && this.client.clientProfile.SelfKnownBenefitClaiming != null) {
      this.incomeForm.controls['knownBenefitClaiming'].patchValue(Utils.formatToCurrency(this.client.clientProfile.SelfKnownBenefitClaiming));
      this.incomeForm.controls['knownBenefitClaiming'].updateValueAndValidity();

      this.incomeForm.controls['pia'].patchValue('');
      this.incomeForm.get("pia").clearValidators();
      this.incomeForm.controls['pia'].updateValueAndValidity();
      this.incomeForm.controls['yearOfStatement'].patchValue('');
      this.incomeForm.get("yearOfStatement").clearValidators();
      this.incomeForm.controls['yearOfStatement'].updateValueAndValidity();
    }

    if (this.client.clientProfile.PIA >= 0 && this.client.clientProfile.PIA != null) {
      this.incomeForm.controls['pia'].patchValue(Utils.formatToCurrency(this.client.clientProfile.PIA));
      this.incomeForm.controls['knownBenefitClaiming'].patchValue('');
      this.incomeForm.get("knownBenefitClaiming").clearValidators();
      this.incomeForm.controls['knownBenefitClaiming'].updateValueAndValidity();
    }

    console.log('here i am 01');
    if (this.client.clientProfile.MonthlyBenefitAmount && this.client.clientProfile.MonthlyBenefitAmount >= 0) {
      console.log('here i am 02');
      this.incomeForm.controls['monthlyBenefits'].patchValue(Utils.formatToCurrency(this.client.clientProfile.MonthlyBenefitAmount));
      // this.incomeForm.controls['isCollectingBenefits'].patchValue(this.client.clientProfile.SelfAlreadyCollecting == false ? 'false' : 'true');
      // this.incomeForm.controls['isCollectingBenefits'].updateValueAndValidity();
      
      if(this.client.clientProfile.DateOfClaimYear && this.client.clientProfile.DateOfClaimYear >= 0 && this.client.clientProfile.SelfAlreadyCollecting){
        if(this.globalService.calculateAgeV2(this.client.client.DOB) >= 62) {
          //this.showClientKnownBenefit = false;
          console.log('DateOfClaimYear', this.client.clientProfile.DateOfClaimYear);
          this.incomeForm.controls['isCollectingBenefits'].patchValue('true');
          this.incomeForm.controls['isCollectingBenefits'].updateValueAndValidity();
          this.showClientKnownBenefit = false;

          this.incomeForm.controls['pia'].clearValidators()
          this.incomeForm.controls['pia'].updateValueAndValidity();
          let dateOfClaimYear = this.client.clientProfile.DateOfClaimYear < this.yearClientTurnedSixty || this.client.clientProfile.DateOfClaimYear > this.yearClientTurnedSixty + (this.dateOfClaimYearDiff - 1) ? '' : this.client.clientProfile.DateOfClaimYear;
          this.incomeForm.get("dateOfClaimYear").setValidators([Validators.required]);
          this.incomeForm.controls['dateOfClaimMonth'].patchValue(this.client.clientProfile.DateOfClaimMonth);
          this.incomeForm.controls['dateOfClaimYear'].patchValue(dateOfClaimYear);
        } else {
          this.incomeForm.controls['dateOfClaimMonth'].patchValue('');
          this.incomeForm.controls['dateOfClaimYear'].patchValue('');
        }
      }

      // this.showClientKnownBenefit = false;
    } else {
      //check if client should already be collecting
      if(this.client.clientProfile.SSDesiredAgeYears && this.client.clientProfile.PIA >= 0){
          if(this.client.clientProfile.SSDesiredAgeYears < this.globalService.calculateAgeV2(this.client.client.DOB) 
          && this.globalService.calculateAgeV2(this.client.client.DOB) >= 62 && this.client.clientProfile.SSDesiredAgeYears > 0){
            console.log('here isCollectingBenefits')
            // this.incomeForm.controls['isCollectingBenefits'].patchValue('true');
            // this.incomeForm.controls['isCollectingBenefits'].updateValueAndValidity();
            // this.showClientKnownBenefit = false;
            // this.incomeForm.get("dateOfClaimMonth").setValidators([Validators.required]);

            // this.incomeForm.controls['dateOfClaimYear'].patchValue('');
            // this.incomeForm.get("dateOfClaimYear").setValidators([Validators.required]);

            if(this.client.clientProfile.PIA > 0){
              this.incomeForm.controls['pia'].clearValidators()
              this.incomeForm.controls['pia'].updateValueAndValidity();
            }

            if (this.client.clientProfile.MonthlyBenefitAmount && this.client.clientProfile.MonthlyBenefitAmount >= 0) {
              const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
              //cant be older than max
              parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
              //cant be younger than min
              || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
              ? {invalidDate: 'Please make sure current monthly benefit is between $' + minAge + ' and $' + maxAge + '.' }  
              : null;
              this.incomeForm.get("monthlyBenefits").setValidators([Validators.required, validateBenefits(250, 6000)]);
              this.incomeForm.controls['monthlyBenefits'].updateValueAndValidity();
            }
            if(this.client.clientProfile.PIA > 0) {
              this.incomeForm.controls['monthlyBenefits'].patchValue(Utils.formatToCurrency(Math.round(this.client.clientProfile.PIA / 12)));
            }
            if(this.client.clientProfile.DateOfClaimYear && this.client.clientProfile.DateOfClaimYear >= 0) {
              // this.showClientKnownBenefit = false;
              this.incomeForm.controls['dateOfClaimMonth'].patchValue(this.client.clientProfile.DateOfClaimMonth);
              this.incomeForm.controls['dateOfClaimYear'].patchValue(this.client.clientProfile.DateOfClaimYear);
            }
        }
      }
    }

    let childrenArr = [];
    if (this.client.clientProfile.Children && this.client.clientProfile.Children != '[]') {
      console.log('here number of children', this.client.clientProfile.Children);
      if (typeof this.client.clientProfile.Children === 'string') {
        try {
          childrenArr = JSON.parse(this.client.clientProfile.Children);
        } catch (e) {
          console.error('Error parsing Children string', e);
          childrenArr = [];
        }
      } else if (Array.isArray(this.client.clientProfile.Children)) {
        childrenArr = this.client.clientProfile.Children;
      }
    }
    if (childrenArr && childrenArr.length) {
      const nonDisabledList = childrenArr.filter(c => !c.isDisabled);
      const disabledList = childrenArr.filter(c => c.isDisabled);

      if (nonDisabledList.length > 0) {
        this.applyQuestionnaireForm.controls['haveNonDisabledChild'].patchValue(true);
        this.haveChildrenForm.controls['haveNonDisabledChild'].patchValue(true);
        this.haveChildrenForm.controls['numberOfChild'].setValue(nonDisabledList.length);
        this.haveChildrenForm.controls['numberOfChild'].updateValueAndValidity();
        const childsAges = <FormArray>this.haveChildrenForm.controls['childsAges'];
        while (childsAges.length !== 0) { childsAges.removeAt(0); }
        for (let i = 0; i < nonDisabledList.length; i++) {
          this.addDependentAge();
          (<FormArray>(<FormArray>this.haveChildrenForm.controls['childsAges']).controls[i]).controls['dependentChildAge'].patchValue(nonDisabledList[i].DependentChildAge ? nonDisabledList[i].DependentChildAge : '');
          (<FormArray>(<FormArray>this.haveChildrenForm.controls['childsAges']).controls[i]).controls['dependentChildAge'].updateValueAndValidity();
        }
      }

      if (disabledList.length > 0) {
        const dac = disabledList[0];
        this.applyQuestionnaireForm.controls['haveDisabledChild'].patchValue(true);
        this.haveChildrenForm.controls['haveDisabledChild'].patchValue(true);
        this.haveChildrenForm.controls['dacCurrentAge'].patchValue(dac.DependentChildAge || '');
        this.haveChildrenForm.controls['dacAnticipateEnd'].patchValue(dac.dacAnticipateEnd ? 'true' : 'false');
        this.haveChildrenForm.controls['dacEndAge'].patchValue(dac.dacEndAge || '');
      }

      const hasDep = nonDisabledList.length > 0 || disabledList.length > 0;
      this.applyQuestionnaireForm.controls['haveDepChild'].patchValue(hasDep);
      this.applyQuestionnaireForm.controls['haveDepChild'].updateValueAndValidity();
    }

    this.pensionForm.controls['annualPensionValue'].patchValue(this.client.clientProfile.Pension ? Utils.formatToCurrency((this.client.clientProfile.Pension)) : '');
    this.pensionForm.controls['annualPensionValue'].updateValueAndValidity();
    this.pensionForm.controls['monthlyPensionValue'].patchValue(this.client.clientProfile.Pension ? Utils.formatToCurrency((this.client.clientProfile.Pension / 12).toFixed(2)) : '');
    this.pensionForm.controls['monthlyPensionValue'].updateValueAndValidity();
    this.pensionForm.controls['pensionInflationRate'].patchValue(this.client.clientProfile.PensionInfl >= 0 ? Utils.formatToPercentage((this.client.clientProfile.PensionInfl != null) ? this.client.clientProfile.PensionInfl : 3.00) : '3.00%');
    this.pensionForm.controls['pensionInflationRate'].updateValueAndValidity();
    this.pensionForm.controls['pensionStartMonth'].patchValue(this.client.clientProfile.PensionMonths ? this.client.clientProfile.PensionMonths : '');
    this.pensionForm.controls['pensionStartMonth'].updateValueAndValidity();
    this.pensionForm.controls['pensionStartYear'].patchValue(this.client.clientProfile.PensionYears ? this.client.clientProfile.PensionYears : '');
    this.pensionForm.controls['pensionStartYear'].updateValueAndValidity();
    this.pensionForm.controls['substantialEarningYear'].patchValue(this.client.clientProfile.SubstantialEarningYears ? this.client.clientProfile.SubstantialEarningYears : '');
    this.pensionForm.controls['substantialEarningYear'].updateValueAndValidity();
    this.applyQuestionnaireForm.controls['havePension'].patchValue(this.pensionForm.value.annualPensionValue ? true : false);
    this.applyQuestionnaireForm.controls['havePension'].updateValueAndValidity();

    this.inRetEarningForm.controls['firstYearRet'].patchValue(this.client.clientProfile.InRetFirstYearIncome ? Utils.formatToCurrency(this.client.clientProfile.InRetFirstYearIncome) : '');
    this.inRetEarningForm.controls['firstYearRet'].updateValueAndValidity();
    this.inRetEarningForm.controls['stopWorkAge'].patchValue(this.client.clientProfile.InRetStopWorkAge ? this.client.clientProfile.InRetStopWorkAge : '');
    this.inRetEarningForm.controls['stopWorkAge'].updateValueAndValidity();
    this.applyQuestionnaireForm.controls['partTimeWork'].patchValue(this.inRetEarningForm.value.firstYearRet ? true : false);
    this.applyQuestionnaireForm.controls['partTimeWork'].updateValueAndValidity();

    this.alreadyCollectedSSForm.controls['monthlyBenefitAmount'].patchValue(this.client.clientProfile.MonthlyBenefitAmount ? Utils.formatToCurrency(this.client.clientProfile.MonthlyBenefitAmount):'');
    this.alreadyCollectedSSForm.controls['monthlyBenefitAmount'].updateValueAndValidity();
    this.applyQuestionnaireForm.controls['alreadySSCollected'].patchValue(this.alreadyCollectedSSForm.value.monthlyBenefitAmount ? true : false);
    this.applyQuestionnaireForm.controls['alreadySSCollected'].updateValueAndValidity();
    // let desiredAgeYears = this.client.clientProfile.InvertSurvivorSwitch ? (this.client.clientProfile.SurvivorSwitchYears ? this.client.clientProfile.SurvivorSwitchYears : '') : (this.client.clientProfile.SSDesiredAgeYears ? this.client.clientProfile.SSDesiredAgeYears : '');
    // this.desiredClaimForm.controls['ageYears'].patchValue(desiredAgeYears);
    // this.desiredClaimForm.controls['ageYears'].updateValueAndValidity();
    // let desiredAgeMonths = this.client.clientProfile.InvertSurvivorSwitch ? (this.client.clientProfile.SurvivorSwitchYears ? this.client.clientProfile.SurvivorSwitchMonths || 0 : '') : (this.client.clientProfile.SSDesiredAgeYears ? this.client.clientProfile.sSDesiredAgeMonths || 0 : '');
    // this.desiredClaimForm.controls['ageMonths'].patchValue(desiredAgeMonths);
    this.desiredClaimForm.controls['ageYears'].patchValue(this.client.clientProfile.SSDesiredAgeYears ? (this.client.clientProfile.SSDesiredAgeYears > 0) ? this.client.clientProfile.SSDesiredAgeYears : '' :'');
    this.desiredClaimForm.controls['ageYears'].updateValueAndValidity();
    this.desiredClaimForm.controls['ageMonths'].patchValue(this.client.clientProfile.SSDesiredAgeMonths || this.client.clientProfile.SSDesiredAgeMonths == 0 ? this.client.clientProfile.SSDesiredAgeMonths : '');
    this.desiredClaimForm.controls['ageMonths'].updateValueAndValidity();
    this.applyQuestionnaireForm.controls['desiredClaimAge'].patchValue(this.desiredClaimForm.value.ageYears ? true : false);
    this.applyQuestionnaireForm.controls['desiredClaimAge'].updateValueAndValidity();

    console.log('here 02');
    //TODO ZSS: needed to figure out how to set legal spouse for clients in production that are in redesign for backwards compatibility
    //NOT sure if this is going to play an issue with non-legal married spouses....
    var ignore60PlusMarriageForBckwrdCompClients = false;
    if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.client.clientProfile.Spouses[0].anniversary && this.client.clientProfile.IsLegalSpouse == null){
      //this.client.clientProfile.IsLegalSpouse = true;
      this.client.clientProfile.IsLegalSpouse = 1;

      //let anniversayDate = new Date(this.client.clientProfile.Spouses[0].anniversary);
      //console.log('anniversay test', anniversayDate);
      //this.sixtyPlusForm.controls['dateOfMarriage'].patchValue(anniversayDate);
      //ignore60PlusMarriageForBckwrdCompClients = true; //this was causing issues with client in Prod - need to review; set to false for now
    }

    if (this.client.clientProfile.Spouses[0].anniversary && this.client.clientProfile.IsLegalSpouse) {
      let anniversayDate = new Date(this.client.clientProfile.Spouses[0].anniversary);
      console.log('anniversay test', anniversayDate);
      this.sixtyPlusForm.controls['dateOfMarriage'].patchValue(anniversayDate);
      console.log('this.client.DOB', this.client);
      console.log('this.calculateAgeAtMarriage 01', this.calculateAgeAtMarriage(this.client.client.DOB, this.client.clientProfile.Spouses[0].anniversary));
      console.log('this.calculateAgeAtMarriage 02', this.calculateAgeAtMarriage(this.client.clientProfile.Spouses[0].dob, this.client.clientProfile.Spouses[0].anniversary));
      this.isClientSixtyPlusAtMarriage = this.calculateAgeAtMarriage(this.client.client.DOB, this.client.clientProfile.Spouses[0].anniversary) >= 60 ? true : false;
      this.isSpouseSixtyPlusAtMarriage = this.calculateAgeAtMarriage(this.client.clientProfile.Spouses[0].dob, this.client.clientProfile.Spouses[0].anniversary) >= 60 ? true : false;
      console.log('isClientSixtyPlusAtMarriage', this.isClientSixtyPlusAtMarriage);
    }

    if (this.client.clientProfile.Spouses.length > 0 && (!this.client.clientProfile.IsLegalSpouse || this.isClientSixtyPlusAtMarriage) && this.client.clientProfile.Spouses[0].maritalStatus != "Single" ) {

      var hasMarriedSpouse = false;
      this.prevMarraigesForm.controls['marraigeTimes'].patchValue(this.client.clientProfile.Spouses.length);// - 1);
      
      for(let i=1; i <= this.client.clientProfile.Spouses.length; i++) {
        if (this.client.clientProfile.Spouses[i-1].maritalStatus == "Married"){
          continue;
        }

        this.addMarriage();
      }

      for (let i = 0; i < this.client.clientProfile.Spouses.length; i++) {
        
        if (this.client.clientProfile.Spouses[i].maritalStatus == "Married"){
          hasMarriedSpouse = true;
          if(this.client.clientProfile.Spouses.length - 1 > 0){
            this.prevMarraigesForm.controls['marraigeTimes'].patchValue(this.client.clientProfile.Spouses.length - 1);
          } else {
            this.prevMarraigesForm.controls['marraigeTimes'].patchValue("");
            //this.prevMarraigesForm.controls['marraigeTimes'].clearValidators();
            this.prevMarraigesForm.controls['marraigeTimes'].updateValueAndValidity();
          }

          continue;
        } else {
          //i = i-1;
        }

        console.log('prev marriage count', this.prevMarraigesForm.value.marraigeTimes);
        console.log('spouse before error', this.client.clientProfile.Spouses);
        console.log('I = ', i);
        console.log('numberMarriages', this.numberMarriagesForm.value.numberMarriages);
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['prevMarriageTypes'].patchValue(this.client.clientProfile.Spouses[i].maritalStatus ? this.client.clientProfile.Spouses[i].maritalStatus : '');
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['prevMarriageTypes'].updateValueAndValidity();
        if (this.client.clientProfile.Spouses[i].maritalStatus) {
          //console.log('numberMarriages', this.numberMarriagesForm.value.numberMarriages);
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['firstName'].patchValue(this.client.clientProfile.Spouses[i].firstName ? this.client.clientProfile.Spouses[i].firstName:'');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['firstName'].updateValueAndValidity();
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['lastName'].patchValue(this.client.clientProfile.Spouses[i].lastName ? this.client.clientProfile.Spouses[i].lastName:'');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['lastName'].updateValueAndValidity();
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['sexAtBirth'].patchValue(this.client.clientProfile.Spouses[i].gender ? (this.client.clientProfile.Spouses[i].gender == "Female" ? 2 :(this.client.clientProfile.Spouses[i].gender == "Male" ? 1 : this.client.clientProfile.Spouses[i].gender)):'');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['sexAtBirth'].updateValueAndValidity();
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['dateOfBirth'].patchValue(this.client.clientProfile.Spouses[i].dobStr ? new Date(this.client.clientProfile.Spouses[i].dobStr):'');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['dateOfBirth'].updateValueAndValidity();
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['insuranceAmount'].patchValue(this.client.clientProfile.Spouses[i].pia ? Utils.formatToCurrency(this.client.clientProfile.Spouses[i].pia):'');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['insuranceAmount'].updateValueAndValidity();
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['stillAlive'].patchValue((this.client.clientProfile.Spouses[i].alive) ? "Yes" : "No");
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['stillAlive'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['expectedClaimAgeYears'].patchValue((this.client.clientProfile.Spouses[i].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[i].expectedClaimAgeYears : "");
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['expectedClaimAgeYears'].setValidators((this.client.clientProfile.Spouses[i].expectedClaimAgeYears) ? [Validators.required, Validators.min(62), Validators.max(70)] : []);
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['expectedClaimAgeYears'].updateValueAndValidity();
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['expectedClaimAgeMonths'].patchValue((this.client.clientProfile.Spouses[i].expectedClaimAgeMonths) ? (this.client.clientProfile.Spouses[i].expectedClaimAgeYears == 70) ? 0 : this.client.clientProfile.Spouses[i].expectedClaimAgeMonths : "");
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['expectedClaimAgeMonths'].setValidators((this.client.clientProfile.Spouses[i].expectedClaimAgeMonths) ? [Validators.required, Validators.min(0), Validators.max(((this.client.clientProfile.Spouses[i].expectedClaimAgeYears) ? ((this.client.clientProfile.Spouses[i].expectedClaimAgeYears == 70) ? 0 : 11) : 11))] : []); 
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['expectedClaimAgeMonths'].updateValueAndValidity();


          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['spouseCollectAtTimeOfPassing'].patchValue((this.client.clientProfile.Spouses[i].spouseCollectAtTimeOfPassing) ? "Yes" : "No");
          //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['spouseCollectAtTimeOfPassing'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['monthlyBenefitAtPassing'].patchValue((this.client.clientProfile.Spouses[i].monthlyBenefitAtPassing) ? Utils.formatToCurrency(this.client.clientProfile.Spouses[i].monthlyBenefitAtPassing) : "");
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['marriedTenOrMoreYears'].patchValue((this.client.clientProfile.Spouses[i].tenyears) ? "Yes" : "No");
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['marriedTenOrMoreYears'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseLifeExpectancy'].patchValue((this.client.clientProfile.Spouses[i].exSpouseLifeExpectancy) ? this.client.clientProfile.Spouses[i].exSpouseLifeExpectancy: this.defaultLifeExpectancy);
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseLifeExpectancy'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseClaimAgeYears'].patchValue((this.client.clientProfile.Spouses[i].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[i].exSpouseClaimAgeYears : '');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseClaimAgeMonths'].patchValue((this.client.clientProfile.Spouses[i].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[i].exSpouseClaimAgeMonths : '');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseClaimAgeMonths'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseDateOfBirth'].patchValue((this.client.clientProfile.Spouses[i].exSpouseDateOfBirth) ? new Date(this.client.clientProfile.Spouses[i].exSpouseDateOfBirth) : '');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['exSpouseDateOfBirth'].updateValueAndValidity();
          
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['yearOfStatement'].patchValue((this.client.clientProfile.Spouses[i].yearOfStatement) ? this.client.clientProfile.Spouses[i].yearOfStatement : this.currentYear);
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['yearOfStatement'].updateValueAndValidity();

          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['yearAtTimeOfPassing'].patchValue((this.client.clientProfile.Spouses[i].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[i].yearAtTimeOfPassing : '');
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['yearAtTimeOfPassing'].updateValueAndValidity();
          // if (this.client.clientProfile.Spouses[i].dobStr && this.client.clientProfile.Spouses[i].gender) {
          //   this.calculateLifeExp(this.calculateAge(this.client.clientProfile.Spouses[i].dobStr),this.client.clientProfile.Spouses[i].gender, (i-1));
          // }

          //TODO: convert DOB here and set Expected Claim Age for backwards compatability
          //do at end of IF to not effect what is already in place for existing clients
          //IF we fall in here with clients before Sept/Oct of 2022 - we need to fix/find out why
          if(!(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).value.dateOfBirth){
            this.client.clientProfile.Spouses[i].dob = new Date(this.client.clientProfile.Spouses[i].dob);
            this.client.clientProfile.Spouses[i].dobStr = this.client.clientProfile.Spouses[i].dob.toString();

            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['dateOfBirth'].patchValue(this.client.clientProfile.Spouses[i].dobStr ? new Date(this.client.clientProfile.Spouses[i].dobStr):'');
            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[(hasMarriedSpouse) ? i - 1 : i]).controls['dateOfBirth'].updateValueAndValidity();
          }

          if(!(this.client.clientProfile.Spouses[i].expectedClaimAgeYears) && this.client.clientProfile.Spouses[i].alive && this.client.clientProfile.Spouses[i].tenyears
            && this.client.clientProfile.Spouses[i].maritalStatus == 'Divorced'){

            var exSpouseFRA = this.getFRA(this.client.clientProfile.Spouses[0].dob);
            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].patchValue(exSpouseFRA.age);
            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);
            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity();
            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].patchValue((exSpouseFRA.age == 70) ? 0 : exSpouseFRA.month);
            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(((exSpouseFRA.age == 70) ? 0 : 11))]); 
            (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity();

          }

        }
      }
      
      this.applyQuestionnaireForm.controls['previouslyMarried'].patchValue(((this.client.clientProfile.Spouses.length - (hasMarriedSpouse ? 1 : 0)) >= 1) ? true : false);
      this.applyQuestionnaireForm.controls['previouslyMarried'].updateValueAndValidity();

      console.log('prevously married bool', this.applyQuestionnaireForm.value.previouslyMarried);

    }
    // console.log('in spouse 01', this.client.clientProfile.Spouses[0]);
    if (this.client.clientProfile.Spouses[0]) {
      console.log('in spouse', this.client.clientProfile.Spouses[0]);
      if(this.client.clientProfile.Spouses[0].dob){
        var FRA = this.getFRA(new Date(this.client.clientProfile.Spouses[0].dob.toString()).getFullYear());
        var birthMonths = this.getAgeMonths(this.client.clientProfile.Spouses[0].dob.toString())
        
        if(birthMonths > ((FRA.age * 12) + FRA.month)){
          this.showSpouseKnownBenefit = true;  
          
          //if less than 845 months
          if(birthMonths <= 845){        
            this.isSpouseAllowedRetroFiling = true;
            if((birthMonths - (FRA.age * 12) - FRA.month) >= 6){
              //if 6mo is/past FRA
              var fixedMonths = birthMonths - 6;
              var years = Math.floor(fixedMonths / 12);
              var months = fixedMonths % 12;
              this.spouseRetroClaimAge = years + " and " + months;
              this.spouseRetroClaimYearMin = years;
              this.spouseRetroClaimMonthMin = months;
            } else {
              //if less than 6mo past FRA
              var years = Math.floor(birthMonths / 12);
              var months = birthMonths % 12;
              this.spouseRetroClaimAge = years + " and " + months;
              this.spouseRetroClaimYearMin = years;
              this.spouseRetroClaimMonthMin = months;
            }

            this.desiredSpouseClaimForm.get("ageYears").setValidators([Validators.required, Validators.min(this.spouseRetroClaimYearMin),Validators.max(this.spouseMaxClaimAge)]);
            this.desiredSpouseClaimForm.controls['ageYears'].updateValueAndValidity();
            /* this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.spouseRetroClaimMonthMin),Validators.max(this.spouseMaxClaimMonth)]);
            this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity(); */
          }
        } else {
          if((birthMonths - (FRA.age * 12) - FRA.month) >= 6){
            //if 6mo is/past FRA
            var fixedMonths = birthMonths - 6;
            var years = Math.floor(fixedMonths / 12);
            var months = fixedMonths % 12;
            this.spouseRetroClaimAge = years + " and " + months;
            this.spouseRetroClaimYearMin = years;
            this.spouseRetroClaimMonthMin = months;
          } else {
            //if less than 6mo past FRA
            var years = Math.floor(birthMonths / 12);
            var months = birthMonths % 12;
            this.spouseRetroClaimAge = years + " and " + months;
            this.spouseRetroClaimYearMin = years;
            this.spouseRetroClaimMonthMin = months;
          }

          this.desiredSpouseClaimForm.get("ageYears").setValidators([Validators.required, Validators.min(this.spouseRetroClaimYearMin),Validators.max(this.spouseMaxClaimAge)]);
          this.desiredSpouseClaimForm.controls['ageYears'].updateValueAndValidity();

           this.showSpouseKnownBenefit = false;
        }
      }
      if(this.client.clientProfile.Spouses[0].currentIncome >= 0){
        // if ((this.isHCFilledBefore && (this.client.clientProfile.Spouses[0].maritalStatus != 'Married')) || !this.isHCFilledBefore){
        //   this.spouseIncomeForm.controls['currentIncome'].patchValue(Utils.formatToCurrency(this.client.clientProfile.Spouses[0].currentIncome));
        // }
        this.spouseIncomeForm.controls['currentIncome'].patchValue(Utils.formatToCurrency(this.client.clientProfile.Spouses[0].currentIncome));
        // this.spouseIncomeForm.controls['currentIncome'].updateValueAndValidity();
      }
      if(this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].pia >= 0) {
        this.spouseIncomeForm.controls['pia'].patchValue(Utils.formatToCurrency(this.client.clientProfile.Spouses[0].pia));
        this.spouseIncomeForm.controls['pia'].updateValueAndValidity();
        this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue('');
        this.spouseIncomeForm.get("knownBenefitClaiming").clearValidators(); 
        this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming = null;
      }
      if(this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming >= 0 && this.showSpouseKnownBenefit && this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming != null){
        this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue(Utils.formatToCurrency(this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming));
        this.spouseIncomeForm.controls['knownBenefitClaiming'].updateValueAndValidity();
        // this.spouseIncomeForm.controls['pia'].patchValue('');
        // this.spouseIncomeForm.get("pia").clearValidators();

        this.spouseIncomeForm.controls['pia'].patchValue('');
        this.spouseIncomeForm.get("pia").clearValidators();
        this.spouseIncomeForm.controls['pia'].updateValueAndValidity();
        this.spouseIncomeForm.controls['yearOfStatement'].patchValue('');
        this.spouseIncomeForm.get("yearOfStatement").clearValidators();
        this.spouseIncomeForm.controls['yearOfStatement'].updateValueAndValidity();

        this.client.clientProfile.Spouses[0].pia = null;
        this.client.clientProfile.Spouses[0].yearOfStatement = null;
      }

      //does this variable even exist in the spouse object?
      var spouseHasMonthlyBenefitsField = false;
      if(this.client.clientProfile.Spouses[0].monthlyBenefits){
        if(Utils.removeCurrencyFormatting(this.client.clientProfile.Spouses[0].monthlyBenefits) >= 0){
          spouseHasMonthlyBenefitsField = true;
        }
      }

      if(spouseHasMonthlyBenefitsField){ //monthlyBenefitAmount
        // This value got saved in the past with multiple $'s ex- $$$1,666
        // Clean up extra $'s
        this.client.clientProfile.Spouses[0].monthlyBenefits = this.client.clientProfile.Spouses[0].monthlyBenefits.replace(/[$]/g,'')

        const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
          //cant be older than max
          parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
          //cant be younger than min
          || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
          ? {invalidDate: 'Please make sure current monthly benefit is between $' + minAge + ' and $' + maxAge + '.' }  
          : null;
        this.spouseIncomeForm.controls['monthlyBenefits'].patchValue(Utils.formatToCurrency(this.client.clientProfile.Spouses[0].monthlyBenefits)); //monthlyBenefitAmount
        this.spouseIncomeForm.get("monthlyBenefits").setValidators([Validators.required, validateBenefits(250, 6000)]);
        this.spouseIncomeForm.controls['monthlyBenefits'].updateValueAndValidity();
        //this.spouseIncomeForm.controls['isCollectingBenefits'].patchValue((this.spouseIncomeForm.value.monthlyBenefits >= 0) ? 'true' : 'false');
        this.spouseIncomeForm.controls['isCollectingBenefits'].patchValue(this.client.clientProfile.SpouseAlreadyCollecting == false ? 'false' : 'true');
        this.spouseIncomeForm.controls['isCollectingBenefits'].updateValueAndValidity();
        this.showSpouseKnownBenefit = this.spouseIncomeForm.value.isCollectingBenefits == 'true' ? false: this.showSpouseKnownBenefit;

        if(this.client.clientProfile.Spouses[0].dateOfClaimYear && this.client.clientProfile.Spouses[0].dateOfClaimYear >= 0 && this.client.clientProfile.SpouseAlreadyCollecting){
          if(this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) >= 62){
            //this.showClientKnownBenefit = false;
            console.log('DateOfClaimYear', this.client.clientProfile.Spouses[0].dateOfClaimYear);
            //this.spouseIncomeForm.controls['isCollectingBenefits'].patchValue('true');
            //this.spouseIncomeForm.controls['isCollectingBenefits'].updateValueAndValidity();

            this.spouseIncomeForm.controls['pia'].clearValidators()
            this.spouseIncomeForm.controls['pia'].updateValueAndValidity();
        
            this.spouseIncomeForm.controls['dateOfClaimMonth'].patchValue(this.client.clientProfile.Spouses[0].dateOfClaimMonth);
            this.spouseIncomeForm.controls['dateOfClaimYear'].patchValue(this.client.clientProfile.Spouses[0].dateOfClaimYear);
          } else {
            this.spouseIncomeForm.controls['dateOfClaimMonth'].patchValue('');
            this.spouseIncomeForm.controls['dateOfClaimYear'].patchValue('');
          }
        }

        //this.spouseIncomeForm.controls['dateOfClaimMonth'].patchValue(this.client.clientProfile.Spouses[0].dateOfClaimMonth);
        //this.spouseIncomeForm.controls['dateOfClaimYear'].patchValue(this.client.clientProfile.Spouses[0].dateOfClaimYear);

        // this.showSpouseKnownBenefit = false;
      } else {
        //check if client should already be collecting
        if(this.client.clientProfile.Spouses[0].sSDesiredAgeYears && this.client.clientProfile.Spouses[0].pia >= 0){
            if(this.client.clientProfile.Spouses[0].sSDesiredAgeYears <= this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) >= 62 && this.client.clientProfile.Spouses[0].sSDesiredAgeYears > 0){
              
              //this.spouseIncomeForm.controls['isCollectingBenefits'].patchValue('true');
              //this.spouseIncomeForm.controls['isCollectingBenefits'].updateValueAndValidity();

              this.spouseIncomeForm.controls['pia'].clearValidators()
              this.spouseIncomeForm.controls['pia'].updateValueAndValidity();
  
              this.spouseIncomeForm.controls['monthlyBenefits'].patchValue(Utils.formatToCurrency(Math.round(this.client.clientProfile.Spouses[0].pia / 12)));
              this.spouseIncomeForm.controls['monthlyBenefits'].updateValueAndValidity();
              //console.log('incomeForm', this.incomeForm);

              if(this.client.clientProfile.Spouses[0].dateOfClaimYear && this.client.clientProfile.Spouses[0].dateOfClaimYear >= 0){
                this.showSpouseKnownBenefit = false;
                this.spouseIncomeForm.controls['dateOfClaimMonth'].patchValue(this.client.clientProfile.Spouses[0].dateOfClaimMonth);
                this.spouseIncomeForm.controls['dateOfClaimYear'].patchValue(this.client.clientProfile.Spouses[0].dateOfClaimYear);
              }
          } else {
            //this.spouseIncomeForm.controls['dateOfClaimMonth'].patchValue('');
            //this.spouseIncomeForm.controls['dateOfClaimYear'].patchValue('');
          }
        }
      }

      let spouseChildrenArr = [];
      if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].children) {
        spouseChildrenArr = this.client.clientProfile.Spouses[0].children;
        if (typeof spouseChildrenArr === 'string') {
          try { spouseChildrenArr = JSON.parse(spouseChildrenArr); } catch (e) { spouseChildrenArr = []; }
        }
      }

      if (spouseChildrenArr && spouseChildrenArr.length) {
        const nonDisabledList = spouseChildrenArr.filter(c => !c.isDisabled);
        const disabledList = spouseChildrenArr.filter(c => c.isDisabled);

        if (nonDisabledList.length > 0) {
          this.applySpouseQuestionnaireForm.controls['haveNonDisabledChild'].patchValue(true);
          this.haveSpouseChildrenForm.controls['haveNonDisabledChild'].patchValue(true);
          this.haveSpouseChildrenForm.controls['numberOfChild'].setValue(nonDisabledList.length);
          this.haveSpouseChildrenForm.controls['numberOfChild'].updateValueAndValidity();
          const childsAges = <FormArray>this.haveSpouseChildrenForm.controls['childsAges'];
          while (childsAges.length !== 0) { childsAges.removeAt(0); }
          for (let i = 0; i < nonDisabledList.length; i++) {
            this.addSpouseDependentAge();
            (<FormArray>(<FormArray>this.haveSpouseChildrenForm.controls['childsAges']).controls[i]).controls['dependentChildAge'].patchValue(nonDisabledList[i].DependentChildAge ? nonDisabledList[i].DependentChildAge : '');
            (<FormArray>(<FormArray>this.haveSpouseChildrenForm.controls['childsAges']).controls[i]).controls['dependentChildAge'].updateValueAndValidity();
          }
        }

        if (disabledList.length > 0) {
          const dac = disabledList[0];
          this.applySpouseQuestionnaireForm.controls['haveDisabledChild'].patchValue(true);
          this.haveSpouseChildrenForm.controls['haveDisabledChild'].patchValue(true);
          this.haveSpouseChildrenForm.controls['dacCurrentAge'].patchValue(dac.DependentChildAge || '');
          this.haveSpouseChildrenForm.controls['dacAnticipateEnd'].patchValue(dac.dacAnticipateEnd ? 'true' : 'false');
          this.haveSpouseChildrenForm.controls['dacEndAge'].patchValue(dac.dacEndAge || '');
        }

        const hasDep = nonDisabledList.length > 0 || disabledList.length > 0;
        this.applySpouseQuestionnaireForm.controls['haveDepChild'].patchValue(hasDep);
        this.applySpouseQuestionnaireForm.controls['haveDepChild'].updateValueAndValidity();
      }

      this.pensionSpouseForm.controls['annualPensionValue'].patchValue(this.client.clientProfile.Spouses[0].pension ? Utils.formatToCurrency(this.client.clientProfile.Spouses[0].pension): '');
      this.pensionSpouseForm.controls['annualPensionValue'].updateValueAndValidity();
      this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue(this.client.clientProfile.Spouses[0].pension ? Utils.formatToCurrency((this.client.clientProfile.Spouses[0].pension / 12).toFixed(2)): '');
      this.pensionSpouseForm.controls['monthlyPensionValue'].updateValueAndValidity();
      this.pensionSpouseForm.controls['pensionInflationRate'].patchValue(this.client.clientProfile.Spouses[0].PensionInfl >= 0 ? Utils.formatToPercentage((this.client.clientProfile.Spouses[0].PensionInfl != null) ? this.client.clientProfile.Spouses[0].PensionInfl : 3.00) : '3.00%');
      this.pensionSpouseForm.controls['pensionInflationRate'].updateValueAndValidity();
      this.pensionSpouseForm.controls['pensionStartMonth'].patchValue(this.client.clientProfile.Spouses[0].pensionMonth ? this.client.clientProfile.Spouses[0].pensionMonth: '');
      this.pensionSpouseForm.controls['pensionStartMonth'].updateValueAndValidity();
      this.pensionSpouseForm.controls['pensionStartYear'].patchValue(this.client.clientProfile.Spouses[0].pensionYear ? this.client.clientProfile.Spouses[0].pensionYear: '');
      this.pensionSpouseForm.controls['pensionStartYear'].updateValueAndValidity();
      this.pensionSpouseForm.controls['substantialEarningYear'].patchValue(this.client.clientProfile.Spouses[0].substantialEarningYears ? this.client.clientProfile.Spouses[0].substantialEarningYears: '');
      this.pensionSpouseForm.controls['substantialEarningYear'].updateValueAndValidity();
      this.applySpouseQuestionnaireForm.controls['havePension'].patchValue(this.pensionSpouseForm.value.annualPensionValue ? true : false);
      this.applySpouseQuestionnaireForm.controls['havePension'].updateValueAndValidity();
  
      this.inRetSpouseEarningForm.controls['firstYearRet'].patchValue(this.client.clientProfile.Spouses[0].inRetFirstYearIncome ? Utils.formatToCurrency(this.client.clientProfile.Spouses[0].inRetFirstYearIncome) : '');
      this.inRetSpouseEarningForm.controls['firstYearRet'].updateValueAndValidity();
      this.inRetSpouseEarningForm.controls['stopWorkAge'].patchValue(this.client.clientProfile.Spouses[0].inRetStopWork ? this.client.clientProfile.Spouses[0].inRetStopWork : '');
      this.inRetSpouseEarningForm.controls['stopWorkAge'].updateValueAndValidity();
      this.applySpouseQuestionnaireForm.controls['partTimeWork'].patchValue(this.inRetSpouseEarningForm.value.firstYearRet ? true : false);
      this.applySpouseQuestionnaireForm.controls['partTimeWork'].updateValueAndValidity();
  
      this.alreadyCollectedSpouseSSForm.controls['monthlyBenefitAmount'].patchValue(this.client.clientProfile.Spouses[0].monthlyBenefitAmount ? Utils.formatToCurrency(this.client.clientProfile.Spouses[0].monthlyBenefitAmount):'');
      this.alreadyCollectedSpouseSSForm.controls['monthlyBenefitAmount'].updateValueAndValidity();
      this.applySpouseQuestionnaireForm.controls['alreadySSCollected'].patchValue(this.alreadyCollectedSSForm.value.monthlyBenefitAmount ? true : false);
      this.applySpouseQuestionnaireForm.controls['alreadySSCollected'].updateValueAndValidity();

       // let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : null); 
      // let isSpouseSurvivor = ((this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.calculateAge(spouseDOB) <= 60
      //       || (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.calculateAge(spouseDOB) <= 69);

      // isSpouseSurvivor = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && isSpouseSurvivor ? true : false

      // if (isSpouseSurvivor) {
      //   this.desiredSpouseClaimForm.controls['ageYears'].patchValue((this.client.clientProfile.Spouses[0].sSDesiredAgeYears && this.client.clientProfile.InvertSurvivorSwitch || this.client.clientProfile.SurvivorSwitchYears && !this.client.clientProfile.InvertSurvivorSwitch) ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears > 0 && this.client.clientProfile.InvertSurvivorSwitch ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears > 0 && !this.client.clientProfile.InvertSurvivorSwitch ? this.client.clientProfile.SurvivorSwitchYears : '' : '')
      //   this.desiredSpouseClaimForm.controls['ageYears'].updateValueAndValidity();
      //   this.desiredSpouseClaimForm.controls['ageMonths'].patchValue((this.client.clientProfile.Spouses[0].sSDesiredAgeMonths && this.client.clientProfile.InvertSurvivorSwitch || this.client.clientProfile.SurvivorSwitchMonths && !this.client.clientProfile.InvertSurvivorSwitch) ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths > 0 && this.client.clientProfile.InvertSurvivorSwitch ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths > 0 && !this.client.clientProfile.InvertSurvivorSwitch ? this.client.clientProfile.SurvivorSwitchMonths : '' : '')
      // } else {

      // }

      // this.isSurivivorAsSpouseDesiredAge = !this.client.clientProfile.Spouses[0].sSDesiredAgeYears && this.client.clientProfile.SurvivorSwitchYears ? true : false;
      this.isSurivivorAsSpouseDesiredAge = !this.client.clientProfile.Spouses[0].sSDesiredAgeYears && this.client.clientProfile.SurvivorSwitchYears || (this.client.clientProfile.Spouses[0].sSDesiredAgeYears && this.client.clientProfile.SurvivorSwitchYears && (Number(this.client.clientProfile.SurvivorSwitchYears) < Number(this.client.clientProfile.Spouses[0].sSDesiredAgeYears)) )  ? true : false;
      this.desiredSpouseClaimForm.controls['ageYears'].patchValue(this.isSurivivorAsSpouseDesiredAge ? this.client.clientProfile.SurvivorSwitchYears : this.client.clientProfile.Spouses[0].sSDesiredAgeYears || '');
      // this.desiredSpouseClaimForm.controls['ageYears'].patchValue(this.client.clientProfile.Spouses[0].sSDesiredAgeYears ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears :(this.client.clientProfile.SurvivorSwitchYears || ''));
      this.desiredSpouseClaimForm.controls['ageYears'].updateValueAndValidity();
      // this.desiredSpouseClaimForm.controls['ageMonths'].patchValue(this.client.clientProfile.Spouses[0].sSDesiredAgeMonths || this.client.clientProfile.Spouses[0].sSDesiredAgeMonths == 0 ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.Spouses[0].sSDesiredAgeYears ? 0 :(this.client.clientProfile.SurvivorSwitchYears ? this.client.clientProfile.SurvivorSwitchMonths || 0: ''));
      this.desiredSpouseClaimForm.controls['ageMonths'].patchValue(this.isSurivivorAsSpouseDesiredAge ? this.client.clientProfile.SurvivorSwitchMonths || 0 : this.client.clientProfile.Spouses[0].sSDesiredAgeYears ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths || 0 : '');
      let value = this.desiredSpouseClaimForm.value.ageYears;
        if (value == 70) {
          this.desiredSpouseClaimForm.controls['ageMonths'].setValidators([Validators.min(0), Validators.max(0)]);
          this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
        }
        if (value < 70) {
            if(this.spouseRetroClaimYearMin && this.spouseRetroClaimYearMin == value){
              this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.spouseRetroClaimMonthMin),Validators.max(this.spouseMaxClaimMonth)]);
            } else {
              this.spouseMinClaimMonth = this.desiredSpouseClaimForm.value.ageMonths > 62 && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) == this.desiredSpouseClaimForm.value.ageMonths ? (this.getDOBMonth(this.client.clientProfile.Spouses[0].dob) > (new Date().getMonth() + 1)) ? (new Date().getMonth() + 1) :((new Date().getMonth() + 1) - this.getDOBMonth(this.client.clientProfile.Spouses[0].dob)) : 0;
              this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.spouseMinClaimMonth),Validators.max(this.spouseMaxClaimMonth)]);
            }
            this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
        }
      // }

      this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
      this.applySpouseQuestionnaireForm.controls['desiredClaimAge'].patchValue(this.desiredSpouseClaimForm.value.ageYears ? true : false);
      this.applySpouseQuestionnaireForm.controls['desiredClaimAge'].updateValueAndValidity();

      if(!this.client.clientProfile.IsLegalSpouse || this.isSpouseSixtyPlusAtMarriage){
        var setSpousePrevMarraiges = false;
        if(!this.client.clientProfile.Spouses[0].spousesSpouse){
          this.client.clientProfile.Spouses[0].spousesSpouse = [];
        }

        //this.prevSpouseMarraigesForm.controls['marraigeTimes'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse.length);
        
        for(let i=1; i <= this.client.clientProfile.Spouses[0].spousesSpouse.length; i++) {
          this.addSpouseMarriage();
          setSpousePrevMarraiges = true;
        }

        if(setSpousePrevMarraiges){
          this.prevSpouseMarraigesForm.controls['marraigeTimes'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse.length);
        }

        for (let i = 1; i <= this.client.clientProfile.Spouses[0].spousesSpouse.length; i++) {
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['prevMarriageTypes'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].maritalStatus ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].maritalStatus:'');
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['prevMarriageTypes'].updateValueAndValidity();
          if (this.client.clientProfile.Spouses[0].spousesSpouse[i-1].maritalStatus) {
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['firstName'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].firstName ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].firstName:'');
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['firstName'].updateValueAndValidity();
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['lastName'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].lastName ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].lastName:'');
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['lastName'].updateValueAndValidity();
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['sexAtBirth'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].gender ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].gender:'');
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['sexAtBirth'].updateValueAndValidity();
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['dateOfBirth'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].dobStr ? new Date(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].dobStr) : (this.client.clientProfile.Spouses[0].spousesSpouse[i-1].dob) ? new Date(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].dob) : '');
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['dateOfBirth'].updateValueAndValidity();
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['insuranceAmount'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].pia ? Utils.formatToCurrency(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].pia):'');
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['insuranceAmount'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeYears'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeYears ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeYears : '');
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeYears'].setValidators((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeYears) ? [Validators.required, Validators.min(62), Validators.max(70)] : []);         
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeYears'].updateValueAndValidity();
            //(<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeMonths'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeMonths ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeMonths : '');
            //(<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeMonths'].setValidators((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeMonths) ? [Validators.required, Validators.min(0), Validators.max(11)] : []); 
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeMonths'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeMonths) ? (this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeYears == 70) ? 0 : this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeMonths : "");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeMonths'].setValidators((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeMonths) ? [Validators.required, Validators.min(0), Validators.max(((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeYears) ? ((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].expectedClaimAgeYears == 70) ? 0 : 11) : 11))] : []);           
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['expectedClaimAgeMonths'].updateValueAndValidity();
          
            
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['stillAlive'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].alive) ? "Yes" : "No");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['stillAlive'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseLifeExpectancy'].patchValue(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].exSpouseLifeExpectancy || '');
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseLifeExpectancy'].updateValueAndValidity();

            
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['spouseCollectAtTimeOfPassing'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].spouseCollectAtTimeOfPassing) ? "Yes" : "No");
            //(<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['spouseCollectAtTimeOfPassing'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['monthlyBenefitAtPassing'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].monthlyBenefitAtPassing) ? Utils.formatToCurrency(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].monthlyBenefitAtPassing) : "");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['marriedTenOrMoreYears'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].tenyears) ? "Yes" : "No");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['marriedTenOrMoreYears'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseDateOfBirth'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].exSpouseDateOfBirth) ? new Date(this.client.clientProfile.Spouses[0].spousesSpouse[i-1].exSpouseDateOfBirth) : "");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseDateOfBirth'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseClaimAgeYears'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].exSpouseClaimAgeYears : "");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseClaimAgeMonths'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].exSpouseClaimAgeMonths : "");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['exSpouseClaimAgeMonths'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['yearOfStatement'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].yearOfStatement) ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].yearOfStatement : this.currentYear);
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['yearOfStatement'].updateValueAndValidity();

            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['yearAtTimeOfPassing'].patchValue((this.client.clientProfile.Spouses[0].spousesSpouse[i-1].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].spousesSpouse[i-1].yearAtTimeOfPassing : "");
            (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i-1]).controls['yearAtTimeOfPassing'].updateValueAndValidity();

          }
        }

        if(setSpousePrevMarraiges){
          this.applySpouseQuestionnaireForm.controls['previouslyMarried'].patchValue(true);
          this.applySpouseQuestionnaireForm.controls['previouslyMarried'].updateValueAndValidity();
        }
      }

    }

    if(isEditAll){
      if(this.client.clientProfile.HouseholdYearOneIncome){
        this.incomeEntryForm.controls['HouseHoldIncome'].patchValue('');
        this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(this.client.clientProfile.HouseholdYearOneIncome));
        this.incomeEntryForm.controls['YearOneRetirementIncome'].updateValueAndValidity();

        //this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.CurrentIncome)));
        this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(Number(this.client.clientProfile.CurrentIncome) + Number((this.client.clientProfile.Spouses) ? (this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.client.clientProfile.Spouses[0].currentIncome : 0 : 0))));

      } else {
        if (this.client.clientProfile.CurrentIncome) {
          //this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.CurrentIncome)));
          this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(Number(this.client.clientProfile.CurrentIncome) + Number((this.client.clientProfile.Spouses) ? (this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.client.clientProfile.Spouses[0].currentIncome : 0 : 0))));

        }
      }
      if (this.client.clientProfile.IRR) {
        this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue(Utils.formatToPercentage(this.client.clientProfile.IRR));
        this.incomeEntryForm.controls['IncomeReplacementRatio'].updateValueAndValidity();
      }
      
      if (this.client.clientProfile.InflationRate == null) {
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue(Utils.formatToPercentage(3));
        this.incomeEntryForm.controls['IncomeInflationRate'].updateValueAndValidity();
      } else if ((this.client.clientProfile.InflationRate || 0) >= 0) {
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue(Utils.formatToPercentage(this.client.clientProfile.InflationRate || 0));
        this.incomeEntryForm.controls['IncomeInflationRate'].updateValueAndValidity();
      }
      if (this.client.clientProfile.InflationRate == null) {
        this.additinalIncomeForm.controls['InRetInflationRate'].patchValue(Utils.formatToPercentage(2.4));
        this.additinalIncomeForm.controls['InRetInflationRate'].updateValueAndValidity();
      } else if (this.client.clientProfile.InRetirementInflationRate || this.client.clientProfile.InRetirementInflationRate > -5) {
        console.log('this.client.clientProfile.InRetirementInflationRate', this.client.clientProfile.InRetirementInflationRate);
        this.additinalIncomeForm.controls['InRetInflationRate'].patchValue(Utils.formatToPercentage(this.client.clientProfile.InRetirementInflationRate || 0));
        this.additinalIncomeForm.controls['InRetInflationRate'].updateValueAndValidity();
      }
      if (this.client.clientProfile.MAGIPercentIncome) {
        this.additinalIncomeForm.controls['MAGIPerc'].patchValue(Utils.formatToPercentage(this.client.clientProfile.MAGIPercentIncome));
        this.additinalIncomeForm.controls['MAGIPerc'].updateValueAndValidity();
      }
      if (this.client.midRetirementAdj) {
        if (this.client.midRetirementAdj.Year) {
          this.additinalIncomeForm.controls['RetAdjYear'].patchValue(this.client.midRetirementAdj.Year);
          this.additinalIncomeForm.controls['RetAdjYear'].updateValueAndValidity();

          if(this.client.clientProfile.Spouses[0]){
            if(this.client.clientProfile.Spouses[0].setYearAfterSpouse){
              if (this.client.midRetirementAdj.Year == this.getFirstSpouseDeathPlusOne()) {
                this.additinalIncomeForm.controls['setYearAfterSpouseLE'].patchValue(this.client.clientProfile.Spouses[0].setYearAfterSpouse);
                this.boolSetYearAfterSpouse = this.client.clientProfile.Spouses[0].setYearAfterSpouse;
              } else {
                this.additinalIncomeForm.controls['setYearAfterSpouseLE'].patchValue(false);
                this.boolSetYearAfterSpouse = false;
              }
            }
          }
        }
        if (this.client.midRetirementAdj.ReductionDollar != null) {
          this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue(Utils.formatToCurrency(this.client.midRetirementAdj.ReductionDollar));
          this.additinalIncomeForm.controls['RetAdjReductionDollar'].updateValueAndValidity();
        }
        if (this.client.midRetirementAdj.ReductionPerc != null) {
          this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue(Utils.formatToPercentage(this.client.midRetirementAdj.ReductionPerc));
          this.additinalIncomeForm.controls['RetAdjReductionPerc'].updateValueAndValidity();
        }
        if (this.client.midRetirementAdj.IncomeInflationRate || this.client.midRetirementAdj.IncomeInflationRate >= 0) {
          this.additinalIncomeForm.controls['RetAdjReductionInflation'].patchValue(Utils.formatToPercentage(this.client.midRetirementAdj.IncomeInflationRate));
          this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
        }
      }


      //this.getMMTBracket();

      //map Additional Questions too
      let firm = this.client.additionalQuestion ? this.client.additionalQuestion.Firm : '';
      let planSponsor = this.client.additionalQuestion ? this.client.additionalQuestion.PlanSponsor : '';
      let wholeSaler = this.client.additionalQuestion ? this.client.additionalQuestion.Wholesaler : '';
      let sendReportTo = this.client.additionalQuestion ? this.client.additionalQuestion.SendReportTo : '';
      let repName = this.client.additionalQuestion ? this.client.additionalQuestion.RepName : '';
      let meetingReference = this.client.additionalQuestion ? this.client.additionalQuestion.MeetingReference : '';
      let reportRequestFrom = this.client.additionalQuestion ? this.client.additionalQuestion.ReportRequestFrom : '';

      this.additionalQuestionsForm.controls['Firm'].setValue(firm);
      this.additionalQuestionsForm.controls['PlanSponsor'].setValue(planSponsor);
      this.additionalQuestionsForm.controls['Wholesaler'].setValue(wholeSaler);
      this.additionalQuestionsForm.controls['SendReportTo'].setValue(sendReportTo);
      this.additionalQuestionsForm.controls['RepName'].setValue(repName);
      this.additionalQuestionsForm.controls['MeetingReference'].setValue(meetingReference);
      this.additionalQuestionsForm.controls['ReportRequestFrom'].setValue(reportRequestFrom);
    }
    
    let clientAge = this.globalService.calculateAgeV2(this.client.client.DOB);
    console.log('clientAge', clientAge);
    if (clientAge >= 62) {
      if (this.incomeForm.value.isCollectingBenefits == 'true') {
        this.isAlreadyCollectSS = true;
      } else {
        this.isAlreadyCollectSS = false;
      }
    } else {
      this.isAlreadyCollectSS = false;
    }

    let spouseAge = this.client.clientProfile.Spouses[0].dob ? this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob): 0;
    if (spouseAge >= 62) {
      if (this.spouseIncomeForm.value.isCollectingBenefits == 'true') {
        this.isSpouseAlreadyCollectSS = true;
      } else {
        this.isSpouseAlreadyCollectSS = false;
      }

    } else {
      this.isSpouseAlreadyCollectSS = false;
    }

  }

  setInRetWorkEarning(scenario){
    if (scenario == 'client') {
      this.afterRetireWorkMinAge = Number(this.client.clientProfile.RetirementAge) + 1;
      this.afterRetireWorkMinMaxDiff = Number(parseInt(this.client.clientProfile.LifeExpectancy) - this.afterRetireWorkMinAge) + 1;
      this.inRetEarningForm.controls['stopWorkAge'].setValidators([Validators.required, Validators.min(this.client.clientProfile.RetirementAge), Validators.max(parseInt(this.client.clientProfile.LifeExpectancy))]);
      if (this.params == 'socialSecurity') {
        this.inRetEarningForm.controls['stopWorkAge'].patchValue(this.client.clientProfile.InRetStopWorkAge ? this.client.clientProfile.InRetStopWorkAge : '');
        this.inRetEarningForm.controls['stopWorkAge'].updateValueAndValidity();
      }

     }
     if (scenario == 'spouse') {
      this.afterRetireWorkSpouseMinAge = Number(this.client.clientProfile.Spouses[0].retirementAge) + 1;
      this.afterRetireWorkSpouseMinMaxDiff = Number(parseInt(this.client.clientProfile.Spouses[0].LifeExpectancy) - this.afterRetireWorkSpouseMinAge) + 1;
      console.log('this.afterRetireWorkSpouseMinAge', this.afterRetireWorkSpouseMinAge);
      this.inRetSpouseEarningForm.controls['stopWorkAge'].setValidators([Validators.required, Validators.min(this.client.clientProfile.Spouses[0].retirementAge), Validators.max(parseInt(this.client.clientProfile.Spouses[0].LifeExpectancy))]);
     }
  }

  calculateLifeExp(age, gender, i, isClientSpouse, updExSpouseLX: boolean = true) {
    let lifeExpectancy = 0;
    var LEObject;
  
    LEObject = {
      gender: Number(gender),
      age: age,
      healthConditions: {
        HCHBP: 0,
        HCHC: 0,
        HCT2D: 0,
        HCCD: 0,
        HCC: 0,
        HCT: 0,
        HCT1D: 0,
        HCMS: 0,
        HCDCW: 0,
        HCFHDC: 0,
        HCCDYrsDiag: 0,
        HCCYrsDiag: 0,

        HCALZ: 0,
        HCPARK: 0,
        HCAMP: 0,
        HCPTSD: 0,
        HCOBS: 0
      }
    }
    console.log('getLE', LEObject);
    this.globalService.getLE(LEObject)
    .subscribe(
      le => {
        console.log('lifeExpectancy', le);
       let lifeExpect = parseInt(le);
       if (isClientSpouse) {
        if(updExSpouseLX){
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].patchValue(lifeExpect + 1);
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].updateValueAndValidity();
        }
       } else {
        if(updExSpouseLX){
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].patchValue(lifeExpect + 1);
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].updateValueAndValidity();
        }

       }

       // this.calculateAge(this.numberMarraiges.at(i).value.dateOfBirth)
       if (this.numberMarraiges.value.length > 0) {
        const convertAge =   new Date(this.numberMarraiges.at(i).value.dateOfBirth);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        let showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);
        if(!updExSpouseLX && (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value){
          //reset showAge to be entered claim age - if have one          
          showAge = parseInt((<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value) + 1;
        }
 
        this.minAge = Math.min(parseInt(le), showAge);  
        this.maxAge = 100 - this.minAge + 1;
       }
      if (this.numberSpouseMarraiges.value.length > 0) {
        const convertAge =   new Date(this.numberSpouseMarraiges.at(i).value.dateOfBirth);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        let showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);
        if(!updExSpouseLX && (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value){
          //reset showAge to be entered claim age - if have one          
          showAge = (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value;
        }
 
        this.minSpouseAge = Math.min(parseInt(le), showAge);  
        this.maxSpouseAge = 100 - this.minSpouseAge + 1;
        console.log('this.maxSpouseAge', this.maxSpouseAge);
      }

       
      },
      error => console.log(error));

  }
/*
  calculateLifeExp(profileInfo, scenario) {
   
    let lifeExpectancy = 0;
    var LEObject;
  
    LEObject = {
      gender: Number(profileInfo.Gender),
      age: profileInfo.Age,
      healthConditions: {
        HCHBP: profileInfo.HCHBP,
        HCHC: profileInfo.HCHC,
        HCT2D: profileInfo.HCT2D,
        HCCD: profileInfo.HCCD,
        HCC: profileInfo.HCC,
        HCT: profileInfo.HCT,
        HCT1D: profileInfo.HCT1D,
        HCMS: profileInfo.HCMS,
        HCDCW: profileInfo.HCDCW,
        HCFHDC: profileInfo.HCFHDC,
        HCCDYrsDiag: profileInfo.HCCDYrsDiag,
        HCCYrsDiag: profileInfo.HCCYrsDiag
      }
    }
    
    //this will just set/patch the existing form that is set for client or spouse when called
    this.globalService.getLE(LEObject)
      .subscribe(
        le => {
          console.log('le', le);
         lifeExpectancy = parseInt('le')
         if (scenario == 'client') {
          this.afterRetireWorkMinAge = Number(this.client.clientProfile.RetirementAge) + 1;
          this.afterRetireWorkMinMaxDiff = Number(le - this.afterRetireWorkMinAge) + 1;
          this.inRetEarningForm.controls['stopWorkAge'].setValidators([Validators.min(this.client.clientProfile.RetirementAge), Validators.max(lifeExpectancy)]);
          if (this.params == 'socialSecurity') {
            this.inRetEarningForm.controls['stopWorkAge'].patchValue(this.client.clientProfile.InRetStopWorkAge ? this.client.clientProfile.InRetStopWorkAge : '');
            this.inRetEarningForm.controls['stopWorkAge'].updateValueAndValidity();
          }

         }
         if (scenario == 'spouse') {
          this.afterRetireWorkSpouseMinAge = Number(this.client.clientProfile.Spouses[0].retirementAge) + 1;
          this.afterRetireWorkSpouseMinMaxDiff = Number(le - this.afterRetireWorkSpouseMinAge) + 1;
          console.log('this.afterRetireWorkSpouseMinAge', this.afterRetireWorkSpouseMinAge);
          this.inRetSpouseEarningForm.controls['stopWorkAge'].setValidators([Validators.min(this.client.clientProfile.Spouses[0].retirementAge), Validators.max(lifeExpectancy)]);
         }
         
        },
        error => console.log(error));
  }
*/

  getDOBMonth(birthday){
    return new Date(birthday).getMonth() + 1;
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }
  calculateAgeAtMarriage(birthdate, marriageDate) {
    birthdate = new Date(birthdate);
    marriageDate = new Date(marriageDate);
    var diffYear = marriageDate.getFullYear() - birthdate.getFullYear();
    return diffYear
  }
  
  getCurrentAgeByDOB(birthday){
    var dob = new Date(birthday);
    const startYear = new Date();
    var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('age',Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset)));
    return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  getAgeYearAtClaimYear(birthday, claimYear, claimMonth) {
    console.log('birthday', birthday);
    console.log('claimYear', claimYear);
    var dob = new Date(birthday);
    // const startYear = new Date(claimYear);
    // var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('startYear.getFullYear()', claimYear)
    console.log('dob.getFullYear()', dob.getFullYear())
    var ageDiffs = claimYear - dob.getFullYear();
    console.log('ageDiffs', ageDiffs);
    ageDiffs = dob.getMonth() + 1 > claimMonth ? ageDiffs - 1: ageDiffs;
    return ageDiffs;
    // console.log('age',Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (claimMonth + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset)));
    // return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (claimMonth + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  getAgeMonthAtClaimMonth(birthday,claimMonth) {
    var dob = new Date(birthday);
    console.log('dobFull', dob);
    var dobMonth = dob.getMonth() + 1;
    console.log('dobMonth', dobMonth)
    console.log('claimMonth', claimMonth)
    console.log('claimMonth - dobMonth', claimMonth - dobMonth)
    var months = dobMonth > claimMonth ? (12 - dobMonth) + Number(claimMonth) : (claimMonth - dobMonth);
    console.log('months', months)
    return months
  }

  toggleButton() {
    //this.isDepChild = !this.isDepChild;
  }

  changeCollectingBenefits(value, isClient) {
    //console.log('changed benefits to', value);
    const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
    //cant be older than max
    parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
    //cant be younger than min
    || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
    ? {invalidDate: 'Please make sure current monthly benefit is between $' + minAge + ' and $' + maxAge + '.' }  
    : null;

    if(isClient){
      if(value == 'true'){
        if (this.globalService.calculateAgeV2(this.client.client.DOB) >= 62) {
          this.isAlreadyCollectSS = true;
        }        
        console.log('set val to true');
        
        this.incomeForm.get("monthlyBenefits").setValidators([Validators.required, validateBenefits(250, 6000)]);//Validators.min(250), Validators.max(5000)]); 
        //this.incomeForm.controls['monthlyBenefits'].updateValueAndValidity();
        //this.incomeForm.controls['monthlyBenefits'].patchValue('');
        //this.incomeForm.get("monthlyBenefits").clearValidators();

        this.showClientKnownBenefit = false;
        this.incomeForm.controls['monthlyBenefits'].patchValue('');
        this.incomeForm.controls['knownBenefitClaiming'].patchValue('');
        //this.incomeForm.get("knownBenefitClaiming").reset();  
        this.incomeForm.get("knownBenefitClaiming").clearValidators();

        //this.incomeForm.controls['pia'].patchValue('');
        //this.incomeForm.get("pia").reset();  
        this.incomeForm.get("pia").clearValidators();        

        //this.incomeForm.controls['yearOfStatement'].patchValue('');
        //this.incomeForm.get("yearOfStatement").reset();  
        this.incomeForm.get("yearOfStatement").clearValidators();        

        //this.incomeForm.controls['dateOfClaimMonth'].patchValue('');
        this.incomeForm.get("dateOfClaimMonth").setValidators([Validators.required]);

        //this.incomeForm.controls['dateOfClaimYear'].patchValue('');
        this.incomeForm.get("dateOfClaimYear").setValidators([Validators.required]);

        //this.validateKnownBenefitOrPIA(isClient, false);
      } else {
        console.log('false');
        if (this.globalService.calculateAgeV2(this.client.client.DOB) >= 62) {
          this.isAlreadyCollectSS = false;
        }
        //remove validation
        //console.log('im in false');
        //this.incomeForm.get("monthlyBenefits").reset();
        this.incomeForm.controls['knownBenefitClaiming'].patchValue('');
        this.incomeForm.controls['monthlyBenefits'].patchValue('');
        this.incomeForm.get("monthlyBenefits").clearValidators();
        
        var FRA = this.getFRA(new Date(this.client.client.DOB.toString()).getFullYear());
        var birthMonths = this.getAgeMonths(this.client.client.DOB.toString())
        
        if(birthMonths > ((FRA.age * 12) + FRA.month)){
          this.showClientKnownBenefit = true;
          let clientPIAValue = this.incomeForm.value.pia;
          if (!clientPIAValue) {
            this.incomeForm.get("knownBenefitClaiming").setValidators([Validators.required, validateBenefits(0, 4800)]);
          }

        } else {
          this.showClientKnownBenefit = false;

          //this.incomeForm.controls['knownBenefitClaiming'].patchValue('');
          this.incomeForm.get("knownBenefitClaiming").clearValidators();
        }
        if (this.showClientKnownBenefit) {
          console.log('this.incomeForm.value', this.incomeForm.value.knownBenefitClaiming)
          if(!this.incomeForm.value.knownBenefitClaiming){
            this.incomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
          } else {
            this.incomeForm.get("pia").clearValidators(); 
          }
        } else {
          this.incomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
        }

        this.incomeForm.get("yearOfStatement").setValidators([Validators.required, Validators.min(this.currentYear - 5), Validators.max(this.currentYear)]);
       


        //remove value and validation on Date of Claim
        //this.incomeForm.controls['dateOfClaimMonth'].patchValue('');
        this.incomeForm.get("dateOfClaimMonth").clearValidators();
        //this.incomeForm.controls['dateOfClaimYear'].patchValue('');
        this.incomeForm.get("dateOfClaimYear").clearValidators();

        //this.validateKnownBenefitOrPIA(isClient, true);
      }

      this.incomeForm.get("monthlyBenefits").updateValueAndValidity();
      this.incomeForm.get("knownBenefitClaiming").updateValueAndValidity();
      this.incomeForm.get("dateOfClaimMonth").updateValueAndValidity();
      this.incomeForm.get("dateOfClaimYear").updateValueAndValidity();
      this.incomeForm.get("yearOfStatement").updateValueAndValidity();
      this.incomeForm.get("pia").updateValueAndValidity();
    } else {
      if(value == 'true') {
        let spouseAge = this.client.clientProfile.Spouses[0].dob? this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob): 0;
        if (spouseAge >= 62) {
          this.isSpouseAlreadyCollectSS = true;
        }  
        this.spouseIncomeForm.get("monthlyBenefits").setValidators([Validators.required, validateBenefits(250, 5000)]);//Validators.min(250), Validators.max(5000)]);
        this.showSpouseKnownBenefit = false;
        this.spouseIncomeForm.controls['monthlyBenefits'].patchValue('');
        this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue('');
        this.spouseIncomeForm.get("knownBenefitClaiming").clearValidators();

        this.spouseIncomeForm.controls['pia'].patchValue('');
        //this.incomeForm.get("pia").reset();  
        this.spouseIncomeForm.get("pia").clearValidators();        

        //this.incomeForm.controls['yearOfStatement'].patchValue('');
        //this.incomeForm.get("yearOfStatement").reset();  
        this.spouseIncomeForm.get("yearOfStatement").clearValidators();        

        //this.incomeForm.controls['dateOfClaimMonth'].patchValue('');
        this.spouseIncomeForm.get("dateOfClaimMonth").setValidators([Validators.required]);

        //this.incomeForm.controls['dateOfClaimYear'].patchValue('');
        this.spouseIncomeForm.get("dateOfClaimYear").setValidators([Validators.required]);

        //this.validateKnownBenefitOrPIA(isClient, false);
      } else {
        let spouseAge = this.client.clientProfile.Spouses[0].dob? this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob): 0;
        if (spouseAge >= 62) {
          this.isSpouseAlreadyCollectSS = false;
        } 
        //remove validation
        //console.log('im in false');
        //this.spouseIncomeForm.get("monthlyBenefits").reset();
        this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue('');
        this.spouseIncomeForm.controls['pia'].patchValue('');
        this.spouseIncomeForm.controls['monthlyBenefits'].patchValue('');
        this.spouseIncomeForm.get("monthlyBenefits").clearValidators();

        this.spouseIncomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
        this.spouseIncomeForm.get("yearOfStatement").setValidators([Validators.required, Validators.min(this.currentYear - 5), Validators.max(this.currentYear)]);

        var FRA = this.getFRA(new Date(this.client.clientProfile.Spouses[0].dob.toString()).getFullYear());
        var birthMonths = this.getAgeMonths(this.client.clientProfile.Spouses[0].dob.toString())
        if (birthMonths > ((FRA.age * 12) + FRA.month)){
          this.showSpouseKnownBenefit = true;
          let spousePIAValue = this.spouseIncomeForm.value.pia;
          console.log('spousePIAValue', spousePIAValue);
          if (!spousePIAValue) {
            this.spouseIncomeForm.get("knownBenefitClaiming").setValidators([Validators.required, validateBenefits(0, 4800)]);
          }
        } else {
          this.showSpouseKnownBenefit = false;

          //this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue('');
          this.spouseIncomeForm.get("knownBenefitClaiming").clearValidators();
        }

        //remove value and validation on Date of Claim
        //this.spouseIncomeForm.controls['dateOfClaimMonth'].patchValue('');
        this.spouseIncomeForm.get("dateOfClaimMonth").clearValidators();
        //this.spouseIncomeForm.controls['dateOfClaimYear'].patchValue('');
        this.spouseIncomeForm.get("dateOfClaimYear").clearValidators();

        //this.validateKnownBenefitOrPIA(isClient, true);
      }

      this.spouseIncomeForm.get("monthlyBenefits").updateValueAndValidity();
      this.spouseIncomeForm.get("knownBenefitClaiming").updateValueAndValidity();
      this.spouseIncomeForm.get("dateOfClaimMonth").updateValueAndValidity();
      this.spouseIncomeForm.get("dateOfClaimYear").updateValueAndValidity();
      this.spouseIncomeForm.get("yearOfStatement").updateValueAndValidity();
      this.spouseIncomeForm.get("pia").updateValueAndValidity();
    }
  }
  
  selectOptions(scenario) {
    if (scenario == 'currentIncome') {

      this.incomeOptionOneSelection();

    } else {

      this.isOptionCurrentIncome = false;
      this.incomeEntryForm.get("YearOneRetirementIncome").setValidators([Validators.required]);

      this.incomeEntryForm.get("YearOneRetirementIncome").updateValueAndValidity();

      //reset the IIR and IRR if empty to defaulted values from form
      if(!this.incomeEntryForm.value.IncomeInflationRate || this.incomeEntryForm.get('IncomeInflationRate').errors){
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue('3.00%');
      }

      if(!this.incomeEntryForm.value.IncomeReplacementRatio || this.incomeEntryForm.get('IncomeReplacementRatio').errors){
        this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue('75%');
      }

      //set the year one value with new set values above
      //household income at yr 1 of retirement = current income * (1 + income inflation rate) ^ (retirement year - current year + 1) * IRR
      
      let firstRetireeYears = Math.max(0, (new Date(this.client.client.DOB).getFullYear() + this.client.clientProfile.RetirementAge) - new Date().getFullYear());
      if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married')
        firstRetireeYears = Math.min((new Date(this.client.clientProfile.Spouses[0].dob).getFullYear() + this.client.clientProfile.Spouses[0].retirementAge) - new Date().getFullYear())
      
      this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(
        Utils.formatToCurrency(Math.round(Utils.removeCurrencyFormatting(this.incomeEntryForm.value.HouseHoldIncome) * Math.pow(1 + (Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate) / 100), Math.max(0, firstRetireeYears - 1)) * (Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio) / 100)))
      );

      //this.incomeEntryForm.get("HouseHoldIncome").reset();
      //this.incomeEntryForm.get("IncomeInflationRate").reset();
      //this.incomeEntryForm.get("IncomeReplacementRatio").reset();

      //this.incomeEntryForm.get("HouseHoldIncome").clearValidators();
      //this.incomeEntryForm.get("IncomeInflationRate").clearValidators();
      //this.incomeEntryForm.get("IncomeReplacementRatio").clearValidators();

      this.incomeEntryForm.get("HouseHoldIncome").updateValueAndValidity();
      this.incomeEntryForm.get("IncomeInflationRate").updateValueAndValidity();
      this.incomeEntryForm.get("IncomeReplacementRatio").updateValueAndValidity();
    }
  }

  incomeOptionOneSelection() {
    this.isOptionCurrentIncome = true;
    //this.incomeEntryForm.get("HouseHoldIncome").setValidators([Validators.required]);
    //this.incomeEntryForm.get("IncomeInflationRate").setValidators([Validators.required]);
    //this.incomeEntryForm.get("IncomeReplacementRatio").setValidators([Validators.required]);
    
    this.incomeEntryForm.get("HouseHoldIncome").updateValueAndValidity();
    this.incomeEntryForm.get("IncomeInflationRate").updateValueAndValidity();
    this.incomeEntryForm.get("IncomeReplacementRatio").updateValueAndValidity();

    this.incomeEntryForm.get("YearOneRetirementIncome").reset();

    this.incomeEntryForm.get("YearOneRetirementIncome").clearValidators();

    this.incomeEntryForm.get("YearOneRetirementIncome").updateValueAndValidity();
  }

  previous(scenario) {
    console.log('scenario', scenario);
    this.resetFormBooleanValue();
    let isSpouse = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;
    console.log('where am i', scenario);
    if (scenario == 'applySixtyPlusForm') {
      this.router.navigate(['/clients/edit'])
    }
    if (scenario == 'applyIncomeForm') {
      if (this.params == 'income' || this.params == 'empty') {
        this.router.navigate(['/clients/edit'])
      } else {
        if (this.isSixtyPlus) {
          this.isApplySixtyPlus = true;
          this.isApplyIncome = false;
        } else {
          this.router.navigate(['/clients/edit'])
        }
      }


    }
    if (scenario == 'applyQuestionnaireForm') {
      //this.router.navigate(['/clients/edit'])
      this.isApplyIncome = true;
    }
    if (scenario == 'applyIncomeFormSpouse') {
      //this.router.navigate(['/clients/edit'])

      this.isClient = true;
      this.isSpouse = false;
      this.isPreviousMarriages = this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
      this.isDesiredClaimAge = !this.isPreviousMarriages && this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB) < 70  ? true: false;
      this.isInRetEarning = !this.isPreviousMarriages && !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.partTimeWork ? true : false;
      this.isPension = !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && this.applyQuestionnaireForm.value.havePension ? true : false;
      this.isChildren = !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && !this.isPension && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
      let isCollectedBenefit = (this.incomeForm.value.isCollectingBenefits == 'true' && this.isAlreadyCollectSS) ? true : false;
      if(!this.isPreviousMarriages && (!this.isDesiredClaimAge || (this.isDesiredClaimAge && isCollectedBenefit)) && !this.isInRetEarning && !this.isChildren && !this.isPension) {
        this.isApplyQuestionnaire = true;
      } else {
        if(this.isPreviousMarriages){
          this.isPreviousMarriages = false;
          this.valuePreviousMarriage = this.numberMarraiges.length - 1;
          this.isExSpouse = true;          
        }
      }
    }
    if(scenario == 'incomeEntryForm'){
      this.isIncomeEnter = false;

      if(isSpouse){
        console.log('incomeEntry as spouste');
        this.isSpouse = true;
        this.isSpousePreviousMarriages = this.applySpouseQuestionnaireForm.value.previouslyMarried ? true : false;
        this.isSpouseDesiredClaimAge = !this.isSpousePreviousMarriages && this.applyQuestionnaireForm.value.alreadySSCollected || this.applySpouseQuestionnaireForm.value.desiredClaimAge && (this.spouseIncomeForm.value.isCollectingBenefits == 'false' || !this.isSpouseAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70 ? true : false;
        this.isSpouseInRetEarning = !this.isSpousePreviousMarriages && !this.isSpouseDesiredClaimAge && this.applySpouseQuestionnaireForm.value.partTimeWork ? true : false;
        this.isSpousePension = !this.isSpousePreviousMarriages && !this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && this.applySpouseQuestionnaireForm.value.havePension ? true : false;
        this.isSpouseChildren = !this.isSpousePreviousMarriages && !this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && !this.isSpousePension && this.applySpouseQuestionnaireForm.value.haveDepChild ? true : false;
        let isCollectedBenefit = (this.spouseIncomeForm.value.isCollectingBenefits == 'true' && this.isSpouseAlreadyCollectSS) ? true : false;
        if(!this.isSpouseInRetEarning && !this.isSpouseChildren && !this.isSpousePension && !this.isSpousePreviousMarriages && (!this.isSpouseDesiredClaimAge || (this.isSpouseDesiredClaimAge && isCollectedBenefit))) {
          console.log('make here 3');
          this.isSpouseApplyQuestionnaire = true;
        } else {
          console.log('make here 1');
          if(this.isSpousePreviousMarriages){
            console.log('make here 2');

            this.isSpousePreviousMarriages = false;
            this.valueSpousePreviousMarriage = this.numberSpouseMarraiges.length - 1;
            this.isSpouseExSpouse = true;          
            this.isSpouse = true;
          }
        }

      } else {
        //this.isExSpouse = true;
        console.log('incomeEntry as client');

        this.isClient = true;
        this.isSpouse = false;
        this.isExSpouse = false;
        this.isPreviousMarriages = !this.isExSpouse && this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
        this.isDesiredClaimAge = !this.isExSpouse && !this.isPreviousMarriages && this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB) ? true: false;
        this.isInRetEarning = !this.isExSpouse && !this.isPreviousMarriages && !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.partTimeWork ? true : false;
        this.isPension = !this.isExSpouse && !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && this.applyQuestionnaireForm.value.havePension ? true : false;
        this.isChildren = !this.isExSpouse && !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && !this.isPension && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
        let isCollectedBenefit = (this.incomeForm.value.isCollectingBenefits == 'true' && this.isAlreadyCollectSS) ? true : false;
        //this.isExSpouse = !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && !this.isPension && !this.isChildren && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
        if(!this.isPreviousMarriages && (!this.isDesiredClaimAge || (this.isDesiredClaimAge && isCollectedBenefit)) && !this.isInRetEarning && !this.isChildren && !this.isPension) {
          this.isApplyQuestionnaire = true;
        } else {
          if(this.isPreviousMarriages){
            this.isPreviousMarriages = false;
            this.valuePreviousMarriage = this.numberMarraiges.length - 1;
            this.isExSpouse = true;          
          }
        }
      }
    }

    if (scenario == 'additinalIncomeForm') {
      this.isIncomeEnter = true;
      this.isAdditionalIncome = false;
    }

    if (scenario == 'additionalQuestionsForm') {
      //this.isMAGIProjection = true;
      this.isAdditionalIncome = true;
      this.isAdditionalQuestion = false;
    }

    if (scenario == 'applyQuestionnaireFormSpouse') {
      //this.router.navigate(['/clients/edit'])
      //this.isSpouseApplyIncome = true;
    }
    if (scenario == 'magiProjectionForm') {
      this.isMAGIProjection = false;
      this.isAdditionalIncome = true;
    }

    if (scenario == 'haveChildrenForm') {
      this.isApplyQuestionnaire = true;
    }
    if (scenario == 'pensionForm') {
      this.isChildren = this.applyQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isChildren) {
        this.isApplyQuestionnaire = true;
      }
    }
    if (scenario == 'inRetEarningForm') {
      this.isPension = this.applyQuestionnaireForm.value.havePension ? true : false;
      this.isChildren = !this.isPension && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isChildren && !this.isPension) {
        this.isApplyQuestionnaire = true;
      }
    }
    if (scenario == 'desiredClaimForm') {
      this.isInRetEarning = this.applyQuestionnaireForm.value.partTimeWork ? true : false;
      this.isPension = !this.isInRetEarning && this.applyQuestionnaireForm.value.havePension ? true : false;
      this.isChildren = !this.isInRetEarning && !this.isPension && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isInRetEarning && !this.isChildren && !this.isPension) {
        this.isApplyQuestionnaire = true;
      }
    }
    if (scenario == 'prevMarraigesForm') {
      this.isDesiredClaimAge = this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB)  ? true: false;
      this.isInRetEarning = !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.partTimeWork ? true : false;
      this.isPension = !this.isDesiredClaimAge && !this.isInRetEarning && this.applyQuestionnaireForm.value.havePension ? true : false;
      this.isChildren = !this.isDesiredClaimAge && !this.isInRetEarning && !this.isPension && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isDesiredClaimAge && !this.isInRetEarning && !this.isChildren && !this.isPension) {
        this.isApplyQuestionnaire = true;
      }
    }
    if (scenario == 'numberMarriagesForm') {
      if (this.valuePreviousMarriage > 0) {
        this.valuePreviousMarriage -= 1;
        this.isExSpouse = true;
      } else {
        this.isExSpouse = false;
        this.isPreviousMarriages = this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
        this.isDesiredClaimAge = !this.isPreviousMarriages && this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB)  ? true: false;
        this.isInRetEarning = !this.isPreviousMarriages && !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.partTimeWork ? true : false;
        this.isPension = !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && this.applyQuestionnaireForm.value.havePension ? true : false;
        this.isChildren = !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && !this.isPension && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
        if(!this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && !this.isChildren && !this.isPension) {
          this.isApplyQuestionnaire = true;
        }
      }
    }
    if (scenario == 'applySpouseQuestionnaireForm') {
      /* this.isClient = true;
      this.isSpouse = false;
      this.isPreviousMarriages = this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
      this.isDesiredClaimAge = !this.isPreviousMarriages && this.applyQuestionnaireForm.value.desiredClaimAge ? true: false;
      this.isInRetEarning = !this.isPreviousMarriages && !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.partTimeWork ? true : false;
      this.isPension = !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && this.applyQuestionnaireForm.value.havePension ? true : false;
      this.isChildren = !this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && !this.isPension && this.applyQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isPreviousMarriages && !this.isDesiredClaimAge && !this.isInRetEarning && !this.isChildren && !this.isPension) {
        this.isApplyQuestionnaire = true;
      } */

      let clientCurrentIncome = this.incomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome): 0;
      let spouseMaxIncome = clientCurrentIncome > 0 ? 5000000 - clientCurrentIncome: 5000000;
      this.spouseIncomeForm.controls['currentIncome'].setValidators([Validators.required, Validators.max(spouseMaxIncome)]);
      this.spouseMaxIncome = Utils.formatToCurrency(spouseMaxIncome);
      this.isSpouseApplyIncome = true;
    }
    if (scenario == 'haveSpouseChildrenForm') {
      this.isSpouseApplyQuestionnaire = true;
    }
    if (scenario == 'pensionSpouseForm') {
      this.isSpouseChildren = this.applySpouseQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isSpouseChildren) {
        this.isSpouseApplyQuestionnaire = true;
      }
    }
    if (scenario == 'inRetSpouseEarningForm') {
      this.isSpousePension = this.applySpouseQuestionnaireForm.value.havePension ? true : false;
      this.isSpouseChildren = !this.isSpousePension && this.applySpouseQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isSpouseChildren && !this.isSpousePension) {
        this.isSpouseApplyQuestionnaire = true;
      }
    }
    if (scenario == 'desiredSpouseClaimForm') {
      this.isSpouseInRetEarning = this.applySpouseQuestionnaireForm.value.partTimeWork ? true : false;
      this.isSpousePension = !this.isSpouseInRetEarning && this.applySpouseQuestionnaireForm.value.havePension ? true : false;
      this.isSpouseChildren = !this.isSpouseInRetEarning && !this.isSpousePension && this.applySpouseQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isSpouseInRetEarning && !this.isSpouseChildren && !this.isSpousePension) {
        this.isSpouseApplyQuestionnaire = true;
      }
    }
    if (scenario == 'prevSpouseMarraigesForm') {
      this.isSpouseDesiredClaimAge = this.applySpouseQuestionnaireForm.value.desiredClaimAge  && (this.spouseIncomeForm.value.isCollectingBenefits == 'false' || !this.isSpouseAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70  ? true: false;
      this.isSpouseInRetEarning = !this.isSpouseDesiredClaimAge && this.applySpouseQuestionnaireForm.value.partTimeWork ? true : false;
      this.isSpousePension = !this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && this.applySpouseQuestionnaireForm.value.havePension ? true : false;
      this.isSpouseChildren = !this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && !this.isSpousePension && this.applySpouseQuestionnaireForm.value.haveDepChild ? true : false;
      if(!this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && !this.isSpouseChildren && !this.isSpousePension) {
        this.isSpouseApplyQuestionnaire = true;
      }
    }
    if (scenario == 'numberSpouseMarriagesForm') {
      if (this.valueSpousePreviousMarriage > 0) {
        this.valueSpousePreviousMarriage -= 1;
        this.isSpouseExSpouse = true;
      } else {
        this.isSpouseExSpouse = false;
        this.isSpousePreviousMarriages = this.applySpouseQuestionnaireForm.value.previouslyMarried ? true : false;
        this.isSpouseDesiredClaimAge = !this.isSpousePreviousMarriages && this.applySpouseQuestionnaireForm.value.desiredClaimAge  && (this.spouseIncomeForm.value.isCollectingBenefits == 'false' || !this.isSpouseAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70 ? true: false;
        this.isSpouseInRetEarning = !this.isSpousePreviousMarriages && !this.isSpouseDesiredClaimAge && this.applySpouseQuestionnaireForm.value.partTimeWork ? true : false;
        this.isSpousePension = !this.isSpousePreviousMarriages && !this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && this.applySpouseQuestionnaireForm.value.havePension ? true : false;
        this.isSpouseChildren = !this.isSpousePreviousMarriages && !this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && !this.isSpousePension && this.applySpouseQuestionnaireForm.value.haveDepChild ? true : false;
        if(!this.isSpousePreviousMarriages && !this.isSpouseDesiredClaimAge && !this.isSpouseInRetEarning && !this.isSpouseChildren && !this.isSpousePension) {
          this.isSpouseApplyQuestionnaire = true;
        }
      }
    }

  }

  annualIncomechangePopUp() {
    const dialogRef = this.dialog.open(BasicQuestionComponent, {     
      data: { title: 'Notification!', 
      btnYesTitle: 'I Understand',
      question: "The Current Annual Income provided does not match income information previously assigned to this profile. Changes made here will override previous profile inputs." }
    });
  }

  next(scenario) {
    console.log('scenario', scenario);
    this.resetFormBooleanValue();
    let isSpouse = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;
    if (scenario == 'applySixtyPlusForm') {
      this.isApplySixtyPlus = false;
      this.isApplyIncome = true;
    }
    if(scenario == 'applyIncomeForm'){
      this.isApplyIncome = false;
      this.isApplyQuestionnaire = true;
      if (this.client.clientProfile.Spouses[0].maritalStatus != 'Married') {
        let houseHoldIncome = this.incomeForm.value.currentIncome;
        this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(houseHoldIncome);
      }
      if (this.incomeEntryForm.value.IncomeReplacementRatio || this.incomeEntryForm.value.YearOneRetirementIncome) {
        //this.isOptionCurrentIncome = (this.incomeEntryForm.value.IncomeReplacementRatio) ? (Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio) > 0) ? true : false : false;
        this.isOptionCurrentIncome = this.incomeEntryForm.value.HouseholdYearOneIncome ? ((this.incomeEntryForm.value.HouseholdYearOneIncome > 0) ? false : true) : true;
      } else {
        this.incomeOptionOneSelection();
      }
    }

    if(scenario == 'applyIncomeFormSpouse'){
      let houseHoldIncome = Utils.formatToCurrency(Number(Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome)) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.currentIncome) : 0));
      this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(houseHoldIncome);
      this.isSpouseApplyIncome = false;
      this.isSpouseApplyQuestionnaire = true;
      //this.isSpouse = true;
    }
    
    if (scenario == 'applyQuestionnaireForm') {
      this.isChildren = this.applyQuestionnaireForm.value.haveDepChild ? true : false;
      this.isPension = !this.isChildren && this.applyQuestionnaireForm.value.havePension ? true : false;
      console.log('this.isPension', this.isPension)
      this.isInRetEarning = !this.isChildren && !this.isPension && this.applyQuestionnaireForm.value.partTimeWork ? true : false;
      console.log('this.isInRetEarning', this.isInRetEarning )
      console.log('this.applyQuestionnaireForm.value.desiredClaimAge',this.applyQuestionnaireForm.value.desiredClaimAge )
      console.log('this.incomeForm.value.isCollectingBenefits', this.incomeForm.value.isCollectingBenefits)
      console.log('this.isAlreadyCollectSS', this.isAlreadyCollectSS)
      this.isDesiredClaimAge = !this.isChildren && !this.isPension && !this.isInRetEarning && this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB) ? true: false;
      this.isPreviousMarriages = !this.isChildren && !this.isPension && !this.isInRetEarning && !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
      let isCollectedBenefit = (this.incomeForm.value.isCollectingBenefits == 'true' && this.isAlreadyCollectSS) ? true : false;      
      console.log('this.calculateAge(this.client.client.DOB)', this.globalService.calculateAgeV2(this.client.client.DOB) );
      console.log('this.isDesiredClaimAge', this.isDesiredClaimAge)
      if (!this.isChildren && !this.isPension && !this.isInRetEarning && (!this.isDesiredClaimAge || (this.isDesiredClaimAge && isCollectedBenefit)) && !this.isPreviousMarriages) {
        this.enableSpouse(isSpouse);
        
      }
    }

    if(scenario == 'incomeEntryForm'){
      this.isIncomeEnter = false;
      this.isAdditionalIncome = true;
      this.isSpouse = false;
      
      // this.getMMTBracket();
    }

    if (scenario == 'additionalQuestionsForm') {
      console.log('saved spouse obj 00', this.client.clientProfile.Spouses);
      this.updateClientProfileWithSSQuestionnaire();
    }

    if (scenario == 'Select') {
      //this.isIncomeRangeSelection = true;
      //this.isOptionEnter = false;
      this.isMAGIUpdate = false;
    }
    if (scenario == 'Enter') {
      this.isIncomeEnter = true;
      //this.isOptionEnter = true;
    }

    if (scenario == 'additinalIncomeForm') {
      //this.isMAGIProjection = true;
      this.isAdditionalIncome = false;
      this.isAdditionalQuestion = true;

      this.getMMTBracket();
    }
    if (scenario == 'magiProjectionForm') {
      if(this.params == 'income'){
        this.updateClientProfileWithSSQuestionnaire();
      } else {
        this.isAdditionalQuestion = true;
        this.isMAGIProjection = false;
      }
    }

    if (scenario == 'haveChildrenForm') {
      this.isPension = this.applyQuestionnaireForm.value.havePension ? true : false;
      this.isInRetEarning = !this.isPension && this.applyQuestionnaireForm.value.partTimeWork ? true : false;
      this.isDesiredClaimAge = !this.isPension && !this.isInRetEarning && this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB) ? true: false;
      this.isPreviousMarriages = !this.isPension && !this.isInRetEarning && !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
      if (!this.isPension && !this.isInRetEarning && !this.isDesiredClaimAge && !this.isPreviousMarriages) {
        this.enableSpouse(isSpouse);
      }
    }
    if (scenario == 'pensionForm') {
      this.isInRetEarning = this.applyQuestionnaireForm.value.partTimeWork ? true : false;
      this.isDesiredClaimAge = !this.isInRetEarning && this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB) ? true: false;
      this.isPreviousMarriages = !this.isInRetEarning && !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
      if (!this.isInRetEarning && !this.isDesiredClaimAge && !this.isPreviousMarriages) {
        this.enableSpouse(isSpouse);
      }
    }
    if (scenario == 'inRetEarningForm') {
      this.isDesiredClaimAge = this.applyQuestionnaireForm.value.desiredClaimAge && (this.incomeForm.value.isCollectingBenefits == 'false' || !this.isAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.client.DOB) ? true: false;
      this.isPreviousMarriages = !this.isDesiredClaimAge && this.applyQuestionnaireForm.value.previouslyMarried  ? true : false;
      console.log('isDesiredClaimAge',this.isDesiredClaimAge)
      console.log('isPreviousMarriages',this.isPreviousMarriages)
      if (!this.isDesiredClaimAge && !this.isPreviousMarriages) {
        this.enableSpouse(isSpouse);
      }
    }
    if (scenario == 'desiredClaimForm') {
      console.log('desiredClaimForm 00');
      this.isPreviousMarriages = this.applyQuestionnaireForm.value.previouslyMarried ? true : false;
      if (!this.isPreviousMarriages) {
        this.enableSpouse(isSpouse);
      } 
    }
    if (scenario == 'prevMarraigesForm') {
      console.log(this.valuePreviousMarriage);
      console.log('my ex spouse', this.numberMarraiges);

      //added to calc LX for LX dropdown if expouse has DOB
      if(this.numberMarraiges.at(this.valuePreviousMarriage).value.dateOfBirth){
        if(this.numberMarraiges.at(this.valuePreviousMarriage).value.prevMarriageTypes != 'Widowed'){
          this.calculateLifeExp(this.globalService.calculateAgeV2(this.numberMarraiges.at(this.valuePreviousMarriage).value.dateOfBirth), 
            this.numberMarraiges.at(this.valuePreviousMarriage).value.sexAtBirth, 
            (this.valuePreviousMarriage), 
            true,
            false); //dont just auto update LX 
        }

        if(this.numberMarraiges.at(this.valuePreviousMarriage).value.spouseCollectAtTimeOfPassing
          && this.numberMarraiges.at(this.valuePreviousMarriage).value.prevMarriageTypes == 'Widowed'){
          
          if(this.numberMarraiges.at(this.valuePreviousMarriage).value.spouseCollectAtTimeOfPassing == 'Yes'){
            //readjust Claim Age validation to not be greater than LX
            //ex: (year of passing) - (DOB year) < (claim age)
            var dobYear = new Date(this.numberMarraiges.at(this.valuePreviousMarriage).value.exSpouseDateOfBirth).getFullYear();            
            var ageAtPass = (parseInt(this.numberMarraiges.at(this.valuePreviousMarriage).value.yearAtTimeOfPassing) - dobYear);

            if(ageAtPass < this.numberMarraiges.at(this.valuePreviousMarriage).value.exSpouseClaimAgeYears){
                //if in here, reset validation on the max for claim age
                //console.log('widow in here 3');
                (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeYears'].patchValue(ageAtPass);
                (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeYears'].setValidators(Validators.required, Validators.min(62), Validators.max(ageAtPass));
                (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();
            }
          }
        }
      }

      this.isExSpouse = true;
    }
    if (scenario == 'numberMarriagesForm') {
      //this.isClient = false;
      if (this.valuePreviousMarriage < (this.numberMarraiges.length - 1)) {
        this.valuePreviousMarriage += 1;
        // this.updateDynamicFormArrayValidation();
        this.isExSpouse = true;
      } else {
        this.isExSpouse = false;
        this.isSpouse = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;
        if (this.isSpouse) {
          this.isClient = false;
          //this.isSpouseApplyQuestionnaire = true;
          let clientCurrentIncome = this.incomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome): 0;
          let spouseMaxIncome = clientCurrentIncome > 0 ? 5000000 - clientCurrentIncome: 5000000;
          this.spouseIncomeForm.controls['currentIncome'].setValidators([Validators.required, Validators.max(spouseMaxIncome)]);
          this.spouseMaxIncome = Utils.formatToCurrency(spouseMaxIncome);
          this.isSpouseApplyIncome = true;
        } else {
          //this.isClient = true;
          this.isClient = false;
          this.isSpouse = false;
          if(this.params == 'editAll' || this.params == ''){
            this.isIncomeEnter = true;
            if (this.client.clientProfile.HouseholdYearOneIncome) {
              this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.HouseholdYearOneIncome)));
            } else {
              this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
            }
          } else {
            this.isIncomeEnter = true;
            // this.updateClientProfileWithSSQuestionnaire();
          }
        }
      }
    }
    if (scenario == 'applySpouseQuestionnaireForm') {
      this.isSpouseChildren = this.applySpouseQuestionnaireForm.value.haveDepChild ? true : false;
      this.isSpousePension = !this.isSpouseChildren && this.applySpouseQuestionnaireForm.value.havePension ? true : false;
      this.isSpouseInRetEarning = !this.isSpouseChildren && !this.isSpousePension && this.applySpouseQuestionnaireForm.value.partTimeWork ? true : false;      
      this.isSpouseDesiredClaimAge = !this.isSpouseChildren && !this.isSpousePension && !this.isSpouseInRetEarning && this.applySpouseQuestionnaireForm.value.desiredClaimAge && (this.spouseIncomeForm.value.isCollectingBenefits == 'false' || !this.isSpouseAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70 ? true : false;
      console.log('this.isSpouseDesiredClaimAge', this.isSpouseDesiredClaimAge);
      this.isSpousePreviousMarriages = !this.isSpouseChildren && !this.isSpousePension && !this.isSpouseInRetEarning && !this.isSpouseDesiredClaimAge && this.applySpouseQuestionnaireForm.value.previouslyMarried ? true : false;
      let isSpouseCollectedBenefit = (this.spouseIncomeForm.value.isCollectingBenefits == 'true' && this.isSpouseAlreadyCollectSS) ? true : false;
      if (!this.isSpouseChildren && !this.isSpousePension && !this.isSpouseInRetEarning && !this.isSpousePreviousMarriages && (!this.isSpouseDesiredClaimAge || (this.isSpouseDesiredClaimAge && isSpouseCollectedBenefit))) {
        if(this.params == 'editAll' || this.params == '') {
          console.log('here 01')
          this.isIncomeEnter = true;
          console.log('this.isHCFilledBefore', this.isHCFilledBefore, this.isSSFilled , this.previousIncome, this.incomeEntryForm.value.HouseHoldIncome)
          let clientCurrentIncome = this.incomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome): 0;
          let spouseCurrentIncome = this.spouseIncomeForm.value.currentIncome && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.currentIncome): 0;
          let houseHoldIncome = Number(clientCurrentIncome) + Number(spouseCurrentIncome);
          console.log('houseHoldIncome', houseHoldIncome);
          console.log('this.previousIncome', this.previousIncome);
          console.log('houseHoldIncome', houseHoldIncome);
          if (this.isHCFilledBefore && !this.isSSFilled && this.previousIncome != houseHoldIncome) {
            console.log('here 02')
            this.annualIncomechangePopUp();
          }
          if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.HouseholdYearOneIncome)));
          } else {
            this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
          }
        } else {
          this.isIncomeEnter = true;
          // this.updateClientProfileWithSSQuestionnaire();
        }
      }
    }
    if (scenario == 'haveSpouseChildrenForm') {
      this.isSpousePension = this.applySpouseQuestionnaireForm.value.havePension ? true : false;
      this.isSpouseInRetEarning = !this.isSpousePension && this.applySpouseQuestionnaireForm.value.partTimeWork ? true : false;
      this.isSpouseDesiredClaimAge = !this.isSpousePension && !this.isSpouseInRetEarning && this.applySpouseQuestionnaireForm.value.desiredClaimAge  && (this.spouseIncomeForm.value.isCollectingBenefits == 'false' || !this.isSpouseAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70 ? true: false;
      this.isSpousePreviousMarriages = !this.isSpousePension && !this.isSpouseInRetEarning && !this.isSpouseDesiredClaimAge && this.applySpouseQuestionnaireForm.value.previouslyMarried ? true : false;
      if (!this.isSpousePension && !this.isSpouseInRetEarning && !this.isSpouseDesiredClaimAge && !this.isSpousePreviousMarriages) {
        //this.updateClientProfileWithSSQuestionnaire();
        if(this.params == 'editAll' || this.params == ''){
          this.isIncomeEnter = true;
          if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.HouseholdYearOneIncome)));
          } else {
            this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
          }
        } else {
          this.isIncomeEnter = true;
          // this.updateClientProfileWithSSQuestionnaire();
        }
      }
    }
    if (scenario == 'pensionSpouseForm') {
      this.isSpouseInRetEarning = this.applySpouseQuestionnaireForm.value.partTimeWork ? true : false;
      this.isSpouseDesiredClaimAge = !this.isSpouseInRetEarning && this.applySpouseQuestionnaireForm.value.desiredClaimAge  && (this.spouseIncomeForm.value.isCollectingBenefits == 'false' || !this.isSpouseAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70  ? true: false;
      this.isSpousePreviousMarriages = !this.isSpouseInRetEarning && !this.isSpouseDesiredClaimAge && this.applySpouseQuestionnaireForm.value.previouslyMarried ? true : false;
      if (!this.isSpouseInRetEarning && !this.isSpouseDesiredClaimAge && !this.isSpousePreviousMarriages) {
        //this.updateClientProfileWithSSQuestionnaire();
        if(this.params == 'editAll' || this.params == ''){
          this.isIncomeEnter = true;
          if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.HouseholdYearOneIncome)));
          } else {
            this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
          }
        } else {
          this.isIncomeEnter = true;
          // this.updateClientProfileWithSSQuestionnaire();
        }
      }
    }
    if (scenario == 'inRetSpouseEarningForm') {
      this.isSpouseDesiredClaimAge = this.applySpouseQuestionnaireForm.value.desiredClaimAge  && (this.spouseIncomeForm.value.isCollectingBenefits == 'false' || !this.isSpouseAlreadyCollectSS) && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70 ? true: false;
      if (!this.isSpouseDesiredClaimAge) {
        //this.updateClientProfileWithSSQuestionnaire();
        if(this.params == 'editAll' || this.params == ''){
          this.isIncomeEnter = true;
          if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.HouseholdYearOneIncome)));
          } else {
            this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
          }
        } else {
          this.isIncomeEnter = true;
          // this.updateClientProfileWithSSQuestionnaire();
        }
      }
    }
    if (scenario == 'desiredSpouseClaimForm') {
      this.isSpousePreviousMarriages = this.applySpouseQuestionnaireForm.value.previouslyMarried ? true : false;
      if(!this.isSpousePreviousMarriages){
        //this.updateClientProfileWithSSQuestionnaire();
        if(this.params == 'editAll' || this.params == ''){
          this.isIncomeEnter = true;
          if (this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.HouseholdYearOneIncome)));
          } else {
            this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
          }
        } else {
          this.isIncomeEnter = true;
          // this.updateClientProfileWithSSQuestionnaire();
        }
      }
    }
    if (scenario == 'prevSpouseMarraigesForm') {
      //console.log(this.valuePreviousMarriage);
      this.isSpousePreviousMarriages = false;

      //added to calc LX for LX dropdown if expouse has DOB
      if((<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).value.dateOfBirth){
        this.calculateLifeExp(this.globalService.calculateAgeV2((<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).value.dateOfBirth), 
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).value.sexAtBirth, 
        (this.valueSpousePreviousMarriage), 
        false,
        false); //dont just auto update LX 
      }

      this.isSpouseExSpouse = true;
    }
    if (scenario == 'numberSpouseMarriagesForm') {
      //this.isClient = false;
      if (this.valueSpousePreviousMarriage < (this.numberSpouseMarraiges.length - 1)) {
        this.valueSpousePreviousMarriage += 1;
        // this.updateDynamicFormArrayValidation();
        this.isSpouseExSpouse = true;
      } else {
        this.isSpouseExSpouse = false;
        this.isSpouse = false;
        if(this.params == 'editAll' || this.params == ''){
          this.isIncomeEnter = true;
          this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
          this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(this.incomeEntryForm.value.HouseHoldIncome);

          //TODO: set Survivor Switch here


        } else {
          this.isIncomeEnter = true;
          // this.updateClientProfileWithSSQuestionnaire();
        }        
      }
    }
  }

  /* public validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
    //cant be older than max
    parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
    //cant be younger than min
    || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
    ? {invalidDate: '' }  
    : null; */

  updateDynamicFormArrayValidation() {
    const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
    //cant be older than max
    parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
    //cant be younger than min
    || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
    ? {invalidDate: '' }  
    : null;

    console.log('this.valuePreviousMarriage', this.valuePreviousMarriage);
    console.log('prevMarriageTypes',this.numberMarraiges.at(this.valuePreviousMarriage).value.prevMarriageTypes);
    if (this.numberMarraiges.at(this.valuePreviousMarriage).value.prevMarriageTypes == 'Divorced') {
      console.log('here i am');
      const youngerThanValidator = (minAge: number, maxAge: number): ValidatorFn => control =>
      //cant be older than max
      (this.globalService.calculateAgeV2(control.value)) > maxAge 
      //cant be younger than min
      || (this.globalService.calculateAgeV2(control.value)) < minAge   
        ? {invalidDate: 'Please make sure age is between ' + minAge + ' and ' + maxAge + '.' }  
        : null;
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['sexAtBirth'].setValidators(Validators.required);
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['dateOfBirth'].setValidators([Validators.required, youngerThanValidator(18, 90)]);
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['stillAlive'].setValidators(Validators.required);
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['marriedTenOrMoreYears'].setValidators(Validators.required);

      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['sexAtBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['dateOfBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['stillAlive'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['marriedTenOrMoreYears'].updateValueAndValidity();
    
      //remove these if NOT widowed
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].reset();
      //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['monthlyBenefitAtPassing'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['expectedClaimAgeYears'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['expectedClaimAgeMonths'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseDateOfBirth'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeYears'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeMonths'].reset();
      // (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearAtTimeOfPassing'].reset();

      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseDateOfBirth'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeYears'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeMonths'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].clearValidators();
      //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['monthlyBenefitAtPassing'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearAtTimeOfPassing'].clearValidators();

      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].updateValueAndValidity();
      //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['expectedClaimAgeYears'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['expectedClaimAgeMonths'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseDateOfBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['exSpouseClaimAgeMonths'].updateValueAndValidity();
      // (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearAtTimeOfPassing'].updateValueAndValidity();
      
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].patchValue(this.currentYear);
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].updateValueAndValidity();
    } else {
      //remove validation if NOT divorced
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['sexAtBirth'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['dateOfBirth'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['stillAlive'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['marriedTenOrMoreYears'].reset();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['sexAtBirth'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['dateOfBirth'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['stillAlive'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['marriedTenOrMoreYears'].clearValidators();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['sexAtBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['dateOfBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['stillAlive'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['marriedTenOrMoreYears'].updateValueAndValidity();

      if(this.numberMarraiges.at(this.valuePreviousMarriage).value.prevMarriageTypes == 'Widowed') {
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].setValidators(Validators.required);
        // (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].setValidators(Validators.required);
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].patchValue(this.currentYear);
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearOfStatement'].updateValueAndValidity();

        //only required if spouseCollectAtTimeOfPassing == yes/true
        //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['yearAtTimeOfPassing'].setValidators(Validators.required);
      }
    }
    (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['prevMarriageTypes'].setValidators(Validators.required);
    (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['firstName'].setValidators([Validators.required, Validators.min(2), Validators.max(50), Validators.pattern('^[a-zA-Z \'\-\.]+')]);
    (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['lastName'].setValidators([Validators.required, Validators.min(2), Validators.max(50), Validators.pattern('^[a-zA-Z \'\-\.]+')]);
    (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['insuranceAmount'].setValidators([Validators.required, validateBenefits(0, 4250)]);
    (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['firstName'].updateValueAndValidity();
    (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['lastName'].updateValueAndValidity();
    (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[this.valuePreviousMarriage]).controls['insuranceAmount'].updateValueAndValidity();

  }

  updateSpouseDynamicFormArrayValidation() {
    const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
    //cant be older than max
    parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
    //cant be younger than min
    || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
    ? {invalidDate: '' }  
    : null;
    console.log('this.valueSpousePreviousMarriage', this.valueSpousePreviousMarriage);
    console.log('prevMarriageTypes',this.numberSpouseMarraiges.at(this.valueSpousePreviousMarriage).value.prevMarriageTypes);
    if (this.numberSpouseMarraiges.at(this.valueSpousePreviousMarriage).value.prevMarriageTypes == 'Divorced') {
      console.log('here i am');
      const youngerThanValidator = (minAge: number, maxAge: number): ValidatorFn => control =>
      //cant be older than max
      (this.globalService.calculateAgeV2(control.value)) > maxAge 
      //cant be younger than min
      || (this.globalService.calculateAgeV2(control.value)) < minAge   
        ? {invalidDate: 'Please make sure age is between ' + minAge + ' and ' + maxAge + '.' }  
        : null;
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['sexAtBirth'].setValidators(Validators.required);
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['dateOfBirth'].setValidators([Validators.required, youngerThanValidator(18, 90)]);
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['stillAlive'].setValidators(Validators.required);
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['marriedTenOrMoreYears'].setValidators(Validators.required);

      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['sexAtBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['dateOfBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['stillAlive'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['marriedTenOrMoreYears'].updateValueAndValidity();
    
      //remove these if NOT widowed
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['monthlyBenefitAtPassing'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].clearValidators();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['monthlyBenefitAtPassing'].clearValidators();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['expectedClaimAgeYears'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['expectedClaimAgeYears'].clearValidators();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['expectedClaimAgeMonths'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['expectedClaimAgeMonths'].clearValidators();
    } else {
      //remove validation if NOT divorced
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['sexAtBirth'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['dateOfBirth'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['stillAlive'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['marriedTenOrMoreYears'].reset();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['sexAtBirth'].clearValidators();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['dateOfBirth'].clearValidators();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['stillAlive'].clearValidators();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['marriedTenOrMoreYears'].clearValidators();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['sexAtBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['dateOfBirth'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['stillAlive'].updateValueAndValidity();
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['marriedTenOrMoreYears'].updateValueAndValidity();
    
      if(this.numberSpouseMarraiges.at(this.valueSpousePreviousMarriage).value.prevMarriageTypes == 'Widowed') {
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['spouseCollectAtTimeOfPassing'].setValidators(Validators.required);
      }
    
    }
    (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['prevMarriageTypes'].setValidators(Validators.required);
    (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['firstName'].setValidators([Validators.required, Validators.min(2), Validators.max(50), Validators.pattern('^[a-zA-Z \'\-\.]+')]);
    (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['lastName'].setValidators([Validators.required, Validators.min(2), Validators.max(50), Validators.pattern('^[a-zA-Z \'\-\.]+')]);
    (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['insuranceAmount'].setValidators([Validators.required, validateBenefits(0, 4250)]);
    (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['firstName'].updateValueAndValidity();
    (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['lastName'].updateValueAndValidity();
    (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[this.valueSpousePreviousMarriage]).controls['insuranceAmount'].updateValueAndValidity();

  }

  enableSpouse(isSpouse) {
    if (isSpouse) {
      this.isClient = false;
      this.isSpouse = isSpouse;
      //this.isSpouseApplyQuestionnaire = true;
      let clientCurrentIncome = this.incomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome): 0;
      let spouseMaxIncome = clientCurrentIncome > 0 ? 5000000 - clientCurrentIncome: 5000000;
      this.spouseIncomeForm.controls['currentIncome'].setValidators([Validators.required, Validators.max(spouseMaxIncome)]);
      this.spouseMaxIncome = Utils.formatToCurrency(spouseMaxIncome);
      this.isSpouseApplyIncome = true;
    } else {
      //this.isSpouse = false;
      if(this.params == 'editAll' || this.params == ''){
        this.isIncomeEnter = true;
        if (this.client.clientProfile.HouseholdYearOneIncome) {
          this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.client.clientProfile.HouseholdYearOneIncome)));
        } else {
          this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(Utils.formatToNumber(this.incomeForm.value.currentIncome) + Utils.formatToNumber(this.spouseIncomeForm.value.currentIncome)));
        }
      } else {
        this.isIncomeEnter = true;
        // this.updateClientProfileWithSSQuestionnaire();
      }
      //this.updateClientProfileWithSSQuestionnaire();
    }
  }

  resetFormBooleanValue() {
    this.isApplyQuestionnaire = this.isChildren = this.isPension = this.isInRetEarning = this.isDesiredClaimAge = this.isPreviousMarriages = this.isExSpouse = this.isIncomeEnter = false;
    this.isSpouseApplyQuestionnaire = this.isSpouseChildren = this.isSpousePension = this.isSpouseInRetEarning = this.isSpouseDesiredClaimAge = this.isSpousePreviousMarriages = this.isSpouseExSpouse = false;
  }

  getDacEndAgeOptions(isSpouse: boolean): number[] {
    const form = isSpouse ? this.haveSpouseChildrenForm : this.haveChildrenForm;
    const currentAge = Number(form.value.dacCurrentAge) || 0;
    const start = currentAge > 0 ? currentAge + 1 : 1;
    const options: number[] = [];
    for (let i = start; i <= 100; i++) {
      options.push(i);
    }
    return options;
  }

  onChildToggle(type: string, checked: boolean, isSpouse: boolean) {
    const qForm = isSpouse ? this.applySpouseQuestionnaireForm : this.applyQuestionnaireForm;
    if (type === 'nonDisabled') {
      qForm.controls['haveNonDisabledChild'].patchValue(checked);
    } else if (type === 'disabled') {
      qForm.controls['haveDisabledChild'].patchValue(checked);
    }
    const hasDep = !!(qForm.value.haveNonDisabledChild || qForm.value.haveDisabledChild);
    qForm.controls['haveDepChild'].patchValue(hasDep);
    this.updateChildValidators(isSpouse);
  }

  onDacAnticipateChange(value: string, isSpouse: boolean) {
    const form = isSpouse ? this.haveSpouseChildrenForm : this.haveChildrenForm;
    form.controls['dacAnticipateEnd'].patchValue(value);
    if (value === 'true') {
      form.controls['dacEndAge'].setValidators([Validators.required]);
    } else {
      form.controls['dacEndAge'].clearValidators();
      form.controls['dacEndAge'].setValue('');
    }
    form.controls['dacEndAge'].updateValueAndValidity();
  }

  onDacCurrentAgeChange(value: string, isSpouse: boolean) {
    const form = isSpouse ? this.haveSpouseChildrenForm : this.haveChildrenForm;
    form.controls['dacCurrentAge'].patchValue(value);
    const dacEndAge = Number(form.value.dacEndAge) || 0;
    if (dacEndAge && dacEndAge <= Number(value)) {
      form.controls['dacEndAge'].setValue('');
    }
    form.controls['dacEndAge'].updateValueAndValidity();
  }

  updateChildValidators(isSpouse: boolean) {
    const form = isSpouse ? this.haveSpouseChildrenForm : this.haveChildrenForm;
    const qForm = isSpouse ? this.applySpouseQuestionnaireForm : this.applyQuestionnaireForm;

    const hasNonDisabled = !!qForm.value.haveNonDisabledChild;
    const hasDisabled = !!qForm.value.haveDisabledChild;

    form.controls['haveNonDisabledChild'].setValue(hasNonDisabled);
    form.controls['haveDisabledChild'].setValue(hasDisabled);

    if (hasNonDisabled) {
      form.controls['numberOfChild'].setValidators([Validators.required]);
    } else {
      form.controls['numberOfChild'].clearValidators();
      form.controls['numberOfChild'].setValue('');
      const childsAges = isSpouse ? this.spouseChildsAge : this.childsAge;
      while (childsAges.length !== 0) {
        childsAges.removeAt(0);
      }
    }
    form.controls['numberOfChild'].updateValueAndValidity();

    if (hasDisabled) {
      form.controls['dacCurrentAge'].setValidators([Validators.required]);
      form.controls['dacAnticipateEnd'].setValidators([Validators.required]);
      if (form.value.dacAnticipateEnd === 'true') {
        form.controls['dacEndAge'].setValidators([Validators.required]);
      } else {
        form.controls['dacEndAge'].clearValidators();
      }
    } else {
      form.controls['dacCurrentAge'].clearValidators();
      form.controls['dacCurrentAge'].setValue('');
      form.controls['dacAnticipateEnd'].clearValidators();
      form.controls['dacAnticipateEnd'].setValue('false');
      form.controls['dacEndAge'].clearValidators();
      form.controls['dacEndAge'].setValue('');
    }
    form.controls['dacCurrentAge'].updateValueAndValidity();
    form.controls['dacAnticipateEnd'].updateValueAndValidity();
    form.controls['dacEndAge'].updateValueAndValidity();
  }

  addDependentAge() {
    const dependantAge = new FormGroup(
      {
        dependentChildAge: new FormControl()
      }
    )
    this.childsAge.push(dependantAge);
  }

  addSpouseDependentAge() {
    const dependantAge = new FormGroup(
      {
        dependentChildAge: new FormControl()
      }
    )
    this.spouseChildsAge.push(dependantAge);
  }

  addMarriage() {
    const marriages = new FormGroup({
      prevMarriageTypes: new FormControl(''),
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      sexAtBirth: new FormControl(''),
      dateOfBirth: new FormControl(''),
      insuranceAmount: new FormControl(''),
      stillAlive: new FormControl(''),
      expectedClaimAgeYears: new FormControl(''),
      expectedClaimAgeMonths: new FormControl(''),
      marriedTenOrMoreYears: new FormControl(''),
      exSpouseLifeExpectancy: new FormControl(''),
      spouseCollectAtTimeOfPassing: new FormControl(''),
      monthlyBenefitAtPassing: new FormControl(''),
      exSpouseDateOfBirth: new FormControl(''),
      exSpouseClaimAgeYears: new FormControl(''),
      exSpouseClaimAgeMonths: new FormControl(''),
      yearOfStatement: new FormControl(''),
      yearAtTimeOfPassing: new FormControl('')
    })
    this.numberMarraiges.push(marriages);
  }

  addSpouseMarriage() {
    const marriages = new FormGroup({
      prevMarriageTypes: new FormControl(''),
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      sexAtBirth: new FormControl(''),
      dateOfBirth: new FormControl(''),
      insuranceAmount: new FormControl(''),
      stillAlive: new FormControl(''),
      expectedClaimAgeYears: new FormControl(''),
      expectedClaimAgeMonths: new FormControl(''),
      marriedTenOrMoreYears: new FormControl(''),
      exSpouseLifeExpectancy: new FormControl(''),
      spouseCollectAtTimeOfPassing: new FormControl(''),
      monthlyBenefitAtPassing: new FormControl(''),
      exSpouseDateOfBirth: new FormControl(''),
      exSpouseClaimAgeYears: new FormControl(''),
      exSpouseClaimAgeMonths: new FormControl(''),
      yearOfStatement: new FormControl(''),
      yearAtTimeOfPassing: new FormControl('')
    })
    this.numberSpouseMarraiges.push(marriages);
  }

  deleteMarriage(marriageIndex: number) {
    this.numberMarraiges.removeAt(marriageIndex);
  }

  alreadyShownSpouseDCAModal: boolean = false;
  onChangeDCA(val, isClient){
    //console.log('toggle DCA', val);
    if(isClient){
      //auto toggle on spouse DCA when clients DCA is toggled on
      if(val){
        //check if already set before toggling
        if(!this.applySpouseQuestionnaireForm.value.desiredClaimAge){
          this.applySpouseQuestionnaireForm.controls['desiredClaimAge'].patchValue(true);
          this.applySpouseQuestionnaireForm.controls['desiredClaimAge'].updateValueAndValidity();
        }
      }
    } else {
      //if spouse, check if client DCA is toggled on or off
      if(!this.applyQuestionnaireForm.value.desiredClaimAge){
        //if client is DCA toggled off, and spouse toggles on, display message on the spouse DCA card
        //NOTE - could prob remove this and just handle in html with if statement
      } else {
        console.log('this.incomeForm.value.isCollectingBenefits', this.incomeForm.value.isCollectingBenefits)
        if(!val && !this.alreadyShownSpouseDCAModal && this.incomeForm.value.isCollectingBenefits == 'false'){
          if(this.applySpouseQuestionnaireForm.value.desiredClaimAge){
            //console.log('show spouse modal here');

            const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
              data: { title: 'Notification!', 
              btnNoTitle: 'Skip This Step and Use FRA',
              btnYesTitle: 'Select a Desired Claim Age',
              question: 'Because ' + this.clientFirstName + ' selected a desired Social Security claim age, the tool requires a claim age for ' + this.spouseFirstName + ' as well. <br/>You may enter a desired claim age, or default to Full Retirement Age (this can always be edited later on the results screen.)' }
            });
        
            dialogRef.afterClosed().subscribe(result => {
              console.log('from basic', result);
              if(result){
                //only need to show the modal once per client profile interaction
                this.applySpouseQuestionnaireForm.controls['desiredClaimAge'].patchValue(result);
                this.alreadyShownSpouseDCAModal = true; 
              }
            });            
          }
        }
      }
    }
  }

  onChange(scenario, newValue, i) {
    console.log('on change');
    if(scenario == 'spouseCollectAtTimeOfPassing'){
      //console.log('spouseCollectAtTimeOfPassing', newValue);
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['spouseCollectAtTimeOfPassing'].patchValue(newValue);
      if(newValue == "Yes"){
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].setValidators(Validators.required);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();
        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].setValidators(Validators.required);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(11)]);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].setValidators([Validators.required]);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].updateValueAndValidity();

      } else {
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].reset();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].clearValidators();        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();
        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].reset();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].clearValidators();        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].reset();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].clearValidators();        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].reset();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].clearValidators();        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].reset();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].clearValidators();        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].updateValueAndValidity();
      }
    }
    if (scenario == 'previousMarriages') {
      this.numberMarriagesForm = null;
      this.numberMarriagesForm = new FormGroup({
        numberMarriages: new FormArray([])
      });
      console.log('<FormArray>this.numberMarraigesForm.controls',(<FormArray>this.numberMarriagesForm.controls['numberMarriages']));

      for(let i=0; i<this.prevMarraigesForm.value.marraigeTimes; i++) {
        this.addMarriage();
      }
      console.log('this.numberMarraiges.length', this.numberMarraiges.length);
      this.valuePreviousMarriage = 0;
      // this.updateDynamicFormArrayValidation();
    }
    if (scenario == 'naturePreviousMarriage') {
      console.log(this.numberMarriagesForm);
      console.log('change dropdown', newValue);
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['prevMarriageTypes'].patchValue(newValue);
      this.updateDynamicFormArrayValidation();
    }
    if (scenario == 'sexAtBirth') {
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['sexAtBirth'].patchValue(newValue);
    }
    if (scenario == 'stillAlive') {
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['stillAlive'].patchValue(newValue);
      if(newValue == 'Yes' && (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['marriedTenOrMoreYears'].value == 'Yes') {
        console.log('here i am 0001');
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(11)]);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
        if (this.numberMarraiges.value.length > 0) {
          if (this.numberMarraiges.at(i).value.stillAlive =='Yes' && this.numberMarraiges.at(i).value.marriedTenOrMoreYears == 'Yes' && this.numberMarraiges.at(i).value.sexAtBirth && this.numberMarraiges.at(i).value.dateOfBirth) {
            console.log('calculateLifeExp');
            let gender = this.numberMarraiges.at(i).value.sexAtBirth;
            console.log('gender', gender);
            this.calculateLifeExp(this.globalService.calculateAgeV2(this.numberMarraiges.at(i).value.dateOfBirth),gender, (i), true);
          }
        }
      } else {
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].clearValidators();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].clearValidators();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
      }
    }
    if (scenario == 'marriedTenOrMoreYears') {
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['marriedTenOrMoreYears'].patchValue(newValue);
      if(newValue == 'Yes' && (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['stillAlive'].value == 'Yes') {
        console.log('here i am 0002');
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 

        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(11)]);        
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
        if (this.numberMarraiges.value.length > 0) {
          if (this.numberMarraiges.at(i).value.stillAlive =='Yes' && this.numberMarraiges.at(i).value.marriedTenOrMoreYears == 'Yes' && this.numberMarraiges.at(i).value.sexAtBirth && this.numberMarraiges.at(i).value.dateOfBirth) {
            console.log('calculateLifeExp');
            let gender = this.numberMarraiges.at(i).value.sexAtBirth;
            console.log('gender', gender);
            this.calculateLifeExp(this.globalService.calculateAgeV2(this.numberMarraiges.at(i).value.dateOfBirth),gender, (i), true);
          }
        }
      } else {
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].clearValidators();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].clearValidators();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
      }
    }
    if (scenario == 'childrenNumber') {
      let numberOfChildren = this.haveChildrenForm.value.numberOfChild;
      const childsAges = <FormArray>this.haveChildrenForm.controls['childsAges'];
      while (childsAges.length !== 0) {
        childsAges.removeAt(0);
      }
      for (let i = 0; i < numberOfChildren; i++) {
        this.addDependentAge();
      }
    }
    if (scenario == 'yearOfStatement') {
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearOfStatement'].patchValue(newValue);
    }
    // this.dependantAge.push('');

    //Spouse
    if(scenario == 'spouseCollectAtTimeOfPassingSpouse'){
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['spouseCollectAtTimeOfPassing'].patchValue(newValue);

      if(newValue == "Yes"){
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].setValidators(Validators.required);        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();
        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].setValidators(Validators.required);        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].updateValueAndValidity();

        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();

        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(11)]);        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].setValidators([Validators.required]);        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].updateValueAndValidity();
      } else {
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].reset();
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].clearValidators();        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();  
        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].reset();
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].clearValidators();        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseDateOfBirth'].updateValueAndValidity();

        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].reset();
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].clearValidators();        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();

        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].reset();
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].clearValidators();        
        // (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeMonths'].updateValueAndValidity();

        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].reset();
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].clearValidators();        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['yearAtTimeOfPassing'].updateValueAndValidity();
      }
    }
    if (scenario == 'previousSpouseMarriages') {
      this.numberSpouseMarriagesForm = null;
      this.numberSpouseMarriagesForm = new FormGroup({
        numberMarriages: new FormArray([])
      });
      console.log('<FormArray>this.numberSpouseMarraigesForm.controls',(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']));

      for(let i=0; i<this.prevSpouseMarraigesForm.value.marraigeTimes; i++) {
        this.addSpouseMarriage();
      }
      console.log('this.numberSpouseMarraiges.length', this.numberSpouseMarraiges.length);
      this.valueSpousePreviousMarriage = 0;
      // this.updateDynamicFormArrayValidation();
    }
    if (scenario == 'natureSpousePreviousMarriage') {
      console.log(this.numberSpouseMarriagesForm);
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['prevMarriageTypes'].patchValue(newValue);
      this.updateSpouseDynamicFormArrayValidation();
    }
    if (scenario == 'sexAtBirthSpouse') {
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['sexAtBirth'].patchValue(newValue);
    }
    if (scenario == 'stillAliveSpouse') {
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['stillAlive'].patchValue(newValue);
      if(newValue == 'Yes' && (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['marriedTenOrMoreYears'].value == 'Yes'){
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 

        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(11)]);        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
      }  else {
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].clearValidators();
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].clearValidators();
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
      }
    }
    if (scenario == 'marriedTenOrMoreYearsSpouse') {
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['marriedTenOrMoreYears'].patchValue(newValue);
      if(newValue == 'Yes' && (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['stillAlive'].value == 'Yes'){
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 

        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(11)]);        
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
      } else {
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].clearValidators();
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].clearValidators();
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
        
      }
    }
    if (scenario == 'spouseChildrenNumber') {
      let numberOfChildren = this.haveSpouseChildrenForm.value.numberOfChild;
      const childsAges = <FormArray>this.haveSpouseChildrenForm.controls['childsAges'];
      while (childsAges.length !== 0) {
        childsAges.removeAt(0);
      }
      for (let i = 0; i < numberOfChildren; i++) {
        this.addSpouseDependentAge();
      }
    }
    // console.log('this.numberMarraiges.at(i).value.stillAlive', this.numberMarraiges.at(i).value.stillAlive);
    // console.log('&& this.numberMarraiges.at(i).value.sexAtBirth', this.numberMarraiges.at(i).value.sexAtBirth);
    if (scenario == 'exSpouseLifeExpectancy') {
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].patchValue(Number(newValue));
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].updateValueAndValidity();
      console.log('this.numberMarraiges.at(i-1).value.exSpouseLifeExpectancy 01', this.numberMarraiges.at(i).value.exSpouseLifeExpectancy);
      
    } 
    // else {
    //   console.log('exSpouseLifeExpectancy')
    //   console.log('this.numberMarraiges', this.numberMarraiges)
    //   if (this.numberMarraiges.value.length > 0) {
    //     if (this.numberMarraiges.at(i).value.stillAlive =='Yes' && this.numberMarraiges.at(i).value.marriedTenOrMoreYears == 'Yes' && this.numberMarraiges.at(i).value.sexAtBirth && this.numberMarraiges.at(i).value.dateOfBirth) {
    //       console.log('calculateLifeExp');
    //       let gender = this.numberMarraiges.at(i).value.sexAtBirth;
    //       console.log('gender', gender);
    //       this.calculateLifeExp(this.calculateAge(this.numberMarraiges.at(i).value.dateOfBirth),gender, (i), true);
    //     }
    //   }

    // }

    if (scenario == 'exSpouseLifeExpectancySpouse') {
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].patchValue(Number(newValue));
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].updateValueAndValidity();
      console.log('this.numberMarraiges.at(i-1).value.exSpouseLifeExpectancy 01', this.numberSpouseMarraiges.at(i).value.exSpouseLifeExpectancy);
      
    } else {
      console.log('exSpouseLifeExpectancySpouse')
      if (this.numberSpouseMarraiges.value.length > 0) {
        if (this.numberSpouseMarraiges.at(i).value.stillAlive =='Yes' && this.numberSpouseMarraiges.at(i).value.marriedTenOrMoreYears == 'Yes' && this.numberSpouseMarraiges.at(i).value.sexAtBirth && this.numberSpouseMarraiges.at(i).value.dateOfBirth) {
          console.log('calculateLifeExp');
          let gender = this.numberSpouseMarraiges.at(i).value.sexAtBirth;
          console.log('gender', gender);
          this.calculateLifeExp(this.globalService.calculateAgeV2(this.numberSpouseMarraiges.at(i).value.dateOfBirth),gender, (i), false);
        }
      }
    }


    if (scenario == 'expectedClaimAgeYears') {
      //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
      //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 

      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max(((this.numberMarraiges.at(i).value.expectedClaimAgeYears == 70) ? 0 : 11))]);        
      (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 

      //reset validation anyways since the Claim Age was adjusted - we now have a base/min for LX
      this.minAge = parseInt((<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value) + 1;
      this.maxAge = 100 - this.minAge + 1;

      if((<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value 
        > (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].value){
          //if in here reset the LX          
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].patchValue(this.minAge);
          
        }
        
        //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].reset();
        //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].clearValidators();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].setValidators([Validators.required, 
          Validators.min(parseInt((<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value) + 1)]);
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseLifeExpectancy'].updateValueAndValidity();
    }

    this.maxExSpouseClaimAge = 70;

    if(scenario == 'exSpouseClaimAgeYears'){

      if(this.numberMarraiges.at(i).value.spouseCollectAtTimeOfPassing
          && this.numberMarraiges.at(i).value.prevMarriageTypes == 'Widowed'){
          
          if(this.numberMarraiges.at(i).value.spouseCollectAtTimeOfPassing == 'Yes'){
            //readjust Claim Age validation to not be greater than LX
            //ex: (year of passing) - (DOB year) < (claim age)
            var dobYear = new Date(this.numberMarraiges.at(i).value.exSpouseDateOfBirth).getFullYear();            
            var ageAtPass = (parseInt(this.numberMarraiges.at(i).value.yearAtTimeOfPassing) - dobYear);

            if(ageAtPass < this.numberMarraiges.at(i).value.exSpouseClaimAgeYears){
                //if in here, reset validation on the max for claim age
                //console.log('widow in here 3');
                //(<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].patchValue(ageAtPass);                
                this.maxExSpouseClaimAge = ageAtPass;
                (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].clearValidators();
                (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].reset();
                (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].setValidators(Validators.required, Validators.min(62), Validators.max(ageAtPass));
                (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['exSpouseClaimAgeYears'].updateValueAndValidity();
            }
          }
        }
    }

    if (scenario == 'spouseExpectedClaimAgeYears') {
      //(<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].setValidators([Validators.required, Validators.min(62), Validators.max(70)]);        
      //(<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].updateValueAndValidity(); 

      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].setValidators([Validators.required, Validators.min(0), Validators.max((((<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeYears'].value == 70) ? 0 : 11))]);        
      (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['expectedClaimAgeMonths'].updateValueAndValidity(); 
    }
   
  }

  priorMarraigeValue(newValue, scenario, i) {
    console.log('prior marriage new value', newValue);
    console.log('prior marriage scen', scenario);

    if (scenario == 'priorSpouseInsuranceAmount') {
      console.log('priorSpouseInsuranceAmount');
      let amount = newValue.replace(/\D/g, '');
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      if (amount != '') {
      console.log('amount', amount);
      const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
        //cant be older than max
        parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
        //cant be younger than min
        || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
        ? {invalidDate: '' }  
        : null;
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['insuranceAmount'].setValidators([Validators.required, validateBenefits(0, 4250)]);
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['insuranceAmount'].updateValueAndValidity();
        (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['insuranceAmount'].patchValue(Utils.formatToCurrency(amount));
      }
    }

    if (scenario == 'monthlyBenefitAtPassing') {
      let amount = newValue.replace(/\D/g, '');
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      if (amount != '') {
        console.log('amount', amount);
        const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
          //cant be older than max
          parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
          //cant be younger than min
          || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
          ? {invalidDate: '' }  
          : null;
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].setValidators([Validators.required, validateBenefits(0, 5000)]);
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].patchValue(Utils.formatToCurrency(amount));
          (<FormArray>(<FormArray>this.numberMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();
      }
    }
  }

  priorSpouseMarraigeValue(newValue, scenario, i) {

    if (scenario == 'priorSpouseInsuranceAmount') {
      console.log('priorSpouseInsuranceAmount');
      let amount = newValue.replace(/\D/g, '');
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      if (amount != '') {
      console.log('amount', amount);
      const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
        //cant be older than max
        parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
        //cant be younger than min
        || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
        ? {invalidDate: '' }  
        : null;

        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['insuranceAmount'].setValidators([Validators.required, validateBenefits(0, 4250)]);
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['insuranceAmount'].updateValueAndValidity();
        (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['insuranceAmount'].patchValue(Utils.formatToCurrency(amount));
        
      }
    }

    if (scenario == 'monthlyBenefitAtPassing') {
      let amount = newValue.replace(/\D/g, '');
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      if (amount != '') {
        console.log('amount', amount);
        const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
          //cant be older than max
          parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
          //cant be younger than min
          || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
          ? {invalidDate: '' }  
          : null;
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].setValidators([Validators.required, validateBenefits(0, 5000)]);
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].updateValueAndValidity();
          (<FormArray>(<FormArray>this.numberSpouseMarriagesForm.controls['numberMarriages']).controls[i]).controls['monthlyBenefitAtPassing'].patchValue(Utils.formatToCurrency(amount));
      }
    }
  }

  /* isClientAllowedRetroFiling: boolean = false;
  isSpouseAllowedRetroFiling: boolean = false;
  checkAllowedRetroFiling(){

  } */

  updateClientProfileWithSSQuestionnaire() {
    
    console.log('saved spouse obj 01', this.client.clientProfile.Spouses);
    var userModel = JSON.parse(localStorage.getItem('userModel'));
    console.log('userProfile', userModel);
    let clientFirstName = userModel? userModel.FirstName ? userModel.FirstName : this.client.client.FirstName : this.client.client.FirstName;
    let clientLastName = userModel? userModel.LastName ? userModel.LastName : this.client.client.LastName : this.client.client.LastName;
    let clientGenderID = userModel? userModel.GenderID ? userModel.GenderID : this.client.client.GenderID : this.client.client.GenderID;
    let clientDOB = userModel? userModel.DOB ? userModel.DOB : this.client.client.DOB : this.client.client.DOB;
    console.log('clientFirstName', clientFirstName);
    // let clientGender = profile? profile.GenderID ? profile.GenderID : UserModel.GenderID : UserModel.GenderID;
    // console.log('clientFirstName', clientFirstName);
    var UserModel = {
      ID: this.client.client ? this.client.client.ID : 0,
      FirstName: clientFirstName,
      LastName: clientLastName,
      AdvisorID: this.client.client.AdvisorID,
      OrganizationID: this.client.client.OrganizationID,
      Username: this.client.client.Username,
      GenderID: clientGenderID,
      DOB: clientDOB,
      Email: this.client.client.Email,
      Phone: this.client.client.Phone,
      Address: this.client.client.Address,
      City: this.client.client.City,
      State: this.client.client.State,
      Zip: this.client.client.Zip,
    }
    
    let children: any[] = [];
    
    if (this.applyQuestionnaireForm.value.haveNonDisabledChild && this.childsAge.length > 0) {
      for (var i = 0; i < this.childsAge.length; i++) {
        children.push({
          DependentChildAge: this.childsAge.at(i).value.dependentChildAge,
          isDisabled: false
        });
      }
    }
    if (this.applyQuestionnaireForm.value.haveDisabledChild && this.haveChildrenForm.value.dacCurrentAge) {
      const isEnd = this.haveChildrenForm.value.dacAnticipateEnd === 'true';
      children.push({
        DependentChildAge: this.haveChildrenForm.value.dacCurrentAge,
        isDisabled: true,
        dacAnticipateEnd: isEnd,
        dacEndAge: isEnd ? this.haveChildrenForm.value.dacEndAge : null
      });
    }


    
    let isSpouse = this.client.clientProfile.Spouses[0] ? true : false;    
    if (isSpouse) {      
      let spouseFRA = null;
      if(this.client.clientProfile.Spouses[0].LifeExpectancy && localStorage.getItem('spouseLifeExpectancy')) {
        this.client.clientProfile.Spouses[0].LifeExpectancy = localStorage.getItem('spouseLifeExpectancy');
      }
      if (this.client.clientProfile.Spouses[0].dob) {
        const spouseFullDOB = new Date(this.client.clientProfile.Spouses[0].dob.toString());
        let birthYear = spouseFullDOB.getFullYear();
        spouseFRA = this.getFRA(birthYear);
      }
      
      //if nothing is entered, we save nothing and force FRA on SS illustration page
      if (this.desiredSpouseClaimForm.value.ageYears && !this.isSurivivorAsSpouseDesiredAge) {
        if (this.applySpouseQuestionnaireForm.value.desiredClaimAge) {
          this.client.clientProfile.Spouses[0].sSDesiredAgeYears = this.desiredSpouseClaimForm.value.ageYears;
        } else {
          if (this.client.clientProfile.Spouses[0].sSDesiredAgeYears) {
            this.client.clientProfile.Spouses[0].sSDesiredAgeYears = null;
          }
        }       
      } 
      // else {
      //   //this.client.clientProfile.Spouses[0].sSDesiredAgeYears = spouseFRA ? spouseFRA.age: 67;
      // }
      if ((this.desiredSpouseClaimForm.value.ageMonths || this.desiredSpouseClaimForm.value.ageMonths == 0) && !this.isSurivivorAsSpouseDesiredAge)  {
        if (this.applySpouseQuestionnaireForm.value.desiredClaimAge) {
          if (this.desiredSpouseClaimForm.value.ageYears && !this.desiredSpouseClaimForm.value.ageMonths) {
            this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = 0;
          } else {
            this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = this.desiredSpouseClaimForm.value.ageMonths;
          }

        } else {
          if (this.client.clientProfile.Spouses[0].sSDesiredAgeMonths) {
            this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = null;
          }
        }

      } 
      // else {
      //   //this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = spouseFRA ? spouseFRA.month: 0;
      // }
      if (this.spouseIncomeForm.value.pia){
        this.client.clientProfile.Spouses[0].pia = Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.pia);
      } else {
        if (this.client.clientProfile.Spouses[0].hasOwnProperty('pia')) {
          delete this.client.clientProfile.Spouses[0].pia
        }
      }
      if(this.spouseIncomeForm.value.currentIncome){
        this.client.clientProfile.Spouses[0].currentIncome = Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.currentIncome);
      }
      if (this.spouseIncomeForm.value.knownBenefitClaiming) {
        this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming = (this.spouseIncomeForm.value.knownBenefitClaiming) ? Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.knownBenefitClaiming) : null;
        //this.spouseIncomeForm.value.knownBenefitClaiming;
      } else {
        if (this.client.clientProfile.Spouses[0].hasOwnProperty('SpouseKnownBenefitClaiming')) {
          delete this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming
        }
      }
      if(this.spouseIncomeForm.value.dateOfClaimYear){
        this.client.clientProfile.Spouses[0].dateOfClaimYear = this.spouseIncomeForm.value.dateOfClaimYear;
        this.client.clientProfile.Spouses[0].dateOfClaimMonth = this.spouseIncomeForm.value.dateOfClaimMonth;
      }

      this.client.clientProfile.Spouses[0].inRetFirstYearIncome = this.applySpouseQuestionnaireForm.value.partTimeWork ? (this.inRetSpouseEarningForm.value.firstYearRet ? Utils.removeCurrencyFormatting(this.inRetSpouseEarningForm.value.firstYearRet): null): null;
      if (this.prevMarraigesForm.value.marraigeTimes > 0) {
        this.client.clientProfile.Spouses[0].maritalHistory = {
          previousSpouseCount: this.prevMarraigesForm.value.marraigeTimes,
          previouslyMarried: this.prevMarraigesForm.value.marraigeTimes > 0 ? true: false,
          spousePreviouslyMarried: false,
        }
      }
      // if (this.inRetSpouseEarningForm.value.firstYearRet) {
      //   this.client.clientProfile.Spouses[0].inRetFirstYearIncome = Utils.removeCurrencyFormatting(this.inRetSpouseEarningForm.value.firstYearRet);
      // }
      if (this.inRetSpouseEarningForm.value.stopWorkAge) {
        this.client.clientProfile.Spouses[0].inRetStopWork = this.inRetSpouseEarningForm.value.stopWorkAge;
      }
      
      if(this.pensionSpouseForm.value.annualPensionValue) {
        this.client.clientProfile.Spouses[0].pension = this.applySpouseQuestionnaireForm.value.havePension ? Utils.removeCurrencyFormatting(this.pensionSpouseForm.value.annualPensionValue):null;
      }
      if(this.pensionSpouseForm.value.pensionInflationRate && Utils.removePercentageFormatting(this.pensionSpouseForm.value.pensionInflationRate) >= 0) {
        this.client.clientProfile.Spouses[0].PensionInfl = this.applySpouseQuestionnaireForm.value.havePension ? Utils.removePercentageFormatting(this.pensionSpouseForm.value.pensionInflationRate) : null;
      }
      if (this.applySpouseQuestionnaireForm.value.havePension) {
        this.client.clientProfile.Spouses[0].IncludePension = 1;
      }
      if(this.pensionSpouseForm.value.pensionStartMonth) {
        this.client.clientProfile.Spouses[0].pensionMonth = this.applySpouseQuestionnaireForm.value.havePension ? this.pensionSpouseForm.value.pensionStartMonth : null;
      }
      if(this.pensionSpouseForm.value.pensionStartYear) {
        this.client.clientProfile.Spouses[0].pensionYear = this.applySpouseQuestionnaireForm.value.havePension ? this.pensionSpouseForm.value.pensionStartYear : null;
      }
      if(this.pensionSpouseForm.value.substantialEarningYear) {
        this.client.clientProfile.Spouses[0].substantialEarningYears = this.applySpouseQuestionnaireForm.value.havePension ? this.pensionSpouseForm.value.substantialEarningYear : null;
      }
      if(this.alreadyCollectedSpouseSSForm.value.monthlyBenefitAmount) {
        this.client.clientProfile.Spouses[0].monthlyBenefitAmount = this.alreadyCollectedSpouseSSForm.value.monthlyBenefitAmount;
      }
      this.client.clientProfile.Spouses[0].monthlyBenefits = this.spouseIncomeForm.value.monthlyBenefits;
      // if(this.spouseIncomeForm.value.monthlyBenefits) {
      //   this.client.clientProfile.Spouses[0].monthlyBenefits = this.spouseIncomeForm.value.monthlyBenefits;
      // }
      if (this.client.clientProfile.IsLegalSpouse > 0 && this.sixtyPlusForm.value.dateOfMarriage) {
        this.client.clientProfile.Spouses[0].anniversary = this.sixtyPlusForm.value.dateOfMarriage;
      }
      let spouseChildren: any[] = [];
      if (!this.applySpouseQuestionnaireForm.value.haveNonDisabledChild && !this.applySpouseQuestionnaireForm.value.haveDisabledChild && !this.applySpouseQuestionnaireForm.value.haveDepChild) {
        this.client.clientProfile.Spouses[0].children = null;
      } else {
        if (this.applySpouseQuestionnaireForm.value.haveNonDisabledChild && this.spouseChildsAge.length > 0) {
          for (var i = 0; i < this.spouseChildsAge.length; i++) {
            spouseChildren.push({
              DependentChildAge: this.spouseChildsAge.at(i).value.dependentChildAge,
              isDisabled: false
            });
          }
        }
        if (this.applySpouseQuestionnaireForm.value.haveDisabledChild && this.haveSpouseChildrenForm.value.dacCurrentAge) {
          const isEnd = this.haveSpouseChildrenForm.value.dacAnticipateEnd === 'true';
          spouseChildren.push({
            DependentChildAge: this.haveSpouseChildrenForm.value.dacCurrentAge,
            isDisabled: true,
            dacAnticipateEnd: isEnd,
            dacEndAge: isEnd ? this.haveSpouseChildrenForm.value.dacEndAge : null
          });
        }
        this.client.clientProfile.Spouses[0].children = spouseChildren;
      }


      //TODO: setup spouses of current spouse > convert from Prod
      console.log('this.client.clientProfile.IsLegalSpouse', this.client.clientProfile.IsLegalSpouse);
      if((!this.client.clientProfile.IsLegalSpouse || this.client.clientProfile.IsLegalSpouse || this.isSpouseSixtyPlusAtMarriage) && this.prevSpouseMarraigesForm.value.marraigeTimes > 0 && !this.applySpouseQuestionnaireForm.value.previouslyMarried) {
        console.log('here i am');
        this.client.clientProfile.Spouses[0].spousesSpouse = [];
        // this.client.clientProfile.Spouses[0].spousesSpouse.splice(1, this.client.clientProfile.Spouses[0].spousesSpouse.length - 1)
      }
      if((!this.client.clientProfile.IsLegalSpouse || this.isSpouseSixtyPlusAtMarriage) && this.prevSpouseMarraigesForm.value.marraigeTimes > 0 && this.applySpouseQuestionnaireForm.value.previouslyMarried) {
        //spousesSpouse
        console.log('this.client.clientProfile.IsLegalSpouse 02', this.client.clientProfile.IsLegalSpouse);

        //if(!this.client.clientProfile.Spouses[0].spousesSpouse){
          this.client.clientProfile.Spouses[0].spousesSpouse = [];
        //}

        for (var i = 1; i <= this.prevSpouseMarraigesForm.value.marraigeTimes; i++) {

          if (this.client.clientProfile.Spouses[0].spousesSpouse.length <= i) {

            this.client.clientProfile.Spouses[0].spousesSpouse.push(
              {
                "maritalStatus": this.numberSpouseMarraiges.at(i-1).value.prevMarriageTypes,
                "firstName": this.numberSpouseMarraiges.at(i-1).value.firstName,
                "lastName": this.numberSpouseMarraiges.at(i-1).value.lastName,
                "gender": this.numberSpouseMarraiges.at(i-1).value.sexAtBirth,
                "dobStr": this.numberSpouseMarraiges.at(i-1).value.dateOfBirth,
                "dob": {
                  date: {
                    year: new Date(this.numberSpouseMarraiges.at(i-1).value.dateOfBirth).getFullYear() || 0,
                    month: new Date(this.numberSpouseMarraiges.at(i-1).value.dateOfBirth).getMonth() + 1 || 0,
                    day: new Date(this.numberSpouseMarraiges.at(i-1).value.dateOfBirth).getDate() || 0
                  }
                },
                "pia": Utils.removeCurrencyFormatting(this.numberSpouseMarraiges.at(i-1).value.insuranceAmount),
                "alive": (this.numberSpouseMarraiges.at(i-1).value.stillAlive == "Yes") ? true : false,
                //"marriedTenOrMoreYears": this.numberMarraiges.at(i-1).value.marriedTenOrMoreYears,
                "tenyears": (this.numberSpouseMarraiges.at(i-1).value.marriedTenOrMoreYears == "Yes") ? true : false,
                "spouseCollectAtTimeOfPassing" : (this.numberSpouseMarraiges.at(i-1).value.spouseCollectAtTimeOfPassing == "Yes") ? true : false,
                "monthlyBenefitAtPassing": (this.numberSpouseMarraiges.at(i-1).value.monthlyBenefitAtPassing) ? Utils.removeCurrencyFormatting(this.numberSpouseMarraiges.at(i-1).value.monthlyBenefitAtPassing) : 0,
                "exSpouseLifeExpectancy": (this.numberSpouseMarraiges.at(i-1).value.exSpouseLifeExpectancy) ? this.numberSpouseMarraiges.at(i-1).value.exSpouseLifeExpectancy : '',
                "expectedClaimAgeYears" : (this.numberSpouseMarraiges.at(i-1).value.expectedClaimAgeYears) ? this.numberSpouseMarraiges.at(i-1).value.expectedClaimAgeYears : '',
                "expectedClaimAgeMonths" : (this.numberSpouseMarraiges.at(i-1).value.expectedClaimAgeMonths) ? this.numberSpouseMarraiges.at(i-1).value.expectedClaimAgeMonths : '',
                "exSpouseDateOfBirth": (this.numberSpouseMarraiges.at(i-1).value.exSpouseDateOfBirth) ? this.numberSpouseMarraiges.at(i-1).value.exSpouseDateOfBirth : '',
                "exSpouseClaimAgeYears": (this.numberSpouseMarraiges.at(i-1).value.exSpouseClaimAgeYears) ? this.numberSpouseMarraiges.at(i-1).value.exSpouseClaimAgeYears : '',
                "exSpouseClaimAgeMonths": (this.numberSpouseMarraiges.at(i-1).value.exSpouseClaimAgeMonths) ? this.numberSpouseMarraiges.at(i-1).value.exSpouseClaimAgeMonths : '',
                "yearOfStatement": (this.numberSpouseMarraiges.at(i-1).value.yearOfStatement) ? this.numberSpouseMarraiges.at(i-1).value.yearOfStatement : '',
                "yearAtTimeOfPassing": (this.numberSpouseMarraiges.at(i-1).value.yearAtTimeOfPassing) ? this.numberSpouseMarraiges.at(i-1).value.yearAtTimeOfPassing : ''
              }
            )
          } else {
            
            if (this.numberSpouseMarraiges.at(i)) {
              // console.log('i', i);
              this.client.clientProfile.Spouses[0].spousesSpouse[i].maritalStatus = this.numberSpouseMarraiges.at(i-1).value.prevMarriageTypes;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].firstName = this.numberSpouseMarraiges.at(i-1).value.firstName;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].lastName = this.numberSpouseMarraiges.at(i-1).value.lastName;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].gender = this.numberSpouseMarraiges.at(i-1).value.sexAtBirth;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].dobStr = this.numberSpouseMarraiges.at(i-1).value.dateOfBirth;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].dob = {
                date: {
                  year: new Date(this.numberSpouseMarraiges.at(i-1).value.dateOfBirth).getFullYear() || 0,
                  month: new Date(this.numberSpouseMarraiges.at(i-1).value.dateOfBirth).getMonth() + 1 || 0,
                  day: new Date(this.numberSpouseMarraiges.at(i-1).value.dateOfBirth).getDate() || 0
                }
              },
              this.client.clientProfile.Spouses[0].spousesSpouse[i].pia = Utils.removeCurrencyFormatting(this.numberSpouseMarraiges.at(i-1).value.insuranceAmount);
              this.client.clientProfile.Spouses[0].spousesSpouse[i].alive = (this.numberSpouseMarraiges.at(i-1).value.stillAlive == "Yes") ? true : false;
              //this.client.clientProfile.Spouses[i].marriedTenOrMoreYears = this.numberSpouseMarraiges.at(i-1).value.marriedTenOrMoreYears,
              this.client.clientProfile.Spouses[0].spousesSpouse[i].tenyears = (this.numberSpouseMarraiges.at(i-1).value.marriedTenOrMoreYears == "Yes") ? true : false;

              this.client.clientProfile.Spouses[0].spousesSpouse[i].expectedClaimAgeYears = this.numberSpouseMarraiges.at(i-1).value.expectedClaimAgeYears;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].expectedClaimAgeMonths = this.numberSpouseMarraiges.at(i-1).value.expectedClaimAgeMonths;

              this.client.clientProfile.Spouses[0].spousesSpouse[i].exSpouseDateOfBirth = this.numberSpouseMarraiges.at(i-1).value.exSpouseDateOfBirth;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].exSpouseClaimAgeYears = this.numberSpouseMarraiges.at(i-1).value.exSpouseClaimAgeYears;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].exSpouseClaimAgeMonths = this.numberSpouseMarraiges.at(i-1).value.exSpouseClaimAgeMonths;

              this.client.clientProfile.Spouses[0].spousesSpouse[i].yearOfStatement = this.numberSpouseMarraiges.at(i-1).value.yearOfStatement;
              this.client.clientProfile.Spouses[0].spousesSpouse[i].yearAtTimeOfPassing = this.numberSpouseMarraiges.at(i-1).value.yearAtTimeOfPassing;
            }    
          }
  
        }
    
      }
    }

    console.log('saved spouse obj', this.client.clientProfile.Spouses);

    console.log('previouslyMarried', this.prevMarraigesForm.value.marraigeTimes);
    if (this.prevMarraigesForm.value.marraigeTimes > 0 && this.applyQuestionnaireForm.value.previouslyMarried) {
      //TODO: if this does work, its going to break code above this for-loop for spouses spouses - that code block will need to be moved below this (if all is workign)
      //var testOutput = this.client.clientProfile.Spouses.slice(0, 1);
      //console.log('what is this', testOutput);
      //this.client.clientProfile.Spouses = ((this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? testOutput : []);
      if (this.client.clientProfile.Spouses[0].maritalStatus == "Married"){
        //this.client.clientProfile.Spouses.slice(0, 1);
        this.client.clientProfile.Spouses.splice(1);

        /* var testOutput = [...this.client.clientProfile.Spouses];//.slice(0, 1);//[0];
        //this.client.clientProfile.Spouses = [];
        console.log('0 index spouse', testOutput);
        this.client.clientProfile.Spouses = [testOutput[0]]; */
      } else {
        this.client.clientProfile.Spouses = [];
      }
      console.log('reset spouses obj', this.client.clientProfile.Spouses);

      for (var i = 1; i<=this.prevMarraigesForm.value.marraigeTimes; i++) {
        console.log('we in here zss');
        // console.log('this.numberMarraiges.at(i-1).value.exSpouseLifeExpectancy', this.numberMarraiges.at(i-1).value.exSpouseLifeExpectancy);
        // console.log('this.client.clientProfile.Spouses.length', this.client.clientProfile.Spouses.length)

        //NOTE: commented out this block of code because this the fix below im not sure we need this anymroe
        //Survivor Switch
        /* if(this.client.clientProfile.Spouses[0].pia >= 0){
          if(this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" 
          && this.client.clientProfile.Spouses[0].pia < Utils.removeCurrencyFormatting(this.numberMarraiges.at(i-1).value.insuranceAmount)){
            
            this.client.clientProfile.Spouses[0].firstName = this.numberMarraiges.at(i-1).value.firstName;
            this.client.clientProfile.Spouses[0].lastName = this.numberMarraiges.at(i-1).value.lastName;
            this.client.clientProfile.Spouses[0].pia = Utils.removeCurrencyFormatting(this.numberMarraiges.at(i-1).value.insuranceAmount);
            
          }
        }

        if(this.client.clientProfile.Spouses[0].maritalStatus == "Single"
          && this.numberMarraiges.at(i-1).value.prevMarriageTypes == "Widowed"){
            this.client.clientProfile.Spouses[0].maritalStatus = "Widowed";
            this.client.clientProfile.Spouses[0].firstName = this.numberMarraiges.at(i-1).value.firstName;
            this.client.clientProfile.Spouses[0].lastName = this.numberMarraiges.at(i-1).value.lastName;
            this.client.clientProfie.Spouses[0].pia = Utils.removeCurrencyFormatting(this.numberMarraiges.at(i-1).value.insuranceAmount);
            this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing = (this.numberMarraiges.at(i-1).value.spouseCollectAtTimeOfPassing == "Yes") ? true : false;
            if (this.numberMarraiges.at(i-1).value.monthlyBenefitAtPassing) {
              this.client.clientProfile.Spouses[0].monthlyBenefitAtPassing = Utils.removeCurrencyFormatting(this.numberMarraiges.at(i-1).value.monthlyBenefitAtPassing);
            }

        } */


        //TODO: Review this code - if everything works as supposed to, we can remove code above and commented code below
        console.log('this.numberMarraiges', this.numberMarraiges)
        if (this.numberMarraiges.at(i - 1)) {
          console.log('this.numberMarraiges.at(i-1)', this.numberMarraiges.at(i-1))
          
          //this.client.clientProfile.Spouses = [];

          this.client.clientProfile.Spouses.push(
            {
              "maritalStatus": this.numberMarraiges.at(i-1).value.prevMarriageTypes,
              "firstName": this.numberMarraiges.at(i-1).value.firstName,
              "lastName": this.numberMarraiges.at(i-1).value.lastName,
              "gender": this.numberMarraiges.at(i-1).value.sexAtBirth,
              "dob": {
                date: {
                  year: new Date(this.numberMarraiges.at(i-1).value.dateOfBirth).getFullYear() || 0,
                  month: new Date(this.numberMarraiges.at(i-1).value.dateOfBirth).getMonth() + 1 || 0,
                  day: new Date(this.numberMarraiges.at(i-1).value.dateOfBirth).getDate() || 0
                }
              },
              "dobStr": this.numberMarraiges.at(i-1).value.dateOfBirth,
              "pia": Utils.removeCurrencyFormatting(this.numberMarraiges.at(i-1).value.insuranceAmount),
              "alive": (this.numberMarraiges.at(i-1).value.stillAlive == "Yes") ? true : false,
              //"marriedTenOrMoreYears": this.numberMarraiges.at(i-1).value.marriedTenOrMoreYears,
              "tenyears": (this.numberMarraiges.at(i-1).value.marriedTenOrMoreYears == "Yes") ? true : false,
              "spouseCollectAtTimeOfPassing" : (this.numberMarraiges.at(i-1).value.spouseCollectAtTimeOfPassing == "Yes") ? true : false,
              "monthlyBenefitAtPassing": (this.numberMarraiges.at(i-1).value.monthlyBenefitAtPassing) ? Utils.removeCurrencyFormatting(this.numberMarraiges.at(i-1).value.monthlyBenefitAtPassing) : 0,
              "exSpouseLifeExpectancy": (this.numberMarraiges.at(i-1).value.exSpouseLifeExpectancy) ? this.numberMarraiges.at(i-1).value.exSpouseLifeExpectancy : '',
              "expectedClaimAgeYears" : (this.numberMarraiges.at(i-1).value.expectedClaimAgeYears) ? this.numberMarraiges.at(i-1).value.expectedClaimAgeYears : '',
              "expectedClaimAgeMonths" : (this.numberMarraiges.at(i-1).value.expectedClaimAgeMonths) ? this.numberMarraiges.at(i-1).value.expectedClaimAgeMonths : '',
              "exSpouseDateOfBirth": (this.numberMarraiges.at(i-1).value.exSpouseDateOfBirth) ? this.numberMarraiges.at(i-1).value.exSpouseDateOfBirth : '',
              "exSpouseClaimAgeYears": (this.numberMarraiges.at(i-1).value.exSpouseClaimAgeYears) ? this.numberMarraiges.at(i-1).value.exSpouseClaimAgeYears : '',
              "exSpouseClaimAgeMonths": (this.numberMarraiges.at(i-1).value.exSpouseClaimAgeMonths) ? this.numberMarraiges.at(i-1).value.exSpouseClaimAgeMonths : '',
              "yearOfStatement": (this.numberMarraiges.at(i-1).value.yearOfStatement) ? this.numberMarraiges.at(i-1).value.yearOfStatement : '',
              "yearAtTimeOfPassing": (this.numberMarraiges.at(i-1).value.yearAtTimeOfPassing) ? this.numberMarraiges.at(i-1).value.yearAtTimeOfPassing : ''
            }
          );
        }

      }
    } else {
      console.log('here i am');
      if (this.client.clientProfile.Spouses[0].maritalStatus !== 'Married') {
        console.log('here i am 02');
        this.client.clientProfile.Spouses[0].maritalStatus = 'Single';
        if (this.client.clientProfile.Spouses.length > 1) {
          this.client.clientProfile.Spouses.splice(1, this.client.clientProfile.Spouses.length - 1);
        }

        if (this.client.clientProfile.Spouses[0].maritalHistory) {
          delete(this.client.clientProfile.Spouses[0].maritalHistory);
        }
        if (this.client.clientProfile.Spouses[0].firstName) {
          delete(this.client.clientProfile.Spouses[0].firstName);
        }
        if (this.client.clientProfile.Spouses[0].lastName) {
          delete(this.client.clientProfile.Spouses[0].lastName);
        }
      } else {
        console.log('this.prevMarraigesForm.value.marraigeTimes', this.prevMarraigesForm.value.marraigeTimes)
        if(this.prevMarraigesForm.value.marraigeTimes > 0) {
          this.client.clientProfile.Spouses.splice(1, this.client.clientProfile.Spouses.length - 1);
        }
      }

    }
   console.log('this.client.clientProfile.Spouses.', this.client.clientProfile.Spouses)
    const fullDOB = new Date(this.client.client.DOB.toString());
    let birthYear = fullDOB.getFullYear();
    let clientFRA = this.getFRA(birthYear);
    let clientSSDesiredAgeYears = 0;
    let clientSSDesiredAgeMonths = 0;
    let spouseSSDesiredAgeYears = 0;
    let spouseSSDesiredAgeMonths = 0;
    let isClaimAgeVisible =  this.incomeForm.value.isCollectingBenefits !==  'true' && this.globalService.calculateAgeV2(this.client.client.DOB) < 70 ? true: false
    let isSpouseClaimAgeVisible = this.spouseIncomeForm.value.isCollectingBenefits !==  'true' && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) < 70 ? true: false
    isClaimAgeVisible = !isClaimAgeVisible && isSpouseClaimAgeVisible && this.desiredSpouseClaimForm.value.ageYears && this.applySpouseQuestionnaireForm.value.desiredClaimAge ? true: isClaimAgeVisible;
    clientSSDesiredAgeYears = (this.desiredClaimForm.value.ageYears && this.applyQuestionnaireForm.value.desiredClaimAge && isClaimAgeVisible ? this.desiredClaimForm.value.ageYears : clientSSDesiredAgeYears);
    clientSSDesiredAgeMonths = (this.desiredClaimForm.value.ageMonths && this.applyQuestionnaireForm.value.desiredClaimAge && isClaimAgeVisible ? this.desiredClaimForm.value.ageMonths: clientSSDesiredAgeMonths);


    // if (this.incomeForm.value.isCollectingBenefits == 'true') {

    // } else {
    //   if (this.desiredClaimForm.value.ageYears && this.applyQuestionnaireForm.value.desiredClaimAge) {
    //     clientSSDesiredAgeYears = this.desiredClaimForm.value.ageYears;
    //   } 
    //   // else {
    //   //   //clientSSDesiredAgeYears = clientFRA.age;
    //   // }
    // }
    // if (this.desiredClaimForm.value.ageMonths && this.applyQuestionnaireForm.value.desiredClaimAge) {
    //   clientSSDesiredAgeMonths = this.desiredClaimForm.value.ageMonths;
    // } 
    // else {
    //   //clientSSDesiredAgeMonths = clientFRA.month;
    // }
    isSpouseClaimAgeVisible = !isSpouseClaimAgeVisible && isClaimAgeVisible && this.desiredClaimForm.value.ageYears && this.applyQuestionnaireForm.value.desiredClaimAge ? true: isSpouseClaimAgeVisible;
    spouseSSDesiredAgeYears = (this.desiredSpouseClaimForm.value.ageYears && this.applyQuestionnaireForm.value.desiredClaimAge && isSpouseClaimAgeVisible ? this.desiredSpouseClaimForm.value.ageYears : spouseSSDesiredAgeYears);
    spouseSSDesiredAgeMonths = (this.desiredSpouseClaimForm.value.ageMonths && this.applyQuestionnaireForm.value.desiredClaimAge && isSpouseClaimAgeVisible ? this.desiredSpouseClaimForm.value.ageMonths: spouseSSDesiredAgeMonths);
    // if (this.spouseIncomeForm.value.isCollectingBenefits == 'true' && this.spouseIncomeForm.value.dateOfClaimYear && this.spouseIncomeForm.value.dateOfClaimMonth && this.client.clientProfile.Spouses[0].dob ) {
    //   this.client.clientProfile.Spouses[0].sSDesiredAgeYears = spouseSSDesiredAgeYears;
    // }
    // if (this.spouseIncomeForm.value.isCollectingBenefits == 'true' && this.spouseIncomeForm.value.dateOfClaimYear && this.spouseIncomeForm.value.dateOfClaimMonth && this.client.clientProfile.Spouses[0].dob ) {
    //   this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = spouseSSDesiredAgeMonths;
    // }

    // if(this.desiredSpouseClaimForm.value.ageYears && this.applySpouseQuestionnaireForm.value.desiredClaimAge){
    //   spouseSSDesiredAgeYears = this.desiredSpouseClaimForm.value.ageYears;
    // }
    // if (this.desiredSpouseClaimForm.value.ageMonths && this.applySpouseQuestionnaireForm.value.desiredClaimAge) {
    //   spouseSSDesiredAgeMonths = this.desiredSpouseClaimForm.value.ageMonths;
    // }

    if (this.client.clientProfile.Spouses[0] && this.spouseSubstantialEarningsDetails)
      this.client.clientProfile.Spouses[0].SubstantialEarningYearsDetails = this.spouseSubstantialEarningsDetails;
      
    if (this.client.clientProfile.Spouses[0] && this.spousePIACalcData)
      this.client.clientProfile.Spouses[0].PIAYears = this.spousePIACalcData;

    if (this.client.clientProfile.Spouses[0] && this.spouseIncomeForm.get('yearOfStatement').value && this.client.clientProfile.Spouses[0].maritalStatus == 'Married')
      this.client.clientProfile.Spouses[0].yearOfStatement = this.spouseIncomeForm.get('yearOfStatement').value;
    console.log('this.spouseIncomeForm.get.value', this.spouseIncomeForm.get('yearOfStatement').value)
    console.log('with Utils', Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome));
    
    console.log('income ', this.incomeForm.value.currentIncome);
    let pensionAmount = this.applyQuestionnaireForm.value.havePension ? (this.pensionForm.value.annualPensionValue ? Utils.removeCurrencyFormatting(this.pensionForm.value.annualPensionValue) : this.client.clientProfile.Pension): null;
    let pensionInfl = this.applyQuestionnaireForm.value.havePension ? Utils.removePercentageFormatting(this.pensionForm.value.pensionInflationRate) : '3.00';
    console.log("localStorage.getItem('clientLifeExpectancy')", localStorage.getItem('clientLifeExpectancy'));


    var clientProfile = JSON.parse(localStorage.getItem('clientProfile'));
    console.log('clientProfile', clientProfile);

    let lifeExpectancy = clientProfile ? clientProfile.LifeExpectancy ? clientProfile.LifeExpectancy : this.client.clientProfile.LifeExpectancy : this.client.clientProfile.LifeExpectancy;
    let retirementAge = clientProfile ? clientProfile.RetirementAge ? clientProfile.RetirementAge : this.client.clientProfile.RetirementAge : this.client.clientProfile.RetirementAge;
    let retirementState = clientProfile ? clientProfile.RetirementState ? clientProfile.RetirementState : this.client.clientProfile.RetirementState : this.client.clientProfile.RetirementState;
    let HCHBP = clientProfile ? clientProfile.HCHBP || 0 : this.client.clientProfile.HCHBP;
    let HCHC = clientProfile ? clientProfile.HCHC || 0 : this.client.clientProfile.HCHC;
    let HCT2D = clientProfile ? clientProfile.HCT2D || 0 : this.client.clientProfile.HCT2D;
    let HCCD = clientProfile ? clientProfile.HCCD || 0 : this.client.clientProfile.HCCD;
    let HCC = clientProfile ? clientProfile.HCC || 0: this.client.clientProfile.HCC;
    let HCT = clientProfile ? clientProfile.HCT || 0 : this.client.clientProfile.HCT;
    let HCT1D = clientProfile ? clientProfile.HCT1D || 0: this.client.clientProfile.HCT1D;
    let HCMS = clientProfile ? clientProfile.HCMS || 0: this.client.clientProfile.HCMS;
    let HCDCW = clientProfile ? clientProfile.HCDCW || 0: this.client.clientProfile.HCDCW;
    let HCFHDC = clientProfile ? clientProfile.HCFHDC || 0: this.client.clientProfile.HCFHDC;

    let HCALZ = clientProfile ? clientProfile.HCALZ || 0: this.client.clientProfile.HCALZ;
    let HCPARK = clientProfile ? clientProfile.HCPARK || 0: this.client.clientProfile.HCPARK;
    let HCAMP = clientProfile ? clientProfile.HCAMP || 0: this.client.clientProfile.HCAMP;
    let HCPTSD = clientProfile ? clientProfile.HCPTSD || 0: this.client.clientProfile.HCPTSD;
    let HCOBS = clientProfile ? clientProfile.HCOBS || 0: this.client.clientProfile.HCOBS;

    let HCCDYrsDiag = clientProfile ? clientProfile.HCCDYrsDiag || 0 : this.client.clientProfile.HCCDYrsDiag;
    let HCCYrsDiag = clientProfile ? clientProfile.HCCYrsDiag || 0 : this.client.clientProfile.HCCYrsDiag;
    let isLegalSpouse = clientProfile ? clientProfile.IsLegalSpouse ? clientProfile.IsLegalSpouse : this.client.clientProfile.IsLegalSpouse : this.client.clientProfile.IsLegalSpouse;
    let IsRunReportWithSpouse = clientProfile ? clientProfile.IsRunReportWithSpouse ? clientProfile.IsRunReportWithSpouse : this.client.clientProfile.IsRunReportWithSpouse : this.client.clientProfile.IsRunReportWithSpouse;

    if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      if(this.client.clientProfile.Spouses[0].LifeExpectancy) {
        this.client.clientProfile.Spouses[0].LifeExpectancy = clientProfile ? clientProfile.Spouses[0].LifeExpectancy ? clientProfile.Spouses[0].LifeExpectancy : this.client.clientProfile.Spouses[0].LifeExpectancy : this.client.clientProfile.Spouses[0].LifeExpectancy;
      }
      if (clientProfile) {
        clientProfile.Spouses = JSON.parse(clientProfile.Spouses);
      }
      this.client.clientProfile.Spouses[0].HCHBP =  clientProfile ? clientProfile.Spouses[0].HCHBP ? clientProfile.Spouses[0].HCHBP : this.client.clientProfile.Spouses[0].HCHBP || 0 : this.client.clientProfile.Spouses[0].HCHBP || 0;
      this.client.clientProfile.Spouses[0].HCHC =  clientProfile ? clientProfile.Spouses[0].HCHC ? clientProfile.Spouses[0].HCHC : this.client.clientProfile.Spouses[0].HCHC || 0 : this.client.clientProfile.Spouses[0].HCHC || 0;
      this.client.clientProfile.Spouses[0].HCT2D =  clientProfile ? clientProfile.Spouses[0].HCT2D ? clientProfile.Spouses[0].HCT2D : this.client.clientProfile.Spouses[0].HCT2D || 0 : this.client.clientProfile.Spouses[0].HCT2D || 0;
      this.client.clientProfile.Spouses[0].HCCD =  clientProfile ? clientProfile.Spouses[0].HCCD ? clientProfile.Spouses[0].HCCD : this.client.clientProfile.Spouses[0].HCCD || 0 : this.client.clientProfile.Spouses[0].HCCD || 0;
      this.client.clientProfile.Spouses[0].HCC =  clientProfile ? clientProfile.Spouses[0].HCC ? clientProfile.Spouses[0].HCC : this.client.clientProfile.Spouses[0].HCC || 0 : this.client.clientProfile.Spouses[0].HCC || 0;
      this.client.clientProfile.Spouses[0].HCT =  clientProfile ? clientProfile.Spouses[0].HCT ? clientProfile.Spouses[0].HCT : this.client.clientProfile.Spouses[0].HCT || 0 : this.client.clientProfile.Spouses[0].HCT || 0;
      this.client.clientProfile.Spouses[0].HCT1D =  clientProfile ? clientProfile.Spouses[0].HCT1D ? clientProfile.Spouses[0].HCT1D : this.client.clientProfile.Spouses[0].HCT1D || 0 : this.client.clientProfile.Spouses[0].HCT1D || 0;
      this.client.clientProfile.Spouses[0].HCMS =  clientProfile ? clientProfile.Spouses[0].HCMS ? clientProfile.Spouses[0].HCMS : this.client.clientProfile.Spouses[0].HCMS || 0 : this.client.clientProfile.Spouses[0].HCMS || 0;
      this.client.clientProfile.Spouses[0].HCDCW =  clientProfile ? clientProfile.Spouses[0].HCDCW ? clientProfile.Spouses[0].HCDCW : this.client.clientProfile.Spouses[0].HCDCW || 0 : this.client.clientProfile.Spouses[0].HCDCW || 0;
      this.client.clientProfile.Spouses[0].HCFHDC =  clientProfile ? clientProfile.Spouses[0].HCFHDC ? clientProfile.Spouses[0].HCFHDC : this.client.clientProfile.Spouses[0].HCFHDC || 0 : this.client.clientProfile.Spouses[0].HCFHDC || 0;

      this.client.clientProfile.Spouses[0].HCALZ =  clientProfile ? clientProfile.Spouses[0].HCALZ ? clientProfile.Spouses[0].HCALZ : this.client.clientProfile.Spouses[0].HCALZ || 0 : this.client.clientProfile.Spouses[0].HCALZ || 0;
      this.client.clientProfile.Spouses[0].HCPARK =  clientProfile ? clientProfile.Spouses[0].HCPARK ? clientProfile.Spouses[0].HCPARK : this.client.clientProfile.Spouses[0].HCPARK || 0 : this.client.clientProfile.Spouses[0].HCPARK || 0;
      this.client.clientProfile.Spouses[0].HCAMP =  clientProfile ? clientProfile.Spouses[0].HCAMP ? clientProfile.Spouses[0].HCAMP : this.client.clientProfile.Spouses[0].HCAMP || 0 : this.client.clientProfile.Spouses[0].HCAMP || 0;
      this.client.clientProfile.Spouses[0].HCPTSD =  clientProfile ? clientProfile.Spouses[0].HCPTSD ? clientProfile.Spouses[0].HCPTSD : this.client.clientProfile.Spouses[0].HCPTSD || 0 : this.client.clientProfile.Spouses[0].HCPTSD || 0;
      this.client.clientProfile.Spouses[0].HCOBS =  clientProfile ? clientProfile.Spouses[0].HCOBS ? clientProfile.Spouses[0].HCOBS : this.client.clientProfile.Spouses[0].HCOBS || 0 : this.client.clientProfile.Spouses[0].HCOBS || 0;

      this.client.clientProfile.Spouses[0].HCCDYrsDiag =  clientProfile ? clientProfile.Spouses[0].HCCDYrsDiag ? clientProfile.Spouses[0].HCCDYrsDiag : this.client.clientProfile.Spouses[0].HCCDYrsDiag || 0 : this.client.clientProfile.Spouses[0].HCCDYrsDiag || 0;
      this.client.clientProfile.Spouses[0].HCCYrsDiag =  clientProfile ? clientProfile.Spouses[0].HCCYrsDiag ? clientProfile.Spouses[0].HCCYrsDiag : this.client.clientProfile.Spouses[0].HCCYrsDiag || 0 : this.client.clientProfile.Spouses[0].HCCYrsDiag || 0;

      this.client.clientProfile.Spouses[0].firstName = clientProfile ? clientProfile.Spouses[0].firstName ? clientProfile.Spouses[0].firstName : this.client.clientProfile.Spouses[0].firstName: this.client.clientProfile.Spouses[0].firstName;
      this.client.clientProfile.Spouses[0].lastName = clientProfile ? clientProfile.Spouses[0].lastName ? clientProfile.Spouses[0].lastName : this.client.clientProfile.Spouses[0].lastName: this.client.clientProfile.Spouses[0].lastName;
      this.client.clientProfile.Spouses[0].retirementAge = clientProfile ? clientProfile.Spouses[0].retirementAge ? clientProfile.Spouses[0].retirementAge : this.client.clientProfile.Spouses[0].retirementAge: this.client.clientProfile.Spouses[0].retirementAge;
      this.client.clientProfile.Spouses[0].state = clientProfile ? clientProfile.Spouses[0].state ? clientProfile.Spouses[0].state : this.client.clientProfile.Spouses[0].state: this.client.clientProfile.Spouses[0].state;
      this.client.clientProfile.Spouses[0].gender = clientProfile ? clientProfile.Spouses[0].gender ? clientProfile.Spouses[0].gender : this.client.clientProfile.Spouses[0].gender: this.client.clientProfile.Spouses[0].gender;
      this.client.clientProfile.Spouses[0].dob = clientProfile ? clientProfile.Spouses[0].dob ? clientProfile.Spouses[0].dob : this.client.clientProfile.Spouses[0].dob: this.client.clientProfile.Spouses[0].dob;
      this.client.clientProfile.Spouses[0].isLegalSpouse = clientProfile ? clientProfile.Spouses[0].isLegalSpouse ? clientProfile.Spouses[0].isLegalSpouse : this.client.clientProfile.Spouses[0].isLegalSpouse: this.client.clientProfile.Spouses[0].isLegalSpouse;
      this.client.clientProfile.Spouses[0].maritalStatus = clientProfile ? clientProfile.Spouses[0].maritalStatus ? clientProfile.Spouses[0].maritalStatus : this.client.clientProfile.Spouses[0].maritalStatus: this.client.clientProfile.Spouses[0].maritalStatus;
      console.log('this.client.clientProfile', this.client.clientProfile);
    }
    
    

    var ClientProfile = {
      ClientID: this.client.clientProfile.ClientID,
      MaritalStatus: (this.client.clientProfile.MaritalStatus == "Single" && this.applyQuestionnaireForm.value.previouslyMarried) ? "Widowed" : this.client.clientProfile.MaritalStatus,
      //CurrentIncome: Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome),// this.client.clientProfile.CurrentIncome,
      CurrentIncome: this.incomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome) : this.client.clientProfile.CurrentIncome,
      IRR: this.incomeEntryForm.value.IncomeReplacementRatio ? Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio) : (this.incomeEntryForm.value.YearOneRetirementIncome ? null: this.client.clientProfile.IRR),
      SelfIRR: this.incomeEntryForm.value.IncomeReplacementRatio ? Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeReplacementRatio) : (this.incomeEntryForm.value.YearOneRetirementIncome ? null: this.client.clientProfile.IRR),

      RetirementAge: retirementAge,
      RetirementState: retirementState,
      SpouseID: this.client.clientProfile.SpouseID,
      LifeExpectancy: lifeExpectancy,
      HCHBP: HCHBP ? 1 : 0,
      HCHC: HCHC ? 1 : 0,
      HCT2D: HCT2D ? 1 : 0,
      HCCD: HCCD ? 1 : 0,
      HCC: HCC ? 1 : 0,
      HCT: HCT ? 1 : 0,   
      HCT1D: HCT1D ? 1 : 0,
      HCMS: HCMS ? 1 : 0,
      HCDCW: HCDCW ? 1 : 0,
      HCFHDC: HCFHDC ? 1 : 0,

      HCALZ: HCALZ ? 1 : 0,
      HCPARK: HCPARK ? 1 : 0,
      HCAMP: HCAMP ? 1 : 0,
      HCPTSD: HCPTSD ? 1 : 0,
      HCOBS: HCOBS ? 1 : 0,

      HCCDYrsDiag: HCCDYrsDiag ? 1 : 0,
      HCCYrsDiag: HCCYrsDiag ? 1 : 0,
      
      Children: (this.applyQuestionnaireForm.value.haveNonDisabledChild || this.applyQuestionnaireForm.value.haveDisabledChild || this.applyQuestionnaireForm.value.haveDepChild) ? (children && children.length > 0 ? JSON.stringify(children) : '[]') : '[]',
      IncludePension: this.applyQuestionnaireForm.value.havePension ? 1 : 0, //this.client.clientProfile.IncludePension,
      
      SelfPIA: this.incomeForm.value.pia ? Utils.removeCurrencyFormatting(this.incomeForm.value.pia) : null,
      PIA: this.incomeForm.value.pia ? Utils.removeCurrencyFormatting(this.incomeForm.value.pia) : null,
      //SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.pia) : 0, 
      //this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spousePIA.toString().replace(/,/g,"").replace("$","") : 0,
      PIAYears: JSON.stringify(this.piaCalcData) || this.client.clientProfile.PIAYears,
      SelfAlreadyCollecting: this.incomeForm.value.isCollectingBenefits == 'true'? true: false,
      // SelfCurrentMonthlyBenefit: (this.incomeForm.value.isCollectingBenefits) ? Utils.removeCurrencyFormatting(this.incomeForm.value.monthlyBenefits) : (this.client.clientProfile.MonthlyBenefitAmount ? this.client.clientProfile.MonthlyBenefitAmount : 0),//this.incomeForm.value.isCollectingBenefits ? this.incomeForm.value.monthlyBenefits || 0 : 0,
      // MonthlyBenefitAmount: (this.incomeForm.value.isCollectingBenefits == 'true') ? Utils.removeCurrencyFormatting(this.incomeForm.value.monthlyBenefits) : (this.client.clientProfile.MonthlyBenefitAmount ? this.client.clientProfile.MonthlyBenefitAmount : 0),
      MonthlyBenefitAmount: (this.incomeForm.value.isCollectingBenefits == 'true') ? Utils.removeCurrencyFormatting(this.incomeForm.value.monthlyBenefits) : 0,

      SpouseAlreadyCollecting: this.spouseIncomeForm.value.isCollectingBenefits == 'true'? true: false,      
	    // SpouseCurrentMonthlyBenefit: this.spouseIncomeForm.value.isCollectingBenefits ? Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.monthlyBenefits) || 0 : 0,

      UseNationalAverage: this.client.clientProfile.UseNationalAverage,
      IsRunReportWithSpouse: IsRunReportWithSpouse,
      IsLegalSpouse: isLegalSpouse,

      IsPrivHealthIns: this.client.clientProfile.IsPrivHealthIns,
      CoverageType: this.client.clientProfile.CoverageType,
      PremiumType: this.client.clientProfile.PremiumType,
      Premiums:  this.client.clientProfile.Premiums,
      IsHSApplySpouse: this.client.clientProfile.IsHSApplySpouse,
      IsSpousePrivHealthIns: this.client.clientProfile.IsSpousePrivHealthIns,
      SpouseCoverageType: this.client.clientProfile.SpouseCoverageType,
      SpousePremiumType: this.client.clientProfile.SpousePremiumType,
      SpousePremiums: this.client.clientProfile.SpousePremiums,

      Bracket: this.client.clientProfile.Bracket,
      InflationRate: (this.incomeEntryForm.value.IncomeInflationRate) ? Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate) >= 0 ? Utils.removePercentageFormatting(this.incomeEntryForm.value.IncomeInflationRate) : this.client.clientProfile.InflationRate : (this.incomeEntryForm.value.YearOneRetirementIncome ? null : this.client.clientProfile.InflationRate),
      HouseholdYearOneIncome: this.incomeEntryForm.value.YearOneRetirementIncome ? Utils.removeCurrencyFormatting(this.incomeEntryForm.value.YearOneRetirementIncome) : (this.incomeEntryForm.value.IncomeReplacementRatio ? null : this.client.clientProfile.HouseholdYearOneIncome),
      //HouseholdYearOneIncome: Utils.removeCurrencyFormatting((this.incomeEntryForm.value.YearOneRetirementIncome > 0) ? this.incomeEntryForm.value.YearOneRetirementIncome : this.incomeEntryForm.value.HouseHoldIncome),

      HouseholdYearOneIncomeChangeYear: this.client.clientProfile.HouseholdYearOneIncomeChangeYear,
      InRetirementInflationRate: Utils.removePercentageFormatting(this.additinalIncomeForm.value.InRetInflationRate) >= -5 ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.InRetInflationRate) : this.client.clientProfile.InRetirementInflationRate,
      MAGIPercentIncome: (this.additinalIncomeForm.value.MAGIPerc) ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.MAGIPerc) > 0 ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.MAGIPerc) : this.client.clientProfile.MAGIPercentIncome : this.client.clientProfile.MAGIPercentIncome,

      OOPCosts: this.client.clientProfile.OOPCosts,
      SpouseOOPCosts: this.client.clientProfile.SpouseOOPCosts,
      ClientMetroArea: this.client.clientProfile.ClientMetroArea,
      SpouseMetroArea: this.client.clientProfile.SpouseMetroArea,
      Pension: pensionAmount,
      PensionInfl: pensionInfl,
      //IncludePension: pensionAmount ? (pensionAmount > 0 ? 1 : 0) : 0,
      PensionMonths: this.applyQuestionnaireForm.value.havePension ? (this.pensionForm.value.pensionStartMonth ? this.pensionForm.value.pensionStartMonth : this.client.clientProfile.PensionMonths): null,
      PensionYears: this.applyQuestionnaireForm.value.havePension ? (this.pensionForm.value.pensionStartYear ? this.pensionForm.value.pensionStartYear : this.client.clientProfile.PensionYears): null,
      SubstantialEarningYears: this.applyQuestionnaireForm.value.havePension ? (this.pensionForm.value.substantialEarningYear ? this.pensionForm.value.substantialEarningYear : this.client.clientProfile.SubstantialEarningYears): null,
      //MonthlyBenefitAmount: this.isAlreadyCollectSS ? this.alreadyCollectedSSForm.value.monthlyBenefitAmount: 0,
      // SSDesiredAgeYears: this.applyQuestionnaireForm.value.desiredClaimAge ? (!this.client.clientProfile.InvertSurvivorSwitch ? clientSSDesiredAgeYears : this.client.clientProfile.SSDesiredAgeYears): null,
      // SSDesiredAgeMonths: this.applyQuestionnaireForm.value.desiredClaimAge ? (!this.client.clientProfile.InvertSurvivorSwitch ? clientSSDesiredAgeMonths : (this.client.clientProfile.SSDesiredAgeYears? this.client.clientProfile.SSDesiredAgeMonths || 0 : null)): null,

      // SurvivorSwitchYears: this.applyQuestionnaireForm.value.desiredClaimAge || (this.isSpouseApplyQuestionnaire && this.applySpouseQuestionnaireForm.value.desiredClaimAge) ? (this.client.clientProfile.InvertSurvivorSwitch ? clientSSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears): null,
      // SurvivorSwitchMonths: this.applyQuestionnaireForm.value.desiredClaimAge || (this.isSpouseApplyQuestionnaire && this.applySpouseQuestionnaireForm.value.desiredClaimAge) ? (this.client.clientProfile.InvertSurvivorSwitch ? clientSSDesiredAgeMonths : (this.client.clientProfile.SurvivorSwitchYears? this.client.clientProfile.SurvivorSwitchMonths || 0 : null)): null,

      SSDesiredAgeYears: this.applyQuestionnaireForm.value.desiredClaimAge ? clientSSDesiredAgeYears: null,
      SSDesiredAgeMonths: this.applyQuestionnaireForm.value.desiredClaimAge ? clientSSDesiredAgeMonths: null,

      SurvivorSwitchYears: this.applyQuestionnaireForm.value.desiredClaimAge || (this.isSpouseApplyQuestionnaire && this.applySpouseQuestionnaireForm.value.desiredClaimAge) ?this.client.clientProfile.SurvivorSwitchYears: null,
      SurvivorSwitchMonths: this.applyQuestionnaireForm.value.desiredClaimAge || (this.isSpouseApplyQuestionnaire && this.applySpouseQuestionnaireForm.value.desiredClaimAge) ? this.client.clientProfile.SurvivorSwitchMonths: null,
      
      SpouseSSDesiredAgeYears: spouseSSDesiredAgeYears,//clientSSDesiredAgeYears,
      SpouseSSDesiredAgeMonths: spouseSSDesiredAgeMonths,//clientSSDesiredAgeMonths,

      Spouses: JSON.stringify(this.client.clientProfile.Spouses),
      InRetFirstYearIncome: this.applyQuestionnaireForm.value.partTimeWork ? (this.inRetEarningForm.value.firstYearRet ? Utils.removeCurrencyFormatting(this.inRetEarningForm.value.firstYearRet): null): null,
      InRetStopWorkAge: this.inRetEarningForm.value.stopWorkAge,

      SelfKnownBenefitClaiming: (this.incomeForm.value.knownBenefitClaiming) ? Utils.removeCurrencyFormatting(this.incomeForm.value.knownBenefitClaiming) : null,
      SubstantialEarningYearsDetails: this.substantialEarningsDetails.startYear ? JSON.stringify(this.substantialEarningsDetails) : this.client.clientProfile.SubstantialEarningYearsDetails,
      YearOfStatement: this.incomeForm.get('yearOfStatement').value,

      DateOfClaimYear: this.incomeForm.value.dateOfClaimYear,
      DateOfClaimMonth:  this.incomeForm.value.dateOfClaimMonth
    }

     console.log('clientProfile saved', ClientProfile);
     //console.log('object for saving SS', Utils.removeCurrencyFormatting(this.incomeEntryForm.value.IncomeReplacementRatio));
    var MidRetirementAdj = null;
    if (this.params == 'income' || this.params == '' || this.params == 'editAll' || this.params == 'socialSecurity' || this.params.includes('empty')) {
      MidRetirementAdj = {
        Year: this.additinalIncomeForm.value.RetAdjYear > 0 ? this.additinalIncomeForm.value.RetAdjYear: null,
        ReductionDollar: this.additinalIncomeForm.value.RetAdjReductionDollar  ? Utils.removeCurrencyFormatting(this.additinalIncomeForm.value.RetAdjReductionDollar): null,
        ReductionPerc: this.additinalIncomeForm.value.RetAdjReductionPerc  ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.RetAdjReductionPerc): null,
        IncomeInflationRate: this.additinalIncomeForm.value.RetAdjReductionInflation ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.RetAdjReductionInflation) : null
      }  
    }


    var modalData;
    let LstMAGIProj = [];
    if (this.isMAGIUpdate) {
      console.log('isMAGIUpdate', this.isMAGIUpdate);
      for(var data of this.mmtModalData) {
        modalData = {
          Year: Number(data.year),
          Age: data.age,
          // Income: Number(data.fullMAGI.toString().includes('$')? Utils.removeCurrencyFormatting(data.fullMAGI): data.fullMAGI),
          Income: Number(Utils.removeCurrencyFormatting(data.fullMAGI.toString())),
          MAGI: Number(Utils.removeCurrencyFormatting(data.percentMAGI.toString())),
          Bracket: Number(data.updatedBracket)
        }
        LstMAGIProj.push(modalData);
      }
    }

    var AdditionalQuestion = null; //undefined
    if (this.params == '' || this.params == 'emptyAll' || this.params == 'editAll' || this.params == 'additionalQuestions') {
      AdditionalQuestion = {
        Firm: this.additionalQuestionsForm.value.Firm,
        PlanSponsor: this.additionalQuestionsForm.value.PlanSponsor,
        Wholesaler: this.additionalQuestionsForm.value.Wholesaler,
        SendReportTo: this.additionalQuestionsForm.value.SendReportTo,
        RepName: this.additionalQuestionsForm.value.RepName,
        MeetingReference: this.additionalQuestionsForm.value.MeetingReference,
        ReportRequestFrom: this.additionalQuestionsForm.value.ReportRequestFrom,
        //FromHCLTCComb: 'LTC'
      }
    }

    var RiskTolerance = null;
    console.log('ClientProfile', ClientProfile);
    console.log('MidRetirementAdj', MidRetirementAdj);
    
    /* if(this.params == ''){
      if(this.globalService.featQuickReports){
        this.router.navigate(['/clients/edit/social-security/options']);
      } else {
        this.router.navigate(['/clients/edit/social-security/options/ss']);
      }
    } else {
      this.router.navigate(['/clients/edit']);
    } */

    this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion, MidRetirementAdj, LstMAGIProj)
    .subscribe(
      resp => {
        if (this.isEnableUpdateButton || this.isEditAll) {
          this.router.navigate(['/clients/edit']);
        } 
      },
      error => {
        this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
      });
  }

  handleClientPensionToggle(duration) {
    let annual = this.applyQuestionnaireForm.value.havePension ? (this.pensionForm.value.annualPensionValue ? Utils.removeCurrencyFormatting(this.pensionForm.value.annualPensionValue) : 1) : 1;
    let monthly = this.applyQuestionnaireForm.value.havePension ? (this.pensionForm.value.monthlyPensionValue ? Utils.removeCurrencyFormatting(this.pensionForm.value.monthlyPensionValue) : 1) : 1;
    if (duration === 0) {
      if (annual === 0 || monthly === 0) {
        this.pensionForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(1));
        this.pensionForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(1));
      } else if (annual)
        this.pensionForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((annual / 12).toFixed(0)))));
      else
        this.pensionForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((monthly * 12).toFixed(0)))));
    } else if (duration === 1) {
      if (annual === 0 || monthly === 0) {
        this.pensionForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(1));
        this.pensionForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(1));
      } else if (monthly)
        this.pensionForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((monthly * 12).toFixed(0)))));
      else
        this.pensionForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((annual / 12).toFixed(0)))));
    }
  }

  handleSpousePensionToggle(duration) {
    let annual = this.applySpouseQuestionnaireForm.value.havePension ? (this.pensionSpouseForm.value.annualPensionValue ? Utils.removeCurrencyFormatting(this.pensionSpouseForm.value.annualPensionValue) : 0) : 0;
    let monthly = this.applySpouseQuestionnaireForm.value.havePension ? (this.pensionSpouseForm.value.monthlyPensionValue ? Utils.removeCurrencyFormatting(this.pensionSpouseForm.value.monthlyPensionValue) : 0) : 0;
    
    if (duration === 0) {
      if (annual === 0 || monthly === 0) {
        this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(1));
        this.pensionSpouseForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(1));
      } else if (annual)
        this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((annual / 12).toFixed(0)))));
      else
        this.pensionSpouseForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((monthly * 12).toFixed(0)))));
    } else if (duration === 1) {
      if (annual === 0 || monthly === 0) {
        this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(1));
        this.pensionSpouseForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(1));
      } else if (monthly)
        this.pensionSpouseForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((monthly * 12).toFixed(0)))));
      else
        this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((annual / 12).toFixed(0)))));
    }
  }

  boolSetYearAfterSpouse: boolean = false;
  setYearAfterSpouse(value){
    this.boolSetYearAfterSpouse = (this.boolSetYearAfterSpouse) ? false : true;
    //console.log('setYearAfterSpouse', this.boolSetYearAfterSpouse);

    //For married couples who do not pass away in the same year
    //When clicked, the year of first spouse death plus one is pre-populated into the “Year” input field. 
    if(this.boolSetYearAfterSpouse){
      this.additinalIncomeForm.controls['RetAdjYear'].patchValue(this.getFirstSpouseDeathPlusOne());
    } else {
      this.additinalIncomeForm.controls['RetAdjYear'].patchValue('');
    }

    this.client.clientProfile.Spouses[0].setYearAfterSpouse = this.boolSetYearAfterSpouse;
  }

  getFirstSpouseDeathPlusOne() {
    var clientPassYear = ((this.client.clientProfile.LifeExpectancy - this.globalService.calculateAgeV2(this.client.client.DOB)) + new Date().getFullYear()) + 1;
    var spousePassYear = ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob)) + new Date().getFullYear()) + 1;
    return clientPassYear > spousePassYear ? spousePassYear : clientPassYear
  }

  formatMidRetDollar(amount, scenario) {
    if (scenario == '') {
      return Utils.formatToCurrency(amount)
    }

    // amount = amount.replace(/\D/g, '');
    amount = amount.replace(/(?!-)[^0-9.]/g, "");
    var newAmount = '';
    newAmount += amount.charAt(0);
    for (var i = 1; i < amount.length; i++) {
        
      if (amount.charAt(i) != '-') {
        console.log('char -');
        console.log('amount', amount);
        newAmount += amount.charAt(i);
        console.log('newAmount', newAmount);
        amount.toString().replace("-", "");
      } else {
        amount = newAmount;
      }
    }

    if (amount != '') {
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      if (scenario == 'retAdjReductionDollar') {
        if (this.additinalIncomeForm.value.RetAdjReductionPerc && amount) {
          this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue('');
        }
        this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue(Utils.formatToCurrency(amount));
        this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
        this.additinalIncomeForm.get('RetAdjYear').setValidators([Validators.required]);
        this.additinalIncomeForm.controls['RetAdjYear'].updateValueAndValidity();
      }
    } else {
      if (!this.additinalIncomeForm.value.RetAdjReductionPerc) {
        this.additinalIncomeForm.get('RetAdjReductionInflation').setValidators([Validators.required])
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
      }
      console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 01', this.additinalIncomeForm.value.RetAdjReductionDollar);
      if (!this.additinalIncomeForm.value.RetAdjReductionDollar) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 02', this.additinalIncomeForm.value.RetAdjReductionDollar);
      }
      if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !Utils.removeCurrencyFormatting(this.additinalIncomeForm.value.RetAdjReductionDollar) && !this.additinalIncomeForm.value.RetAdjReductionPerc && !this.additinalIncomeForm.value.RetAdjYear) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 03', this.additinalIncomeForm.value.RetAdjReductionDollar);
        this.clearMidRetValidation();
      }
    }

  }
  clearMidRetValidation() {
    this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
    this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
    this.additinalIncomeForm.get('RetAdjReductionDollar').clearValidators();
    this.additinalIncomeForm.controls['RetAdjReductionDollar'].updateValueAndValidity();
    this.additinalIncomeForm.get('RetAdjReductionPerc').clearValidators();
    this.additinalIncomeForm.controls['RetAdjReductionPerc'].updateValueAndValidity();
    this.additinalIncomeForm.get('RetAdjYear').clearValidators();
    this.additinalIncomeForm.controls['RetAdjYear'].updateValueAndValidity();

  }


  handleEarningHistorySelection() {
    this.toggleSEYSelection(false);
  }

  handleEarningHistorySpouseSelection() {
    this.toggleSpouseSEYSelection(false);
  }

  formatMidRetPer(event, scenario) {
    const key = event.keyCode || event.charCode;
    var value = event.target.value;
    value = value.replace(/(?!-)[^0-9.]/g, "");
    var newValue = '';
    newValue += value.charAt(0);
    for (var i = 1; i < value.length; i++) {
        
      if (value.charAt(i) != '-') {
        console.log('char -');
        console.log('value', value);
        newValue += value.charAt(i);
        console.log('newValue', newValue);
        value.toString().replace("-", "");
      } else {
        value = newValue;
      }
    }
    var isDeleting = false;
    if(key === 8 || key === 46){
      isDeleting = true;
    }
    if (value != '') {
      if (scenario == 'retAdjReductionPerc') {
        if (this.additinalIncomeForm.value.RetAdjReductionDollar && value) {
          this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue('');
        }
        this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
        if (this.additinalIncomeForm.value.RetAdjReductionPerc) {
          this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
          this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
        }
        this.additinalIncomeForm.get('RetAdjYear').setValidators([Validators.required]);
      }
    } else {
      if (!this.additinalIncomeForm.value.RetAdjReductionDollar) {
        this.additinalIncomeForm.get('RetAdjReductionInflation').setValidators([Validators.required])
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
      }
      if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && !this.additinalIncomeForm.value.RetAdjYear) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 03', this.additinalIncomeForm.value.RetAdjReductionDollar);
        this.clearMidRetValidation();
      }

    }
  }

  formatNumber(amount, scenario) {
    amount = amount.replace(/\D/g, '');
    if (scenario == 'yearOfStatement') {
      this.incomeForm.controls['yearOfStatement'].patchValue(amount);
    }
    if (scenario == 'spouseYearOfStatement') {
      this.spouseIncomeForm.controls['yearOfStatement'].patchValue(amount);
    }
  }

  formatCurrency(amount, scenario) {
    console.log('scenario', scenario);
    if (scenario == '') {
      return Utils.formatToCurrency(amount)
    }

    amount = amount.replace(/\D/g, '');
    if (amount != '') {
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      
      if (scenario == 'annualPensionValue') {
        this.pensionForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number(amount))));
        this.pensionForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((amount / 12).toFixed(2)))));
      }
      if (scenario == 'monthlyPensionValue') {
        this.pensionForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number(amount))));
        this.pensionForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((amount * 12).toFixed(0)))));
      }
      if (scenario == 'annualSpousePensionValue') {
        this.pensionSpouseForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number(amount))));
        this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((amount / 12).toFixed(2)))));
      }
      if (scenario == 'monthlySpousePensionValue') {
        this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number(amount))));
        this.pensionSpouseForm.controls['annualPensionValue'].patchValue(Utils.formatToCurrency(Math.max(1, Number((amount * 12).toFixed(0)))));
      }
      if (scenario == 'firstYearRet') {
        this.inRetEarningForm.controls['firstYearRet'].patchValue(Utils.formatToCurrency(amount));
      }
      if (scenario == 'firstYearSpouseRet') {
        this.inRetSpouseEarningForm.controls['firstYearRet'].patchValue(Utils.formatToCurrency(amount));
      }
      if (scenario == 'currentIncome') {
        if (amount > 5000000) {
          this.incomeForm.controls['currentIncome'].patchValue('$'+amount);
          this.incomeForm.controls['currentIncome'].setErrors({'incorrect': true});
        } else {
          this.incomeForm.controls['currentIncome'].patchValue(Utils.formatToCurrency(amount));
        }
      }
      if (scenario == 'pia') {
        this.incomeForm.controls['pia'].patchValue(Utils.formatToCurrency(amount));
      }
      if (scenario == 'knownBenefitClaiming') {
        this.incomeForm.controls['knownBenefitClaiming'].patchValue(Utils.formatToCurrency(amount));
      }
      if (scenario == 'monthlyBenefits') {  
        const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
          //cant be older than max
          parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
          //cant be younger than min
          || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
          ? {invalidDate: 'Please make sure current monthly benefit is between $' + minAge + ' and $' + maxAge + '.' }  
          : null;      
        this.incomeForm.controls['monthlyBenefits'].patchValue(Utils.formatToCurrency(amount));
        this.incomeForm.get("monthlyBenefits").setValidators([Validators.required, validateBenefits(250, 6000)]);
        this.incomeForm.controls['monthlyBenefits'].updateValueAndValidity();
        
        if (this.incomeForm.value.isCollectingBenefits == 'true') {
          this.incomeForm.get("monthlyBenefits").setValidators([Validators.required]);
        }
      }
      if (scenario == 'currentIncomeSpouse') {
        console.log('this.incomeForm.value.currentIncome', this.incomeForm.value.currentIncome)
        let clientCurrentIncome = this.incomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome): 0;
        let spouseMaxIncome = clientCurrentIncome > 0 ? 5000000 - clientCurrentIncome: 5000000;
        console.log('maxValue', spouseMaxIncome)
        if (amount > spouseMaxIncome) {
          this.spouseIncomeForm.controls['currentIncome'].patchValue('$'+amount);
          this.spouseIncomeForm.controls['currentIncome'].setErrors({'incorrect': true});
        } else {
          this.spouseIncomeForm.controls['currentIncome'].patchValue(Utils.formatToCurrency(amount));
        }
        this.spouseMaxIncome = Utils.formatToCurrency(spouseMaxIncome);
        
      }
      if (scenario == 'piaSpouse') {
        this.spouseIncomeForm.controls['pia'].patchValue(Utils.formatToCurrency(amount));
      }
      if (scenario == 'monthlyBenefitsSpouse') {
        const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
          //cant be older than max
          parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
          //cant be younger than min
          || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
          ? {invalidDate: 'Please make sure current monthly benefit is between $' + minAge + ' and $' + maxAge + '.' }  
          : null;      
        this.spouseIncomeForm.controls['monthlyBenefits'].patchValue(Utils.formatToCurrency(amount));
        this.spouseIncomeForm.get("monthlyBenefits").setValidators([Validators.required, validateBenefits(250, 6000)]);
        this.spouseIncomeForm.controls['monthlyBenefits'].updateValueAndValidity();

        //this.spouseIncomeForm.controls['monthlyBenefits'].patchValue(Utils.formatToCurrency(amount));
      }
      if (scenario == 'houseHoldIncome') {
        if (amount > 5000000) {
          this.incomeEntryForm.controls['HouseHoldIncome'].patchValue('$'+amount);
          this.incomeEntryForm.controls['HouseHoldIncome'].setErrors({'incorrect': true});
        } else {
          this.incomeEntryForm.controls['HouseHoldIncome'].patchValue(Utils.formatToCurrency(amount));
        }
        
      }
      if (scenario == 'yearOneRetirementIncome') {
        this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue(Utils.formatToCurrency(amount));
      }
      if (scenario == 'knownBenefitClaimingSpouse') {
        this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue(Utils.formatToCurrency(amount));
      }
      // if (scenario == 'retAdjReductionDollar') {
      //   if (this.additinalIncomeForm.value.RetAdjReductionPerc && amount) {
      //     this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue('');
      //   }
      //   this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue(Utils.formatToCurrency(amount));
      // }

    } else {
      if (scenario == 'annualPensionValue') {
        this.pensionForm.controls['annualPensionValue'].patchValue('');
      }
      if (scenario == 'monthlyPensionValue') {
        this.pensionForm.controls['monthlyPensionValue'].patchValue('');
      }
      if (scenario == 'annualSpousePensionValue') {
        this.pensionSpouseForm.controls['annualPensionValue'].patchValue('');
      }
      if (scenario == 'monthlySpousePensionValue') {
        this.pensionSpouseForm.controls['monthlyPensionValue'].patchValue('');
      }
      if (scenario == 'firstYearRet') {
        this.inRetEarningForm.controls['firstYearRet'].patchValue('');
      }
      if (scenario == 'firstYearSpouseRet') {
        this.inRetSpouseEarningForm.controls['firstYearRet'].patchValue('');
      }

      if (scenario == 'currentIncome') {
        this.incomeForm.controls['currentIncome'].patchValue('');
      }
      if (scenario == 'pia') {
        this.incomeForm.controls['pia'].patchValue('');
      }
      if (scenario == 'knownBenefitClaiming') {
        this.incomeForm.controls['pia'].clearValidators();
        this.incomeForm.controls['yearOfStatement'].clearValidators();
        this.incomeForm.controls['knownBenefitClaiming'].setValidators(Validators.required);
        this.incomeForm.controls['knownBenefitClaiming'].patchValue('');
      }
      if (scenario == 'monthlyBenefits') {
        this.incomeForm.controls['monthlyBenefits'].patchValue('');
      }
      if (scenario == 'currentIncomeSpouse') {
        this.spouseIncomeForm.controls['currentIncome'].patchValue('');
      }
      if (scenario == 'piaSpouse') {
        this.spouseIncomeForm.controls['pia'].patchValue('');
      }
      if (scenario == 'knownBenefitClaimingSpouse') {
        this.spouseIncomeForm.controls['pia'].clearValidators();
        this.spouseIncomeForm.controls['knownBenefitClaiming'].setValidators(Validators.required);
        this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue('');
      }
      if (scenario == 'monthlyBenefitsSpouse') {
        this.spouseIncomeForm.controls['monthlyBenefits'].patchValue('');
      }
      if (scenario == 'houseHoldIncome') {
        this.incomeEntryForm.controls['HouseHoldIncome'].patchValue('');
      }
      if (scenario == 'yearOneRetirementIncome') {
        this.incomeEntryForm.controls['YearOneRetirementIncome'].patchValue('');
      }
      
    }

  }

  formatPercentage(event, scenario, precision = 2) {
    const key = event.keyCode || event.charCode;
    var value = event.target.value.replace('%', '');
    var values = value.split('.')
    const isNegative = value.substring(0, 1) === '-'

    if (!(/\d/.test(value)) && !isNegative) {
      value = ''
    } else {
      if(value.includes('.')) {
        values[0] = isNegative ? values[0].replace(/\D+/g, '') * -1 : values[0].replace(/\D+/g, '');
        values[1] = values[1].replace(/\D+/g, '');
        value = `${values[0]}.${values[1].substring(0, precision)}`
      } else {
        if (value < 0)
          value = value;
        else
          value = value === '-' ? '-' : value.replace(/\D+/g, '');
      }
    }
    
    var isDeleting = false;
    if (key === 8 || key === 46) {
      isDeleting = true;
    }

    if (value != '') {
      if (scenario == 'pensionInflationRate') {
        this.pensionForm.controls['pensionInflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'incomeReplacementRatio') { 
        this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'incomeInflationRate') {
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'inRetInflationRate') {
        this.additinalIncomeForm.controls['InRetInflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'magiPerc') {
        this.additinalIncomeForm.controls['MAGIPerc'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      // if (scenario == 'retAdjReductionPerc') {
      //   if (this.additinalIncomeForm.value.RetAdjReductionDollar && value) {
      //     this.additinalIncomeForm.controls['RetAdjReductionDollar'].patchValue('');
      //   }
      //   this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      // }
      if (scenario == 'retAdjReductionInflation') {
        if (this.additinalIncomeForm.value.RetAdjReductionInflation) {
          console.log('this.additinalIncomeForm.value.RetAdjReductionInflation 001', this.additinalIncomeForm.value.RetAdjReductionInflation);
          this.additinalIncomeForm.get('RetAdjYear').setValidators([Validators.required]);
        } 
        this.additinalIncomeForm.controls['RetAdjYear'].updateValueAndValidity();
        if (!this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && this.additinalIncomeForm.value.RetAdjYear) {
          console.log('here i am');
          this.additinalIncomeForm.get('RetAdjReductionInflation').setValidators([Validators.required]);
        } else {
          this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
        }
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
      }
      if (scenario == 'spousePensionInflationRate') {
        this.pensionSpouseForm.controls['pensionInflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
    } else {
      if (scenario == 'pensionInflationRate') {
        this.pensionForm.controls['pensionInflationRate'].patchValue('');
      }
      if (scenario == 'incomeReplacementRatio') {
        this.incomeEntryForm.controls['IncomeReplacementRatio'].patchValue('');
      }
      if (scenario == 'incomeInflationRate') {
        this.incomeEntryForm.controls['IncomeInflationRate'].patchValue('');
      }
      if (scenario == 'inRetInflationRate') {
        this.additinalIncomeForm.controls['InRetInflationRate'].patchValue('');
      }
      if (scenario == 'magiPerc') {
        this.additinalIncomeForm.controls['MAGIPerc'].patchValue('');
      }
      if (scenario == 'retAdjReductionPerc') {
        this.additinalIncomeForm.controls['RetAdjReductionPerc'].patchValue('');
      }
      if (scenario == 'retAdjReductionInflation') {
        this.additinalIncomeForm.controls['RetAdjReductionInflation'].patchValue('');
      }
      if (scenario == 'spousePensionInflationRate') {
        this.pensionSpouseForm.controls['pensionInflationRate'].patchValue('');
      }
      if (scenario == 'annualPensionValue') {
        this.pensionForm.controls['pensionInflationRate'].patchValue('');
      }
      if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && !this.additinalIncomeForm.value.RetAdjYear) {
        console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 03', this.additinalIncomeForm.value.RetAdjReductionDollar);
        this.clearMidRetValidation();
      }
    }

  }

  allowValue(evt, scenario) {
      let value = evt.target.value;
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      console.log('charCode', charCode);
      // remove decimal
      if (charCode == 110 || charCode == 190) {
        value = value.toString().replace('.','');
        value = Number(value);
        evt.target.value = value;
        if (scenario == 'ageMonths') {
          this.desiredClaimForm.controls['ageMonths'].setValue(value);
        }
        if (scenario == 'ageYears') {
          if(this.clientRetroClaimYearMin && this.clientRetroClaimYearMin == value){
            this.desiredClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.clientRetroClaimMonthMin),Validators.max(11)]);
          } else if(value < 70){
            this.desiredClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(0),Validators.max(11)]);            
          } else {
            this.desiredClaimForm.get("ageMonths").setValidators([Validators.min(0),Validators.max(0)]);
          }
          this.desiredClaimForm.controls['ageMonths'].updateValueAndValidity();

          this.desiredClaimForm.controls['ageYears'].setValue(value);
        }
        if (scenario == 'ageSpouseMonths' || scenario == 'ageSpouseYears') {
          if(this.spouseRetroClaimYearMin && this.spouseRetroClaimYearMin == value){
            this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.spouseRetroClaimMonthMin),Validators.max(11)]);
          } else if(value < 70){
            this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(0),Validators.max(11)]);            
          } else {
            this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.min(0),Validators.max(0)]);
          }
          this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();

          this.desiredSpouseClaimForm.controls['ageYears'].setValue(value);
        }
      }
      if (value < 70) {
        if (scenario == 'ageYears') {
          if(this.clientRetroClaimYearMin && this.clientRetroClaimYearMin == value){
            this.desiredClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.clientRetroClaimMonthMin),Validators.max(11)]);
          } else if (this.desiredClaimForm.controls['ageYears'].value == 70) {
            this.desiredClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(0),Validators.max(0)]);
          } else {
            this.desiredClaimForm.controls['ageMonths'].setValidators([Validators.min(0), Validators.max(11)]);
          }
          this.desiredClaimForm.controls['ageMonths'].updateValueAndValidity();
        } else if (scenario == 'ageMonths'){
          //NOTE: this func was built to accomodate years not months, so all months will fall in here
          if(this.desiredClaimForm.value.ageYears == 70){
            this.desiredClaimForm.get("ageMonths").setValidators([Validators.min(0),Validators.max(0)]);
            this.desiredClaimForm.controls['ageMonths'].updateValueAndValidity();
          }
        }
        if (scenario == 'ageSpouseYears') {
          //this.desiredSpouseClaimForm.controls['ageMonths'].setValidators([Validators.min(0), Validators.max(11)]);
          //this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
          if(this.spouseRetroClaimYearMin && this.spouseRetroClaimYearMin == value){
            this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(this.spouseRetroClaimMonthMin),Validators.max(this.spouseMaxClaimMonth)]);
          } else if (this.desiredClaimForm.controls['ageYears'].value == 70) {
            this.desiredClaimForm.get("ageMonths").setValidators([Validators.required, Validators.min(0),Validators.max(0)])
          } else {
            this.spouseMinClaimMonth = this.desiredSpouseClaimForm.value.ageMonths > 62 && this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob) == this.desiredSpouseClaimForm.value.ageMonths ? (this.getDOBMonth(this.client.clientProfile.Spouses[0].dob) > (new Date().getMonth() + 1)) ? (new Date().getMonth() + 1) :((new Date().getMonth() + 1) - this.getDOBMonth(this.client.clientProfile.Spouses[0].dob)) : 0;
            this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.min(this.spouseMinClaimMonth),Validators.max(this.spouseMaxClaimMonth)]);
          }
          this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
        } else if (scenario == 'ageSpouseMonths'){
          //NOTE: this func was built to accomodate years not months, so all months will fall in here
          if(this.desiredSpouseClaimForm.value.ageYears == 70){
            this.desiredSpouseClaimForm.get("ageMonths").setValidators([Validators.min(0),Validators.max(0)]);
            this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
          }
        }

      }
      if (value == 70) {
        if (scenario == 'ageYears') {
          this.desiredClaimForm.controls['ageMonths'].setValidators([Validators.min(0), Validators.max(0)]);
          this.desiredClaimForm.controls['ageMonths'].updateValueAndValidity();
        }
        if (scenario == 'ageSpouseYears') {
          this.desiredSpouseClaimForm.controls['ageMonths'].setValidators([Validators.min(0), Validators.max(0)]);
          this.desiredSpouseClaimForm.controls['ageMonths'].updateValueAndValidity();
        }
      }
  }

  getBirthdayFullYear(dob: Date){
    const startYear = new Date().getFullYear();

    var _monthOffset = 0;
    if (dob.getDate() == 1)
    {
      _monthOffset = 1;
    }

    var _yearOffset = 0;
    if ((dob.getMonth() == 0) && (_monthOffset == 1))
    {
      _yearOffset = 1;
    }

    return (startYear - this.getCurrentAgeByDOB(dob) - _yearOffset);
  }


  getAgeMonths(birthday) {
    const today = new Date();
    let months;
    birthday = new Date(birthday);
    months = (today.getFullYear() - birthday.getFullYear()) * 12;
    months -= birthday.getMonth();
    months += today.getMonth();
    return months <= 0 ? 0 : months;
  }

  getFRA(bday) {
    let yearOfBirth = bday;
    let FRA = {
      age: 0,
      month: 0,
    }

    if (yearOfBirth <= 1937) {
      FRA.age = 65;
      FRA.month = 0;
    } else if (yearOfBirth === 1938) {
      FRA.age = 65;
      FRA.month = 2;
    } else if (yearOfBirth === 1939) {
      FRA.age = 65;
      FRA.month = 4;
    } else if (yearOfBirth === 1940) {
      FRA.age = 65;
      FRA.month = 6;
    } else if (yearOfBirth === 1941) {
      FRA.age = 65;
      FRA.month = 8;
    } else if (yearOfBirth === 1942) {
      FRA.age = 65;
      FRA.month = 10;
    } else if (yearOfBirth >= 1943 && yearOfBirth <= 1954) {
      FRA.age = 66;
      FRA.month = 0;
    } else if (yearOfBirth === 1955) {
      FRA.age = 66;
      FRA.month = 2;
    } else if (yearOfBirth === 1956) {
      FRA.age = 66;
      FRA.month = 4;
    } else if (yearOfBirth === 1957) {
      FRA.age = 66;
      FRA.month = 6;
    } else if (yearOfBirth === 1958) {
      FRA.age = 66;
      FRA.month = 8;
    } else if (yearOfBirth === 1959) {
      FRA.age = 66;
      FRA.month = 10;
    } else if (yearOfBirth >= 1960) {
      FRA.age = 67;
      FRA.month = 0;
    }

    return FRA;
  }

  piaCalcData;
  spousePIACalcData;
  piaCalculator(forSpouse){
    const dialogRef = this.dialog.open(PIAComponent, {
      data: (this.client.clientProfile.PIAYears && !forSpouse) ?
      {piaData: this.piaCalcData ? this.piaCalcData : JSON.parse(this.client.clientProfile.PIAYears), client: this.client, isSpouse: forSpouse} //client
      : (forSpouse) 
      ? {piaData: this.spousePIACalcData ? this.spousePIACalcData : this.client.clientProfile.Spouses[0].PIAYears, client: this.client, isSpouse: forSpouse} //spouse
      : {piaData: this.piaCalcData ? this.piaCalcData : '', client: this.client, isSpouse: forSpouse} //first time use, not data in objects
    });

    dialogRef.afterClosed().subscribe(result =>{
      if (result && result.pia >= 0){
        if (!forSpouse) {
          this.incomeForm.get('pia').patchValue(Utils.formatToCurrency(result.pia));
          this.piaCalcData = result;
          this.substantialEarningsDetails = result;
        } else {
          this.spouseIncomeForm.get('pia').patchValue(Utils.formatToCurrency(result.pia))
          this.spousePIACalcData = result;
          this.spouseSubstantialEarningsDetails = result;
        }
      }
    });
  }

  error;
  calculatePIA(isSpouse) {
    // Typically PIA is roughly 30-40% of monthly income for average earners    
    if (isSpouse) {
      const monthlyIncome = (this.spouseIncomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.spouseIncomeForm.value.currentIncome): 0) / 12; //this.spouseIncomeForm.value.currentIncome;// this.params.currentIncome / 12;
      var newPIA = Math.round(monthlyIncome * 0.35);

      //this.spouseIncomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
      this.spouseIncomeForm.controls['pia'].patchValue(Utils.formatToCurrency(Math.min(newPIA, 4250)));
      this.spouseIncomeForm.controls['pia'].updateValueAndValidity();
    } else {
      const monthlyIncome = (this.incomeForm.value.currentIncome ? Utils.removeCurrencyFormatting(this.incomeForm.value.currentIncome): 0) / 12;// this.params.currentIncome / 12;
      var newPIA = Math.round(monthlyIncome * 0.35);

      //this.incomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
      this.incomeForm.controls['pia'].patchValue(Utils.formatToCurrency(Math.min(newPIA, 4250)));
      this.incomeForm.controls['pia'].updateValueAndValidity();
    }

    /* const calcData = !isSpouse ? this.piaCalcData : this.spousePIACalcData;
    if (!calcData || !calcData.piaYearArray) {
      this.piaCalculator(isSpouse);
      return;
    }

    var PIACalculator = {
      currentAge: Number((!isSpouse ? this.globalService.calculateAgeV2(this.client.client.DOB) : this.globalService.calculateAgeV2(this.client.clientProfile.Spouses[0].dob))),
      earningYear: !isSpouse ? this.piaCalcData.piaYearArray : this.spousePIACalcData.piaYearArray
    }

    this.globalService.getPIA(PIACalculator)
      .subscribe(
        data => {
          const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
            parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge
              || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge
              ? { invalidDate: '' }
              : null;

          if (data > 4250)
            data = 4250

          if (isSpouse) {
            this.spouseIncomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
            this.spouseIncomeForm.controls['pia'].patchValue(Utils.formatToCurrency(data));
            this.spouseIncomeForm.controls['pia'].updateValueAndValidity();
          } else {
            this.incomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
            this.incomeForm.controls['pia'].patchValue(Utils.formatToCurrency(data));
            this.incomeForm.controls['pia'].updateValueAndValidity();
          }
        },
        error => this.error = <any>error); */
  }

  substantialEarningsDetails = { startYear: 0, endYear: 0, seyTable: [], details: [], staticValue: false };
  spouseSubstantialEarningsDetails = { startYear: 0, endYear: 0, seyTable: [], details: [], staticValue: false };

  substantialEarningsCalculator(forSpouse) {
    const { startYear, endYear, details, staticValue } = !forSpouse ? JSON.parse(this.client.clientProfile.SubstantialEarningYearsDetails) || { startYear: 0, endYear: 0, details: [], staticValue: false}
      : this.client.clientProfile.Spouses[0].PIAYears || { startYear: 0, endYear: 0, details: [], staticValue: false} 

    if (this.substantialEarningsDetails && !this.substantialEarningsDetails.startYear)
      this.substantialEarningsDetails = JSON.parse(this.client.clientProfile.SubstantialEarningYearsDetails) || { startYear: 0, endYear: 0, details: [], staticValue: false }

    if (forSpouse && !this.spouseSubstantialEarningsDetails)
      this.spouseSubstantialEarningsDetails = this.client.clientProfile.Spouses[0].SubstantialEarningYearsDetails || { startYear: 0, endYear: 0, details: [], staticValue: false }

    if (forSpouse && details && !details.length)
      this.spouseSubstantialEarningsDetails = this.spousePIACalcData ? this.spousePIACalcData : this.client.clientProfile.Spouses[0].PIAYears

    if (!forSpouse && details && !details.length)
      this.substantialEarningsDetails = this.piaCalcData ? this.piaCalcData : JSON.parse(this.client.clientProfile.PIAYears)

    if (!forSpouse)
      this.clientSEY = [];
    else
      this.spouseSEY = [];

    const dialogRef = this.dialog.open(SubstantialEarningsComponent, {
      data: (this.substantialEarningsDetails && !forSpouse) ? { substantialEarningsData: this.substantialEarningsDetails, client: this.client, isSpouse: forSpouse }
        : ((this.spouseSubstantialEarningsDetails && forSpouse) ?
          { substantialEarningsData: this.spouseSubstantialEarningsDetails, client: this.client, isSpouse: forSpouse }
          : { substantialEarningsData: this.substantialEarningsDetails, client: this.client, isSpouse: forSpouse })
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.substantialEarningYears <= 20)
          result.substantialEarningYears = 20

        if (result.substantialEarningYears >= 30)
          result.substantialEarningYears = 30

        if (!forSpouse) {
          this.clientSEY = []

          if (result.seyTable.length) {
            for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.client.DOB)); i >= 62; i--) {
              this.clientSEY.push({ age: i, total: result.seyTable.length - (result.seyTable.filter(y => {
                if (y.age >= i)
                  return y
              }).length) })
            }
  
            this.clientSEY.reverse()
          }

          this.substantialEarningsDetails = { startYear: result.startYear, endYear: result.endYear, details: result.details, seyTable: result.seyTable, staticValue: false };
          this.hasEarningDetailsOrDropdown = false
          this.hasSubEarningYearsDetails = true
          this.piaCalcData = result;
          // this.pensionForm.get('substantialEarningYear').setValidators([]);
          // this.pensionForm.controls['substantialEarningYear'].updateValueAndValidity()
        } else {
          this.spouseSEY = []

          if (result.seyTable.length) {
            for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.clientProfile.Spouses[0].dob)); i >= 62; i--) {
              this.spouseSEY.push({ age: i, total: result.seyTable.length - (result.seyTable.filter(y => {
                if (y.age >= i)
                  return y
              }).length) })
            }
  
            this.spouseSEY.reverse()
          }

          this.spousePIACalcData = result;
          this.spouseSubstantialEarningsDetails = { startYear: result.startYear, endYear: result.endYear, details: result.details, seyTable: result.seyTable, staticValue: false };
          this.spouseHasEarningDetailsOrDropdown = false
          this.spouseHasSubEarningYearsDetails = true
          // this.pensionSpouseForm.get('substantialEarningYear').setValidators([]);
          // this.pensionSpouseForm.controls['substantialEarningYear'].updateValueAndValidity()
        }
      }
    });
  }

  validateKnownBenefitOrPIA(isClient, isPIA){
    
    const validateBenefits = (minAge: number, maxAge: number): ValidatorFn => control =>
        //cant be older than max
        parseInt(control.value.replace(/,/g, "").replace("$", "")) > maxAge 
        //cant be younger than min
        || parseInt(control.value.replace(/,/g, "").replace("$", "")) < minAge   
        ? {invalidDate: 'Please make sure current monthly benefit is between $' + minAge + ' and $' + maxAge + '.' }  
        : null;
    
    if(isClient){
      if(isPIA){
        this.incomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
        this.incomeForm.get("yearOfStatement").setValidators([Validators.required, Validators.min(this.currentYear - 5), Validators.max(this.currentYear)]);
        this.incomeForm.controls['knownBenefitClaiming'].patchValue('');
        this.incomeForm.get("knownBenefitClaiming").clearValidators();
      } else {
        
        this.incomeForm.get("knownBenefitClaiming").setValidators([Validators.required, validateBenefits(0, 4800)]);

        this.incomeForm.controls['pia'].patchValue('');
        this.incomeForm.get("pia").clearValidators();

        this.incomeForm.controls['yearOfStatement'].patchValue('');
        this.incomeForm.controls['yearOfStatement'].clearValidators();
      }

      this.incomeForm.controls['pia'].updateValueAndValidity();
      this.incomeForm.controls['knownBenefitClaiming'].updateValueAndValidity();
      this.incomeForm.controls['yearOfStatement'].updateValueAndValidity();
    } else {
      if(isPIA){
        this.spouseIncomeForm.get("pia").setValidators([Validators.required, validateBenefits(0, 4250)]);
        this.spouseIncomeForm.get("yearOfStatement").setValidators([Validators.required, Validators.min(this.currentYear - 5), Validators.max(this.currentYear)]);
        this.spouseIncomeForm.controls['knownBenefitClaiming'].patchValue('');
        this.spouseIncomeForm.get("knownBenefitClaiming").clearValidators();
      } else {
        
        this.spouseIncomeForm.get("knownBenefitClaiming").setValidators([Validators.required, validateBenefits(0, 4800)]);

        this.spouseIncomeForm.controls['pia'].patchValue('');
        this.spouseIncomeForm.get("pia").clearValidators();

        this.spouseIncomeForm.controls['yearOfStatement'].patchValue('');
        this.spouseIncomeForm.controls['yearOfStatement'].clearValidators();
      }

      this.spouseIncomeForm.controls['pia'].updateValueAndValidity();
      this.spouseIncomeForm.controls['knownBenefitClaiming'].updateValueAndValidity();
      this.spouseIncomeForm.controls['yearOfStatement'].updateValueAndValidity();
    }
  }

  validateDateOfClaim(event, type, isSpouse){
    var value = event.target.value;
    console.log('value', value);
    console.log('value', this.currentMonth);
    if(isSpouse){ //spouse
      if(type == 'year'){ //year check
        if(this.spouseIncomeForm.value.dateOfClaimMonth){
          if(this.spouseIncomeForm.value.dateOfClaimMonth > this.currentMonth && this.currentYear == value){
            //show error message about future values issue
            this.spouseIncomeForm.get("dateOfClaimMonth").setValidators([Validators.required, Validators.max(this.currentMonth)]);            
          } else {
            this.spouseIncomeForm.get("dateOfClaimMonth").clearValidators();
          }
          this.spouseIncomeForm.controls['dateOfClaimMonth'].updateValueAndValidity();
        }
      } else { //month check
        if(this.spouseIncomeForm.value.dateOfClaimYear){
          if(this.spouseIncomeForm.value.dateOfClaimYear == this.currentYear && value > this.currentMonth){
            //show error message about future values issue
            this.spouseIncomeForm.get("dateOfClaimMonth").setValidators([Validators.required, Validators.max(this.currentMonth)]);           
          } else {
            this.spouseIncomeForm.get("dateOfClaimMonth").clearValidators();
          }
          this.spouseIncomeForm.controls['dateOfClaimMonth'].updateValueAndValidity();
        }
      }
    } else { //client
      if(type == 'year'){ //year check
        if(this.incomeForm.value.dateOfClaimMonth){
          if(this.incomeForm.value.dateOfClaimMonth > this.currentMonth && this.currentYear == value){
            //show error message about future values issue
            this.incomeForm.get("dateOfClaimMonth").setValidators([Validators.required, Validators.max(this.currentMonth)]);            
          } else {
            this.incomeForm.get("dateOfClaimMonth").clearValidators();
          }
          this.incomeForm.controls['dateOfClaimMonth'].updateValueAndValidity();
        }
      } else { //month check
        if(this.incomeForm.value.dateOfClaimYear){
          if(this.incomeForm.value.dateOfClaimYear == this.currentYear && value > this.currentMonth){
            //show error message about future values issue
            this.incomeForm.get("dateOfClaimMonth").setValidators([Validators.required, Validators.max(this.currentMonth)]);           
          } else {
            this.incomeForm.get("dateOfClaimMonth").clearValidators();
          }
          this.incomeForm.controls['dateOfClaimMonth'].updateValueAndValidity();
        }
      }
    }
  }

  calculateMinAge() {
    return 27;
  }

  changeYear() {
    console.log('this.additinalIncomeForm.value.RetAdjReductionInflation', this.additinalIncomeForm.value.RetAdjReductionInflation);
    console.log('this.additinalIncomeForm.value.RetAdjReductionInflation', this.additinalIncomeForm.value.RetAdjReductionDollar);
    console.log('this.additinalIncomeForm.value.RetAdjReductionInflation', this.additinalIncomeForm.value.RetAdjReductionDollar);
    console.log('this.additinalIncomeForm.value.RetAdjYear', this.additinalIncomeForm.value.RetAdjYear);
    if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && this.additinalIncomeForm.value.RetAdjYear) {
      console.log('here i am');
      this.additinalIncomeForm.get('RetAdjReductionInflation').setValidators([Validators.required]);
    } 
    // else {
    //   this.additinalIncomeForm.get('RetAdjReductionInflation').clearValidators();
    // }
    // this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
    if (!this.additinalIncomeForm.value.RetAdjReductionInflation && !this.additinalIncomeForm.value.RetAdjReductionDollar && !this.additinalIncomeForm.value.RetAdjReductionPerc && !this.additinalIncomeForm.value.RetAdjYear) {
      console.log('this.additinalIncomeForm.value.RetAdjReductionDollar 03', this.additinalIncomeForm.value.RetAdjReductionDollar);
      this.clearMidRetValidation();
    }
    this.additinalIncomeForm.controls['RetAdjReductionInflation'].updateValueAndValidity();
    this.additinalIncomeForm.controls['setYearAfterSpouseLE'].patchValue(false);
    this.boolSetYearAfterSpouse = false
  }

  onDateChange() {
    this.isClientSixtyPlusAtMarriage = this.calculateAgeAtMarriage(this.client.client.DOB, this.sixtyPlusForm.value.dateOfMarriage) >= 60 ? true : false;
    if (this.isLegalMarried) {
      this.isSpouseSixtyPlusAtMarriage = this.calculateAgeAtMarriage(this.client.clientProfile.Spouses[0].dob, this.sixtyPlusForm.value.dateOfMarriage) >= 60 ? true : false;
    }
  }
  
  toggleSEYSelection(detailsSelected) {
    if (this.hasEarningDetailsOrDropdown == null)
      this.hasEarningDetailsOrDropdown = detailsSelected

    this.clientSEY = []

    if (detailsSelected) {
      let details = this.substantialEarningsDetails ? this.substantialEarningsDetails.seyTable : null;
      this.hasEarningDetailsOrDropdown = false

      if (details && details.length) {
        // this.pensionForm.get('substantialEarningYear').setValidators([]);
        // this.pensionForm.controls['substantialEarningYear'].updateValueAndValidity()
      }

      let piaYears = JSON.parse(this.client.clientProfile.PIAYears)

      if (!details && piaYears)
        details = piaYears.seyTable
      else if (details)
        this.substantialEarningsDetails.staticValue = false;

      this.pensionForm.get('substantialEarningYear').patchValue('')

      if (details && details.length) {
        for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.client.DOB)); i >= 62; i--) {
          this.clientSEY.push({
            age: i, total: details.length - (details.filter(y => {
              if (y.age >= i)
              return y
            }).length)
          })
        }
  
        this.hasSubEarningYearsDetails = true
        this.clientSEY.reverse()
      }
      
      if (piaYears) { 
        piaYears.staticValue = false;
        piaYears.substantialEarningYears = piaYears.details.length
        this.substantialEarningsDetails = piaYears
        this.client.clientProfile.PIAYears = JSON.stringify(piaYears)
        this.client.clientProfile.SubstantialEarningYears = piaYears.details.length
      }

      if (details == undefined || details == null) {
        // this.pensionForm.get('substantialEarningYear').setValidators([Validators.required]);
        // this.pensionForm.controls['substantialEarningYear'].updateValueAndValidity()
      }
    } else {
      this.hasEarningDetailsOrDropdown = true
      let piaYears = JSON.parse(this.client.clientProfile.PIAYears)

      // this.pensionForm.get('substantialEarningYear').setValidators([Validators.required]);
      // this.pensionForm.controls['substantialEarningYear'].updateValueAndValidity()

      if (this.substantialEarningsDetails)
        this.substantialEarningsDetails.staticValue = this.hasEarningDetailsOrDropdown

      for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.client.DOB)); i >= 62; i--) {
        this.clientSEY.push({
          age: i, total: this.pensionForm.get('substantialEarningYear').value
        })
      }

      this.clientSEY.reverse()

      if (piaYears) {
        piaYears.staticValue = true;
        piaYears.substantialEarningYears = this.pensionForm.get('substantialEarningYear').value;
        this.substantialEarningsDetails = piaYears
        this.client.clientProfile.PIAYears = JSON.stringify(piaYears)
        this.client.clientProfile.SubstantialEarningYears = this.pensionForm.get('substantialEarningYear').value
      }
    }
  }

  toggleSpouseSEYSelection(detailsSelected) {
    if (this.spouseHasEarningDetailsOrDropdown == null)
      this.spouseHasEarningDetailsOrDropdown = detailsSelected

    this.spouseSEY = []

    if (detailsSelected) {
      let details = this.spouseSubstantialEarningsDetails ? this.spouseSubstantialEarningsDetails.seyTable : null;
      this.spouseHasEarningDetailsOrDropdown = false

      if (details && details.length) {
        // this.pensionSpouseForm.get('substantialEarningYear').setValidators([]);
        // this.pensionSpouseForm.controls['substantialEarningYear'].updateValueAndValidity()
      }

      let piaYears = this.client.clientProfile.Spouses[0].PIAYears
      if (typeof piaYears == 'string')
        piaYears = JSON.parse(piaYears)

      if (!details && piaYears)
        details = piaYears.seyTable
      else if (details)
        this.spouseSubstantialEarningsDetails.staticValue = false;

      this.pensionSpouseForm.get('substantialEarningYear').patchValue('')

      if (details && details.length) {
        for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.clientProfile.Spouses[0].dob)); i >= 62; i--) {
          this.spouseSEY.push({
            age: i, total: details.length - (details.filter(y => {
              if (y.age >= i)
              return y
            }).length)
          })
        }
  
        this.spouseHasSubEarningYearsDetails = true
        this.spouseSEY.reverse()
      }
      
      if (piaYears) { 
        piaYears.staticValue = false;
        piaYears.substantialEarningYears = piaYears.details.length
        this.spouseSubstantialEarningsDetails = piaYears
        this.client.clientProfile.Spouses[0].PIAYears = piaYears
        this.client.clientProfile.Spouses[0].substantialEarningYear = piaYears.details.length
      }

      if (details == undefined || details == null) {
        // this.pensionSpouseForm.get('substantialEarningYear').setValidators([Validators.required]);
        // this.pensionSpouseForm.controls['substantialEarningYear'].updateValueAndValidity()
      }
    } else {
      this.spouseHasEarningDetailsOrDropdown = true
      let piaYears = this.client.clientProfile.Spouses[0].PIAYears
      if (typeof piaYears == 'string')
        piaYears = JSON.parse(piaYears)

      // this.pensionSpouseForm.get('substantialEarningYear').setValidators([Validators.required]);
      // this.pensionSpouseForm.controls['substantialEarningYear'].updateValueAndValidity()

      if (this.spouseSubstantialEarningsDetails) {
        this.spouseSubstantialEarningsDetails.staticValue = this.spouseHasEarningDetailsOrDropdown
      }

      for (var i = Math.max(70, this.getCurrentAgeByDOB(this.client.clientProfile.Spouses[0].dob)); i >= 62; i--) {
        this.spouseSEY.push({
          age: i, total: this.pensionSpouseForm.get('substantialEarningYear').value
        })
      }

      this.spouseSEY.reverse()

      if (piaYears) {
        piaYears.staticValue = true;
        piaYears.substantialEarningYears = this.pensionSpouseForm.get('substantialEarningYear').value;
        this.spouseSubstantialEarningsDetails = piaYears
        this.client.clientProfile.Spouses[0].PIAYears = piaYears
        this.client.clientProfile.Spouses[0].substantialEarningYear = this.pensionSpouseForm.get('substantialEarningYear').value;
      }
    }
  }
}
